// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { BiImport } from "react-icons/bi";
// import { CiSearch } from "react-icons/ci";
// import { FaFilter } from "react-icons/fa";
// import { FaEye } from "react-icons/fa";
// import partiesData from '../data/party';
// import stocksData from '../data/stock';
// import updatestocksApi from '../data/stockhistory';
// import settingapi from '../data/setting';
// import { PiNutLight } from 'react-icons/pi';
// import axios from 'axios';



// // --- add for router ---
// import { useLocation } from "react-router-dom";




// const Tooltip = ({ children, text }: { children: React.ReactNode, text: string }) => {
//   return (
//     <div className="group relative flex flex-col items-center inline-block">
//       {children}
//       <div className="absolute bottom-full mb-2 hidden group-hover:flex flex-col items-center z-50">
//         <div className="relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-gray-800 shadow-lg rounded-md w-48 text-center">
//           {text}
//         </div>
//         <div className="w-3 h-3 -mt-2 rotate-45 bg-gray-800"></div>
//       </div>
//     </div>
//   );
// };

// // --- The rest is unchanged ---
// // --- Dynamic AKK Balance Sheet Data Builder (MATCHING IMAGE FORMAT) ---
// /**
//  * Example output shape:
//  * {
//  *   liabilities: [
//  *     {
//  *       group: "Capital Account",
//  *       items: [
//  *         { label: "AKK CAP OLD SHARES(9.21.22)", amount: "27,25,547.52" },
//  *         { label: "AKK CAPITAL(27.07.21)", amount: "12,07,245.25" },
//  *         { label: "Interest On Investment", amount: "39,97,449.15" }
//  *       ],
//  *       subtotal: "1,69,89,163.23"
//  *     }, ...
//  *   ],
//  *   liabTotal: "2,08,56,570.30",
//  *   assets: [
//  *     ...
//  *   ],
//  *   assetTotal: "2,08,56,570.30",
//  *   settings: { ...meta info like company, period, etc }
//  * }
//  */
// export function buildAkkBalanceSheet({
//   capitalOldShares,
//   capital,
//   interestOnInvestment,
//   profitAndLoss,
//   sundryCreditors,
//   closingStock,
//   company = "AKK NEW SHARES",
//   location = "Jaipur",
//   period = "1-Apr-2023 to 31-Dec-2025",
//   asAt = "31-Dec-2025"
// }: {
//   capitalOldShares: number,
//   capital: number,
//   interestOnInvestment: number,
//   profitAndLoss: number,
//   sundryCreditors: number,
//   closingStock: number,
//   company?: string,
//   location?: string,
//   period?: string,
//   asAt?: string
// }) {
//   function fmt(num: number) {
//     return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//   }
//   const capitalAccountSubtotal = capitalOldShares + capital + interestOnInvestment;
//   const profitAndLossLabel = profitAndLoss < 0
//     ? `(${fmt(Math.abs(profitAndLoss))})`
//     : fmt(profitAndLoss);

//   const liabilities = [
//     {
//       group: "Capital Account",
//       items: [
//         { label: "AKK CAP OLD SHARES(9.21.22)", amount: fmt(capitalOldShares) },
//         { label: "AKK CAPITAL(27.07.21)", amount: fmt(capital) },
//         { label: "Interest On Investment", amount: fmt(interestOnInvestment) },
//       ],
//       subtotal: fmt(capitalAccountSubtotal)
//     },
//     {
//       group: "Loans (Liability)",
//       items: [],
//       subtotal: "" // No loans shown in image (empty)
//     },
//     {
//       group: "Profit & Loss A/c",
//       items: [
//         { label: "Opening Balance", amount: "" },
//         { label: "Current Period", amount: profitAndLossLabel }
//       ],
//       subtotal: fmt(Math.abs(profitAndLoss))
//     }
//   ];
//   // Total is sum of subtotal Capital Account + Profit & Loss A/c (loans empty)
//   const liabTotal = fmt(capitalAccountSubtotal + Math.abs(profitAndLoss));

//   // --- Assets (RIGHT section from image) ---
//   const assets = [
//     {
//       group: "Current Liabilities",
//       items: [
//         { label: "Sundry Creditors", amount: fmt(sundryCreditors) }
//       ],
//       subtotal: fmt(sundryCreditors)
//     },
//     {
//       group: "Investments",
//       items: [],
//       subtotal: "" // None as per image
//     },
//     {
//       group: "Current Assets",
//       items: [
//         { label: "Closing Stock", amount: fmt(closingStock) }
//       ],
//       subtotal: fmt(closingStock)
//     }
//   ];
//   const assetTotal = fmt(sundryCreditors + closingStock);

//   return {
//     settings: {
//       company,
//       location,
//       period,
//       asAt,
//     },
//     liabilities,
//     liabTotal,
//     assets,
//     assetTotal,
//   };
// }

// type StockCategoryObj = {
//   id: number;
//   stock_name: string;
//   category: string;
//   unit: string;
//   total_amount: string;
//   indirect_charges: string;
//   perUnitCharge: string;
//   investment_type: string;
// };

// type WithdrawalRecord = {
//   id: number;
//   party_id: number;
//   amount: number;
//   date: string;
//   catrgories: string;
// };

// type SellStockRecord = {
//   id: number;
//   party_id: number;
//   category: string;
//   stock_id: string;
//   stock_name: string;
//   sell_units: string;
//   sell_amount: string;
//   indirect_charges: string;
//   date: string;
//   catrgories: string;
// };

// interface Party {
//   id: number;
//   date: string;
//   name: string;
//   number: string;
//   contact_person_name: string;
//   contact_person_number: string;
//   categories: string[];
//   total_amount?: number | string;
// }

// type PartyStockDBType = {
//   id: number | string;
//   party_id: number | string;
//   categories: string | StockCategoryObj[];
//   date?: string;
//   date_of_purchase?: string;
// };

// type StockCurrentAmountRecord = {
//   id: number;
//   stock_id: number;
//   cat_id: number;
//   current_price: number | string;
//   current_price_date: string;
//   sundry_creditors?: number;
// };
// interface IndexPriceRecord {
//   id: number; // for server-side id, if available
//   niftyPrice?: string;
//   sensexPrice?: string;
//   date: string; // ISO string e.g. 2024-06-13
// }


// function parseCategoriesForDb(categories: string | StockCategoryObj[]): StockCategoryObj[] {
//   if (Array.isArray(categories)) return categories as StockCategoryObj[];
//   if (typeof categories === 'string') {
//     try {
//       const value = categories.trim();
//       if (value.startsWith('[')) {
//         const arr = JSON.parse(value);
//         if (Array.isArray(arr)) return arr;
//         return [arr];
//       }
//     } catch { }
//   }
//   return [];
// }

// function getAllCurrentAmountsFor(
//   stockId: number | string,
//   catId: number | string,
//   records: StockCurrentAmountRecord[],
//   dateFrom?: string,
//   dateTo?: string
// ) {
//   if (!stockId || !catId) return [];
//   return records
//     .filter(record =>
//       String(record.stock_id) === String(stockId) &&
//       String(record.cat_id) === String(catId) &&
//       (!dateFrom || new Date(record.current_price_date) >= new Date(dateFrom)) &&
//       (!dateTo   || new Date(record.current_price_date) <= new Date(dateTo))
//     )
//     .sort((a, b) => (a.current_price_date < b.current_price_date ? 1 : -1));
// }

// function getLatestCurrentAmountFor(
//   stockId: number | string,
//   catId: number | string,
//   records: StockCurrentAmountRecord[],
//   dateFrom?: string,
//   dateTo?: string
// ) {
//   const all = getAllCurrentAmountsFor(stockId, catId, records, dateFrom, dateTo);
  

//   if (all.length === 0) return null;
//   return all[0];
// }

// function downloadCSV(csv: string, filename: string) {
//   const blob = new Blob([csv], { type: 'text/csv' });
//   const url = window.URL.createObjectURL(blob);
//   const a = document.createElement('a');
//   a.href = url;
//   a.download = filename;
//   a.click();
//   window.URL.revokeObjectURL(url);
// }

// function getUniqueValues(array: any[], field: string): string[] {
//   const set = new Set<string>();
//   array.forEach(item => {
//     let value = item[field];
//     if (value === undefined || value === null) return;
//     set.add(String(value));
//   });
//   return Array.from(set).filter(v => v !== '');
// }

// const columnFilters = [
//   { key: 'party_name', label: 'Party Name', type: 'string' },
// ];

// type ModalSheetView = "overall" | "final" | "balance" | "QTLY Performance";

// function formatPeriod(dateFrom?: string, dateTo?: string) {
//   if (!dateFrom && !dateTo) return "All dates";
//   if (dateFrom && dateTo) {
//     return `${new Date(dateFrom).toLocaleDateString()} to ${new Date(dateTo).toLocaleDateString()}`;
//   }
//   if (dateFrom) return `From ${new Date(dateFrom).toLocaleDateString()}`;
//   if (dateTo) return `Up to ${new Date(dateTo).toLocaleDateString()}`;
//   return '';
// }
// function getMonthDiff(partyDate: string | Date | undefined, to: string | Date | undefined) {

//   if (!partyDate) return 1;
//   const start = typeof partyDate === "string" ? new Date(partyDate) : partyDate;
//   const end = to ? (typeof to === "string" ? new Date(to) : to) : new Date();

//   if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) {
//     return 1;
//   }
//   let months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
//   if (end.getDate() >= start.getDate()) {
//     months += 1;
//   }
//   return months < 1 ? 1 : months;
// }

// // Add API fetch for sellstocks
// async function fetchSellStocks() {
//   try {
//     const res = await fetch("https://stockaadvikbackend.aadviktech.com/auth/sellstocks");
//     if (!res.ok) return [];
//     const data = await res.json();
//     return Array.isArray(data) ? data : [];
//   } catch {
//     return [];
//   }
// }

// // Fetch Withdrawals
// async function fetchWithdrawals(): Promise<WithdrawalRecord[]> {
//   debugger;
//   try {
//     const res = await fetch("https://stockaadvikbackend.aadviktech.com/auth/withdrawals");
//     if (!res.ok) return [];
//     const data = await res.json();
//     return Array.isArray(data) ? data : [];
//   } catch {
//     return [];
//   }
// }
//  // --- Load Calculation Formulas Config from LocalStorage ---
//   // At mount, try to load the calculationsFormulasConfigV1 from localStorage and keep in state
//   type CalculationFormulaConfig = {
//     purchaseShare: true,
//     purchaseDirect: true,
//     purchaseOperator: "+",
//     grossSaleStock: true,
//     grossSaleStockOp: "+",
//     grossSaleCharges: true,
//     grossSaleChargesOp: "+",
//     grossPurchasedStockSale: false,
//     grossPurchasedStockSaleOp: "+",
//     grossPurchaseIndirect: false,
//     grossInterestCharges: false,
//     gpcGrossProfit: true,
//     gpcOperator: "-",
//     gpcSaleAccount: true,
//     indirectCharges: true,
//     indirectChargesOp: "+",
//     indInterestCharges: true,
//     indPurchaseIndirect: true,
//     indPurchasedStockSale: true,
//     indPurchasedStockSaleOp: "+",
//     netGrossProfit: true,
//     netIndirectExpenses: true,
//     netPLOperator: "-",
//     // Allow unknown fallback fields
//     [key: string]: any
//   };
// // (All types and helpers unchanged up to main component)

// function CustomBalance() {
//   // ... all hooks/logic state declarations unchanged ...
//   const [interestDateTo, setInterestDateTo] = useState<string>('');

//   const [parties, setParties] = useState<Party[]>([]);
//   const [stocks, setStocks] = useState<PartyStockDBType[]>([]);
//   const [updates, setUpdates] = useState<StockCurrentAmountRecord[]>([]);
//   const [search, setSearch] = useState('');
//   const [page, setPage] = useState(1);
//   const perPage = 10;
//   const [openFilterDropdown, setOpenFilterDropdown] = useState<string | null>(null);
//   const [uniqueColumnValues, setUniqueColumnValues] = useState<{ [key: string]: string[] }>({});
//   const [filters, setFilters] = useState<{ [key: string]: string | null }>({});

//   // Outsource closing amount: have per-party mapping (object), not a single global
//   const [partyClosingAmounts, setPartyClosingAmounts] = useState<Record<string, number>>({}); // { partyId: closingAmt }
//   const [showClosingAmountModal, setShowClosingAmountModal] = useState<{ open: boolean, partyId?: string }>({ open: false });
//   const [showLossAmountModal, setShowLossAmountModal] = useState<{ open: boolean, partyId?: string }>({ open: false });
//   // Loss and profit amounts are Record<string, number> (partyId -> value)
//   const [partyLossAmounts, setPartyLossAmounts] = useState<Record<string, number>>({}); // { partyId: loss }
//   const [partyProfitAmounts, setPartyProfitAmounts] = useState<Record<string, number>>({}); // { partyId: profit }
//   const [partyCommisionAmounts, setPartyCommisionAmounts] = useState<Record<string, number>>({}); // { partyId: closingAmt }
//   const [partyExpensesAmounts, setPartyExpensesAmounts] = useState<Record<string, number>>({}); // { partyId: closingAmt }

//   const [showProfitAmountModal, setShowProfitAmountModal] = useState<{ open: boolean, partyId?: string }>({ open: false });
//   const [showCommisionAndExpensesAmountModal, setShowCommisionAndExpensesAmountModal] = useState<{ open: boolean, partyId?: string }>({ open: false });
//   const [showExpensesAmountModal, setShowExpensesAmountModal] = useState<{ open: boolean, partyId?: string }>({ open: false });
//   const [closingAmountInput, setClosingAmountInput] = useState(""); // for modal input
//   const [lossAmountInput, setLossAmountInput] = useState(""); // for modal input
//   const [profitAmountInput, setProfitAmountInput] = useState(""); // for modal input
//   const [commisionAmountInput, setCommisionAmountInput] = useState(""); // for modal input

//   const [showFilterPanel, setShowFilterPanel] = useState(false);

//   // Date filter state
//   const [dateFrom, setDateFrom] = useState<string>('');
//   const [dateTo, setDateTo] = useState<string>('');

//   // Multi-modal support
//   const [selectedParty, setSelectedParty] = useState<Party | null>(null);
//   const [showPartyModal, setShowPartyModal] = useState(false);
//   const [partyModalSheet, setPartyModalSheet] = useState<ModalSheetView>("overall");

//   // For file import
//   const fileInputRef = useRef<HTMLInputElement>(null);

//   // Interest percentage from Settings API (default 3%)
//   const [interestPercentage, setInterestPercentage] = useState(3);

//   const [indexPriceHistory, setIndexPriceHistory] = useState<IndexPriceRecord[]>([]);

//   // Sell Stocks from API state
//   const [sellStocks, setSellStocks] = useState<SellStockRecord[]>([]);

//   // Withdrawals state
//   const [withdrawals, setWithdrawals] = useState<WithdrawalRecord[]>([]);

//   const [globalQTLY, setGlobalQtly] = useState(false);

//   const [farmForm, setFarmForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     address: "",
//   });
//   const [savedFarmForm, setSavedFarmForm] = useState<any>(null);

//   // --- ADD FOR PARTY ID FROM URL ---
//   const location = useLocation();
//   const [partyIdFromUrl, setPartyIdFromUrl] = useState<string | null>(null);

 

//   const [calculationFormulasConfig, setCalculationFormulasConfig] = useState<CalculationFormulaConfig | null>(null);

//   // State for multi-entry amounts
// const [partyClosingRecords, setPartyClosingRecords] = useState<Record<string, {amount: string, date: string}[]>>({});
// const [partyLossRecords, setPartyLossRecords] = useState<Record<string, {amount: string, date: string}[]>>({});
// const [partyProfitRecords, setPartyProfitRecords] = useState<Record<string, {amount: string, date: string}[]>>({});
// const [partyCommisionRecords, setPartyCommisionRecords] = useState<Record<string, {amount: string, date: string}[]>>({});
// const [partyExpnsesRecords, setPartyEspnesRecords] = useState<Record<string, {amount: string, date: string}[]>>({});
// const [partySaleRecords, setPartySaleRecords] = useState<Record<string, any[]>>({});
// // Generic Modal State
// const [entryModal, setEntryModal] = useState<{
//   isOpen: boolean, 
//   type: 'Closing' | 'Loss' | 'Profit' | 'Commission' | 'Sale' | 'Expenses',
//   partyId: string
// }>({ isOpen: false, type: 'Closing', partyId: '' });

// const handleSaveRecords = (type: string, partyId: string, entries: any[]) => {
//   // 1. Update the correct state based on the type
//   const setters: Record<string, Function> = {
//     'Closing': setPartyClosingRecords,
//     'Loss': setPartyLossRecords,
//     'Profit': setPartyProfitRecords,
//     'Commission': setPartyCommisionRecords,
//     'Expenses': setPartyEspnesRecords
//   };

//   if (setters[type]) {
//     debugger;
//     setters[type]((prev: any) => {
    
//       const updated = { ...prev, [partyId]: entries };
//       // 2. Persist to LocalStorage
//       localStorage.setItem(`saved_party_${type}_data`, JSON.stringify(updated));
//       return updated;
//     });
//   }

//   setEntryModal({ ...entryModal, isOpen: false });
// };

// // Add a useEffect to load this data from LocalStorage when the app starts
// useEffect(() => {
//   ['Closing', 'Loss', 'Profit', 'Commission', 'Expenses'].forEach(type => {
//     const saved = localStorage.getItem(`saved_party_${type}_data`);
//     if (saved) {
//       const parsed = JSON.parse(saved);
//       if (type === 'Closing') setPartyClosingRecords(parsed);
//       if (type === 'Loss') setPartyLossRecords(parsed);
//       if (type === 'Profit') setPartyProfitRecords(parsed);
//       if (type === 'Commission') setPartyCommisionRecords(parsed);
//       if (type === 'Expenses') setPartyEspnesRecords(parsed);
//     }
//   });
// }, []);

// const MultiEntryForm = ({ type, partyId, records, onSave, onClose, parties }: any) => {
//   const [localEntries, setLocalEntries] = useState(records[partyId] || [{ amount: "", date: new Date().toISOString().split('T')[0] }]);
//   const partyName = parties.find((p: any) => String(p.id) === String(partyId))?.name;

//   const addRow = () => setLocalEntries([...localEntries, { amount: "", date: "" }]);
//   const updateRow = (index: number, field: string, value: string) => {
//     const newEntries = [...localEntries];
//     newEntries[index][field] = value;
//     setLocalEntries(newEntries);
//   };

//   return (
//     <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
//       <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden border border-gray-200">
//         <div className="bg-[#6742c7] p-4 text-white flex justify-between items-center">
//           <h3 className="font-bold text-lg">{type} Entries: {partyName}</h3>
//           <button onClick={onClose} className="text-2xl">&times;</button>
//         </div>
//         <div className="p-6 max-h-[60vh] overflow-y-auto">
//           {localEntries.map((entry: any, idx: number) => (
//             <div key={idx} className="flex gap-3 mb-4 items-end border-b pb-4 last:border-0">
//               <div className="flex-1">
//                 <label className="text-xs font-bold text-gray-500 block mb-1">Date</label>
//                 <input 
//                   type="date" 
//                   value={entry.date} 
//                   onChange={(e) => updateRow(idx, 'date', e.target.value)}
//                   className="w-full border rounded-lg p-2 text-sm"
//                 />
//               </div>
//               <div className="flex-1">
//                 <label className="text-xs font-bold text-gray-500 block mb-1">Amount (₹)</label>
//                 <input 
//                   type="number" 
//                   value={entry.amount} 
//                   placeholder="0.00"
//                   onChange={(e) => updateRow(idx, 'amount', e.target.value)}
//                   className="w-full border rounded-lg p-2 text-sm"
//                 />
//               </div>
//               <button
//                 onClick={() => setLocalEntries(localEntries.filter((_: any, i: number) => i !== idx))}
//                 className="text-red-500 p-2"
//                 title="Remove this entry"
//               >
//                 🗑️
//               </button>
//             </div>
//           ))}
//           <button onClick={addRow} className="w-full py-2 border-2 border-dashed border-[#6742c7] text-[#6742c7] rounded-lg font-bold hover:bg-purple-50">+ Add Another Entry</button>
//         </div>
//         <div className="p-4 bg-gray-50 flex gap-3 justify-end">
//           <button onClick={onClose} className="px-4 py-2 text-gray-600 font-semibold">Cancel</button>
//           <button onClick={() => handleSaveRecords(entryModal.type, entryModal.partyId, localEntries)} className="px-6 py-2 bg-[#6742c7] text-white rounded-lg font-bold shadow-lg">Save All Records</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const SaleEntryForm = ({ partyId, stocks, records, onSave, onClose, parties }: any) => {
//   // 1. Get only the stocks belonging to this party
//   const partyOwnedStocks = stocks
//     .filter((s: any) => String(s.party_id) === String(partyId))
//     .flatMap((s: any) => parseCategoriesForDb(s.categories).map(cat => ({
//       ...cat,
//       originalStockId: s.id // Keep reference to the DB row ID
//     })));

//   const partyName = parties.find((p: any) => String(p.id) === String(partyId))?.name;

//   // 2. Initialize with OLD DATA if it exists
//   const [localSales, setLocalSales] = useState<any[]>(() => {
//     const existing = records[partyId];
//     return existing && existing.length > 0 
//       ? [...existing] 
//       : [{ stockName: "", category: "", amount: "", units: "", date: new Date().toISOString().split('T')[0] }];
//   });

//   const addRow = () => {
//     setLocalSales([...localSales, { stockName: "", category: "", amount: "", units: "", date: new Date().toISOString().split('T')[0] }]);
//   };

//   const updateRow = (index: number, field: string, value: string) => {
//     const newSales = [...localSales];
//     // If selecting a stock, we auto-fill the category
//     if (field === "stockName") {
//       const selectedStock = partyOwnedStocks.find((s:any) => s.stock_name === value);
//       newSales[index].category = selectedStock?.category || "";
//     }
//     newSales[index][field] = value;
//     setLocalSales(newSales);
//   };

//   return (
//     <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
//       <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl overflow-hidden border border-gray-200">
        
//         {/* Header */}
//         <div className="bg-[#ae793c] p-5 text-white flex justify-between items-center">
//           <div>
//             <h3 className="font-bold text-xl">Sale Stock Management</h3>
//             <p className="text-orange-100 text-sm opacity-90">Recording sales for {partyName}</p>
//           </div>
//           <button onClick={onClose} className="text-2xl hover:text-gray-200">&times;</button>
//         </div>

//         {/* Body */}
//         <div className="p-6 max-h-[65vh] overflow-y-auto bg-orange-50/30">
//           <div className="space-y-4">
//             {localSales.map((sale, idx) => (
//               <div key={idx} className="grid grid-cols-12 gap-3 p-4 bg-white rounded-xl shadow-sm border border-orange-100 items-end">
                
//                 {/* Stock Selector */}
//                 <div className="col-span-4">
//                   <label className="text-[10px] font-extrabold text-gray-400 uppercase mb-1 block">Select Stock</label>
//                   <select 
//                     value={sale.stockName}
//                     onChange={(e) => updateRow(idx, 'stockName', e.target.value)}
//                     className="w-full border rounded-lg p-2 text-sm bg-gray-50 outline-none focus:ring-2 focus:ring-orange-400"
//                   >
//                     <option value="">-- Choose Stock --</option>
//                     {partyOwnedStocks.map((s: any, i: number) => (
//                       <option key={i} value={s.stock_name}>{s.stock_name} ({s.category})</option>
//                     ))}
//                   </select>
//                 </div>

//                 {/* Date */}
//                 <div className="col-span-3">
//                   <label className="text-[10px] font-extrabold text-gray-400 uppercase mb-1 block">Date</label>
//                   <input 
//                     type="date" 
//                     value={sale.date} 
//                     onChange={(e) => updateRow(idx, 'date', e.target.value)}
//                     className="w-full border rounded-lg p-2 text-sm outline-none focus:ring-2 focus:ring-orange-400"
//                   />
//                 </div>

//                 {/* Units */}
//                 <div className="col-span-2">
//                   <label className="text-[10px] font-extrabold text-gray-400 uppercase mb-1 block">Units</label>
//                   <input 
//                     type="number" 
//                     placeholder="Qty"
//                     value={sale.units} 
//                     onChange={(e) => updateRow(idx, 'units', e.target.value)}
//                     className="w-full border rounded-lg p-2 text-sm outline-none focus:ring-2 focus:ring-orange-400"
//                   />
//                 </div>

//                 {/* Amount */}
//                 <div className="col-span-2">
//                   <label className="text-[10px] font-extrabold text-gray-400 uppercase mb-1 block">Total ₹</label>
//                   <input 
//                     type="number" 
//                     placeholder="Amount"
//                     value={sale.amount} 
//                     onChange={(e) => updateRow(idx, 'amount', e.target.value)}
//                     className="w-full border rounded-lg p-2 text-sm font-bold text-green-700 outline-none focus:ring-2 focus:ring-orange-400"
//                   />
//                 </div>

//                 {/* Delete */}
//                 <div className="col-span-1 text-right">
//                   <button 
//                     onClick={() => setLocalSales(localSales.filter((_, i) => i !== idx))}
//                     className="text-red-400 hover:text-red-600 p-2"
//                   >
//                     🗑️
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button 
//             onClick={addRow} 
//             className="mt-6 w-full py-3 border-2 border-dashed border-orange-200 text-[#ae793c] rounded-xl font-bold hover:bg-orange-50 transition-all"
//           >
//             + Add Another Sale Row
//           </button>
//         </div>

//         {/* Footer */}
//         <div className="p-4 bg-white border-t flex gap-3 justify-end">
//           <button onClick={onClose} className="px-6 py-2 text-gray-500 font-bold">Cancel</button>
//           <button 
//             onClick={() => onSave("Sale", partyId, localSales.filter(s => s.stockName && s.amount))} 
//             className="px-8 py-2.5 bg-[#ae793c] text-white rounded-xl font-bold shadow-lg hover:bg-[#8e622f] transition-all"
//           >
//             Save All Sales
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };
//   // Load from localStorage on mount
//   useEffect(() => {
//     try {
//       const configRaw = localStorage.getItem('calculationsFormulasConfigV1');
//       if (configRaw) {
//         setCalculationFormulasConfig(JSON.parse(configRaw));
//       }
//     } catch (err) {
//       // ignore parse errors for now
//       setCalculationFormulasConfig(null);
//     }
//   }, []);
//   //console.log("setCalculationFormulasConfig ", calculationFormulasConfig);

//   useEffect(() => {
//     // Try something like /balance-sheet?party_id=XXX OR /balance-sheet/XXX
//     const searchParams = new URLSearchParams(location.search);
//     let pid = searchParams.get("party");
//     if(!pid) {
//       // try to match /:id (in path)
//       const match = location.pathname.match(/\/(\d+)$/);
//       if(match) pid = match[1];
//     }
//     setPartyIdFromUrl(pid);
//   }, [location]);

//   // Fetch interest percentage setting from API on mount
//   useEffect(() => {
//     const fetchSettings = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API_URL}/auth/setting`);
//         const settingsArray = Array.isArray(res.data) ? res.data : [];

//         // Interest (legacy)
//         const foundInterestType = settingsArray.find(
//           (item: any) =>
//             item.meta_key === "interest_type" &&
//             (item.meta_value === "simple" || item.meta_value === "compound")
//         );
//         const foundPercentage = settingsArray.find(
//           (item: any) => item.meta_key === "percentage"
//         );
       

//         // Farm info
//         const farm = settingsArray.find((item: any) => item.meta_key === "farm");
//         if (farm) {
//           const value = typeof farm.meta_value === "string"
//             ? JSON.parse(farm.meta_value || "{}")
//             : farm.meta_value || {};
//           setFarmForm({
//             name: value.name || "",
//             email: value.email || "",
//             phone: value.phone || "",
//             address: value.address || "",
//           });
//           setSavedFarmForm(value);
//         }

//         // Index Price History (array or fallback to old behavior)
//         let history: IndexPriceRecord[] = [];
//         const priceHistorySetting = settingsArray.find((item: any) => item.meta_key === "index_prices_history");
//         if (priceHistorySetting) {
//           try {
//             const historyArray = typeof priceHistorySetting.meta_value === "string"
//               ? JSON.parse(priceHistorySetting.meta_value || "[]")
//               : priceHistorySetting.meta_value || [];
//             if (Array.isArray(historyArray)) {
//               history = historyArray
//                 .map((item, idx) => ({
//                   ...item,
//                   id: item.id ?? idx, // fallback if no id
//                   niftyPrice: item.niftyPrice,
//                   sensexPrice: item.sensexPrice,
//                   date: item.date,
//                 }))
//                 .sort((a, b) => (b.date > a.date ? 1 : -1));
//               setIndexPriceHistory(history);
//             }
//           } catch (err) {
//             setIndexPriceHistory([]);
//           }
//         } else {
//           // Fallback: legacy single price object, use as initial entry if exists
//           const indexPrice = settingsArray.find((item: any) => item.meta_key === "index_prices");
//           if (indexPrice) {
//             const value = typeof indexPrice.meta_value === "string"
//               ? JSON.parse(indexPrice.meta_value || "{}")
//               : indexPrice.meta_value || {};
//             const fakeDate = new Date().toISOString().split("T")[0];
//             const rec: IndexPriceRecord = {
//               id: 1,
//               niftyPrice: value.niftyPrice,
//               sensexPrice: value.sensexPrice,
//               date: fakeDate,
//             };
//             setIndexPriceHistory([rec]);
//           }
//         }

//       } catch (e) {
//         // setError("Failed to fetch settings.");
//       }
//     };

//     fetchSettings();
//   }, []);
//   useEffect(() => {
//     async function fetchSettingsApi() {
//       try {
//         const res = await settingapi();
//         if (Array.isArray(res)) {
//           const percentageSetting = res.find(
//             (item: any) => item.meta_key === "percentage"
//           );
//           if (percentageSetting && percentageSetting.meta_value !== undefined) {
//             const percentValue = parseFloat(percentageSetting.meta_value);
//             if (!isNaN(percentValue)) {
//               setInterestPercentage(percentValue);
//             }
//           }
//         }
//       } catch {}
//     }
//     fetchSettingsApi();
//   }, []);

//   // Fetch all parties
//   useEffect(() => {
//     async function fetchPartiesApi() {
//       try {
//         const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/addparty`, {
//           method: "GET",
//           headers: { "Content-Type": "application/json" },
//         });
//         if (!res.ok) return setParties([]);
//         const data = await res.json();
//         if (Array.isArray(data)) {
//           setParties(
//             data.map((item: any) => ({
//               ...item,
//               categories: Array.isArray(item.categories)
//                 ? item.categories
//                 : (typeof item.categories === "string"
//                   ? (
//                     item.categories.trim().startsWith("[")
//                       ? JSON.parse(item.categories)
//                       : item.categories.split(",").map((c: string) => c.trim())
//                   ) : [])
//             }))
//           );
//         } else {
//           setParties([]);
//         }
//       } catch {
//         setParties([]);
//       }
//     }
//     fetchPartiesApi();
//   }, []);

//   const fetchStocks = useCallback(async () => {
//     try {
//       const res = await stocksData();
//       setStocks(Array.isArray(res) ? res : []);
//     } catch {
//       setStocks([]);
//     }
//   }, []);

//   const fetchUpdates = useCallback(async () => {
//     try {
//       const data = await updatestocksApi();
//       setUpdates(Array.isArray(data) ? data : []);
//     } catch {
//       setUpdates([]);
//     }
//   }, []);

//   // Fetch sell stocks from API on mount
//   useEffect(() => {
//     async function loadSellStocks() {
//       const sellArr = await fetchSellStocks();
//       setSellStocks(sellArr);
//     }
//     loadSellStocks();
//   }, []);

//   // Fetch withdrawals from API on mount
//   useEffect(() => {
//     async function loadWithdrawal() {
//       const withdrawalsArr = await fetchWithdrawals();

//       // Parse and normalize withdrawalsArr such that:
//       // - Each "catrgories" property (note typo from API) is parsed and objects inside are extracted for each withdrawal
//       // - Each withdrawal can have a categories property that is a parsed array of category objects

//       const normalized = (withdrawalsArr || []).map(wd => {
//         let categories: any[] = [];
//         if (wd.catrgories) {
//           try {
//             // expects string like: ["[{\"category\":\"Equity\",\"stockName\":\"IFCI LTD\",\"stockId\":2,\"amount\":\"120000\"}]"]
//             let arr = JSON.parse(wd.catrgories);
//             if (Array.isArray(arr) && arr.length > 0 && typeof arr[0] === "string") {
//               categories = JSON.parse(arr[0]);
//               if (!Array.isArray(categories)) categories = [categories];
//             }
//           } catch (e) {
//             categories = [];
//           }
//         }
//         return { ...wd, categories };
//       });

//       setWithdrawals(normalized);
//     }
//     loadWithdrawal();
//   }, []);

//   useEffect(() => {
//     fetchStocks();
//     fetchUpdates();
//   }, [fetchStocks, fetchUpdates]);

//   // Helper: in-range date
//   const isInDateRange = (dateStr: string) => {
//     if (!dateStr) return true;
//     const date = new Date(dateStr);
//     const from = dateFrom ? new Date(dateFrom) : null;
//     const to = dateTo ? new Date(dateTo) : null;
//     if (from && date < from) return false;
//     if (to && date > to) return false;
//     return true;
//   };

//   // --- Party Aggregated Rows ---
//   // Now includes dividend from stock history in update_history
//   const partyAggregatedRows = React.useMemo(() => {
//     if (!parties.length || !stocks.length) return [];
//     let result: {
//       party: Party,
//       stocks: Array<{
//         stock_name: string,
//         records: Array<{
//           category: string,
//           unit: string,
//           date_of_purchase: string,
//           opening_balance: number,
//           update_history: Array<{
//             date: string,
//             current_amount: number,
//             used: number,
//             earning: number,
//             profitAndLoss: number,
//             dividend?: number
//           }>,
//           total_purchased: number,
//           total_used: number,
//           total_earning: number,
//           total_profit_and_loss: number,
//           indirect_charges: number,
//           per_unit_charge: number
//         }>
//       }>,
//       total_purchased: number,
//       total_used: number,
//       total_earning: number,
//       total_indirect_charges: number,
//       total_interest: number;
//       total_sales_amount?: number;
//       total_sales_units?: number;
//       total_withdrawal_amount?: number;
//       withdrawals_details?: WithdrawalRecord[];
//     }[] = [];
    
//     for (const party of parties) {
//       const partyStocks = stocks.filter(stk => String(stk.party_id) === String(party.id));
//       let total_purchased = 0;
//       let total_used = 0;
//       let total_earning = 0;
//       let total_indirect_charges = 0;
//       let stock_aggregate: typeof result[0]['stocks'] = [];
//       let months = 1;
//       const end = dateTo ? new Date(dateTo) : new Date();
//       months = getMonthDiff(party.date, end);
//       let total_interest = Number(party.total_amount || 0) * (Number(interestPercentage) / 100) * Number(months);

//       // --- Sell Data ---
//       let total_sales_amount = 0;
//       let total_sales_units = 0;

//       // Gather sale stock amounts for party using sellStocks in given date range.
//       if (sellStocks && Array.isArray(sellStocks)) {
//         const filteredSellStocks = sellStocks.filter(
//           s =>
//             String(s.party_id) === String(party.id) &&
//             (!dateFrom || new Date(s.date) >= new Date(dateFrom)) &&
//             (!dateTo   || new Date(s.date) <= new Date(dateTo))
//         );
//         total_sales_amount = filteredSellStocks.reduce(
//           (sum, s) => sum + (parseFloat(s.sell_amount) || 0), 0
//         );
//         total_sales_units = filteredSellStocks.reduce(
//           (sum, s) => sum + (parseFloat(s.sell_units) || 0), 0
//         );
//       }

//       // --- Withdrawal Data ---
//       let total_withdrawal_amount = 0;
//       let withdrawals_details: WithdrawalRecord[] = [];
//       if (withdrawals && Array.isArray(withdrawals)) {
//         const filteredWithdrawals = withdrawals.filter(
//           w =>
//             String(w.party_id) === String(party.id) &&
//             (!dateFrom || new Date(w.date) >= new Date(dateFrom)) &&
//             (!dateTo   || new Date(w.date) <= new Date(dateTo))
//         );
//         total_withdrawal_amount = filteredWithdrawals.reduce(
//           (sum, w) => sum + (parseFloat(String(w.amount)) || 0), 0
//         );
//         withdrawals_details = filteredWithdrawals;
//       }

//       for (const stk of partyStocks) {
//         const cats = parseCategoriesForDb(stk.categories);
//         for (const catObj of cats) {
//           const catId = catObj.id ?? '';
//           const stock_name = catObj.stock_name;
//           const perUnitCharge = Number(catObj.perUnitCharge || 0) || 0;
//           const indirectCharges = Number(catObj.indirect_charges || 0) || 0;

//           const allHistory = getAllCurrentAmountsFor(stk.id, catId, updates, dateFrom, dateTo);
   
//           //console.log("allHistory, ", allHistory);

//           const chronHistory = [...allHistory].sort((a, b) => (a.current_price_date > b.current_price_date ? 1 : -1));
//           let opening = Number(catObj.total_amount || 0);
//           const purchaseDate = stk.date_of_purchase || stk.date || "";
//           let inDate = isInDateRange(purchaseDate);
          
//           let prevAmount = opening;
//           let records = [];
//           let totalStockUsed = 0;
//           let totalStockEarning = 0;
//           let total_profit_and_loss = 0;
          
//           if (inDate) {
//             records.push({
//               category: catObj.category,
//               unit: catObj.unit,
//               date_of_purchase: purchaseDate,
//               opening_balance: opening,
//               update_history: [],
//               total_purchased: opening,
//               total_used: 0,
//               total_earning: 0,
//               indirect_charges: indirectCharges,
//               per_unit_charge: perUnitCharge,
//               total_profit_and_loss: 0
//             });
//           }

//           // Add sundry_creditors as a field in update_history
//           let update_history: Array<{
//             date: string,
//             current_amount: number,
//             used: number,
//             earning: number,
//             profitAndLoss: number,
//             dividend?: number,
//             sundry_creditors?: number,
//           }> = [];

//           for (let i = 0; i < chronHistory.length; ++i) {
//             const rec = chronHistory[i];
//             if ((rec.sundry_creditors ?? 0) > 0) {
//               //console.log("dividend ", rec.sundry_creditors);
//             }
//             const thisAmount = Number(rec.current_price || 0);
//             const used = thisAmount - prevAmount;
//             const earning = thisAmount - (prevAmount + indirectCharges);
//             const profitAndLoss = thisAmount - (prevAmount + indirectCharges);
//             total_profit_and_loss += profitAndLoss;

//             const entry: {
//               date: string,
//               current_amount: number,
//               used: number,
//               earning: number,
//               profitAndLoss: number,
//               dividend?: number,
//               sundry_creditors?: number,
//             } = {
//               date: rec.current_price_date,
//               current_amount: thisAmount,
//               used,
//               earning,
//               profitAndLoss,
//             };

//             // Add dividend if present for backward compatibility or semantic usage
//             if (rec.sundry_creditors !== undefined && rec.sundry_creditors !== null) {
//               entry.dividend = Number(rec.sundry_creditors);
//               entry.sundry_creditors = Number(rec.sundry_creditors);
//             }

//             update_history.push(entry);

//             totalStockUsed += used;
//             totalStockEarning += earning;
//             // prevAmount = thisAmount;
//           }

//           if (inDate && records.length > 0) {
//             (records[0] as any).update_history = update_history;
//             (records[0] as any).total_used = totalStockUsed;
//             (records[0] as any).total_earning = totalStockEarning;
//             (records[0] as any).total_profit_and_loss = total_profit_and_loss;
//           }

//           if (inDate) {
//             total_purchased += opening;
//             total_purchased += indirectCharges;
//             total_indirect_charges += indirectCharges;
//           }
//           total_used += totalStockUsed;
//           total_earning += totalStockEarning;

//           let stockEntry = stock_aggregate.find(s => s.stock_name === stock_name);
//           if (!stockEntry) {
//             stock_aggregate.push({
//               stock_name,
//               records: records
//             });
//           } else {
//             stockEntry.records.push(...records);
//           }
//         }
//       }
//       total_earning = total_earning > 0 ? (total_earning - total_purchased) : 0;
//       if (stock_aggregate.length > 0) {
//         result.push({
//           party,
//           stocks: stock_aggregate,
//           total_purchased,
//           total_used,
//           total_earning,
//           total_indirect_charges,
//           total_interest,
//           total_sales_amount,
//           total_sales_units,
//           total_withdrawal_amount,
//           withdrawals_details,
//         });
//       }
//     }
//     return result;
//   }, [parties, stocks, updates, dateFrom, dateTo, interestPercentage, sellStocks, withdrawals]);

//   // --- Collect Sundry Creditors per party from updates ---
//   const partySundryCreditorsMap = React.useMemo(() => {
//     if (!updates.length || !stocks.length) return {};
//     const stockIdToParty = new Map();
//     for (const stk of stocks) {
//       stockIdToParty.set(String(stk.id), stk.party_id);
//     }
//     const partyTotals: Record<string, number> = {};
//     for (const update of updates) {
//       const party_id = stockIdToParty.get(String(update.stock_id));
//       if (!party_id) continue;
//       const inDate = (!update.current_price_date ||
//         (
//           (!dateFrom || new Date(update.current_price_date) >= new Date(dateFrom)) &&
//           (!dateTo || new Date(update.current_price_date) <= new Date(dateTo))
//         )
//       );
//       if (!inDate) continue;
//       if (typeof update.sundry_creditors !== "undefined" && !isNaN(Number(update.sundry_creditors))) {
//         if (!partyTotals[party_id]) partyTotals[party_id] = 0;
//         partyTotals[party_id] += Number(update.sundry_creditors);
//       }
//     }
//     return partyTotals;
//   }, [updates, stocks, dateFrom, dateTo]);

//   const calculateReducingInterest = (
//     party: Party,
//     withdrawals: WithdrawalRecord[],
//     interestRate: number, // e.g., 15
//     endDate: string // Usually the "Date To" filter or today
//   ) => {
//     console.log("=== [REDUCING INTEREST] Step 1: Setup Parameters ===");
//     const start = new Date(party.date);
//     const end = new Date(endDate);
//     console.log("  - Start date:", start);
//     console.log("  - End date:", end);
//     console.log("  - Interest Rate (annualized):", interestRate);

//     // 1. Start with the initial full amount
//     let currentPrincipal = parseFloat(String(party.total_amount || 0));
//     let totalInterest = 0;
//     let lastDate = new Date(start);
//     console.log("Step 2: Initial Principal from party.total_amount:", currentPrincipal);

//     // 2. Filter and sort withdrawals for this specific party
//     const partyWithdrawals = withdrawals
//       .filter(w => String(w.party_id) === String(party.id))
//       .map(w => ({
//         date: new Date(w.date),
//         amount: parseFloat(String(w.amount || 0))
//       }))
//       .filter(w => w.date > start && w.date <= end)
//       .sort((a, b) => a.date.getTime() - b.date.getTime());
//     console.log("Step 3: Filtered and Sorted Party Withdrawals:");
//     partyWithdrawals.forEach((w, idx) => {
//       console.log(`  [${idx + 1}] Date: ${w.date}, Amount: ${w.amount}`);
//     });

//     // Calculate totalWithdrawal
//     const totalWithdrawal = partyWithdrawals.reduce((sum, w) => sum + w.amount, 0);

//     // 3. Process time slices between withdrawals
//     partyWithdrawals.forEach((withdrawal, idx) => {
//       console.log(`Step 4: Processing Withdrawal #${idx + 1}`);
//       // Calculate days between the last event and this withdrawal
//       const diffTime = withdrawal.date.getTime() - lastDate.getTime();
//       const days = Math.floor(diffTime / (1000 * 60 * 60 * 24));
//       console.log(`  - Last Date:`, lastDate);
//       console.log(`  - Withdrawal Date:`, withdrawal.date);
//       console.log(`  - Days in period:`, days);
//       if (days > 0) {
//         // Apply your formula: (P * 1 * R / 36500) * Days
//         const interestForSlice = (currentPrincipal * 1 * interestRate / 36500) * days;
//         totalInterest += interestForSlice;
//         console.log(`  - [Interest Calculation] (${currentPrincipal} * 1 * ${interestRate} / 36500) * ${days} = ${interestForSlice}`);
//         console.log(`  - Total interest so far:`, totalInterest);
//       } else {
//         console.log(`  - No days between lastDate and this withdrawal, skipped interest.`);
//       }
//       // REDUCE the principal for the next period
//       console.log(`  - Reducing principal: ${currentPrincipal} - ${withdrawal.amount} = ${currentPrincipal - withdrawal.amount}`);
//       currentPrincipal -= withdrawal.amount;
//       lastDate = new Date(withdrawal.date);
//     });

//     // 4. Final slice: Calculate interest from the last withdrawal date to the end date
//     const finalDiffTime = end.getTime() - lastDate.getTime();
//     const finalDays = Math.floor(finalDiffTime / (1000 * 60 * 60 * 24));
//     console.log(`Step 5: Final Interest Slice`);
//     console.log(`  - Final period: ${lastDate} to ${end} (${finalDays} days)`);
//     if (finalDays > 0) {
//       const finalInterestForSlice = (currentPrincipal * 1 * interestRate / 36500) * finalDays;
//       totalInterest += finalInterestForSlice;
//       console.log(`  - [Final Interest Calculation] (${currentPrincipal} * 1 * ${interestRate} / 36500) * ${finalDays} = ${finalInterestForSlice}`);
//       console.log(`  - Total interest after final period:`, totalInterest);
//     } else {
//       console.log(`  - No days in the final period, skipped final interest.`);
//     }

//     console.log("=== [REDUCING INTEREST] Result ===");
//     console.log("  - Accumulated Interest:", totalInterest);
//     console.log("  - Remaining Principal:", currentPrincipal);
//     console.log("  - Total Withdrawal:", totalWithdrawal);

//     return {
//       accumulatedInterest: totalInterest,
//       remainingPrincipal: currentPrincipal,
//       totalWithdrawal
//     };
//   };
//   function getDatafromLocalStorageForSale(partyId:any) {
//     // Read "saved_party_Sale_data" from localStorage
//     const key = "saved_party_Sale_data";
//     let data = {};
//     try {
//       const saved = localStorage.getItem(key);
//       if (saved) {
//         data = JSON.parse(saved);
//       }
//     } catch (e) {
//       // If parsing fails or no data, just return 0
//       return 0;
//     }
//     // Get this party's array (or empty array)
//     const salesArr = Array.isArray(data)
//       ? data.filter((item) => String(item.partyId) === String(partyId))
//       : (data && (data as Record<string, any>)[partyId]) || [];
//     // Sum the "amount" fields (string or number)
//     const sum = salesArr.reduce((total:any, entry:any) => {
//       const a = typeof entry.amount === "number" ? entry.amount : Number(entry.amount);
//       return total + (isNaN(a) ? 0 : a);
//     }, 0);
//     return sum;
//   }
//   function getDatafromLocalStorageForExpenses(partyId:any) {
//     // Read "saved_party_Sale_data" from localStorage
//     const key = "saved_party_Expenses_data";
//     let data = {};
//     try {
//       const saved = localStorage.getItem(key);
//       if (saved) {
//         data = JSON.parse(saved);
//       }
//     } catch (e) {
//       // If parsing fails or no data, just return 0
//       return 0;
//     }
//     // Get this party's array (or empty array)
//     const salesArr = Array.isArray(data)
//       ? data.filter((item) => String(item.partyId) === String(partyId))
//       : (data && (data as Record<string, any>)[partyId]) || [];
//     // Sum the "amount" fields (string or number)
//     const sum = salesArr.reduce((total:any, entry:any) => {
//       const a = typeof entry.amount === "number" ? entry.amount : Number(entry.amount);
//       return total + (isNaN(a) ? 0 : a);
//     }, 0);
//     return sum;
//   }
//   // --- REWRITE buildFinalSheetDataForParty to use loss/profit logic ---
//   function buildFinalSheetDataForParty(party: Party) {
//     //console.log("party data ", party);

    
//     const partyStockRow = partyAggregatedRows.find(r => r.party.id === party.id);
//     const totalWithdrawalAmount = withdrawals
//     .filter(w => String(w.party_id) === String(party.id))
//     .reduce((sum, w) => sum + (parseFloat(String(w.amount)) || 0), 0);
    
//     let remainingAmount = 0;
//     let interestExpenses = 0;
//     let openingStock = 0;
//     let purchases = 0;
//     let directExpenses = 0;
//     let sharesPurchased = 0;

//     openingStock = parties
//       .filter(prt => prt.id === party.id)
//       .reduce((sum, prt) => sum + (Number(prt.total_amount) || 0), 0);

//     // Get the month difference for a party by taking the earliest of all their investment dates from `parties`.
//     // Dates are like "2026-01-06", "2026-02-17", etc.; pick the earliest, i.e., "01" (Jan).
//     function getMonthDiff(_: any, to: string | Date | undefined, parties: any[], partId: number) {
//       // Find the party in the parties array
//       //console.log("parties data,", parties);
//       const party = parties.find((p: any) => Number(p.id) === Number(partId));
//       if (!party) return 1;

//       // Gather all string dates for the party in yyyy-mm-dd format
//       let dateList: Date[] = [];
//       if (Array.isArray(party.dates) && party.dates.length > 0) {
//         // .dates exists on the party, expected as array of date strings
//         dateList = party.dates
//           .filter(Boolean)
//           .map((d: string | Date) => typeof d === "string" ? new Date(d) : d);
//       } else if (party.date) {
//         // Fallback to single date property
//         dateList = [typeof party.date === "string" ? new Date(party.date) : party.date];
//       }

//       if (dateList.length === 0) return 1;

//       // Take the earliest date (by value)
//       const earliest = dateList.reduce((min, d) => (d.getTime() < min.getTime() ? d : min), dateList[0]);
//       const end = to ? (typeof to === "string" ? new Date(to) : to) : new Date();

//       // If the month and year are the same, return 1
//       if (earliest.getFullYear() === end.getFullYear() && earliest.getMonth() === end.getMonth()) {
//         return 1;
//       }

//       // Calculate month difference
//       let months = (end.getFullYear() - earliest.getFullYear()) * 12 + (end.getMonth() - earliest.getMonth());
//       if (end.getDate() >= earliest.getDate()) {
//         months += 1;
//       }
//       return months < 1 ? 1 : months;
//     }
//     function getMonthDiffForStockdate(_: any, to: string | Date | undefined, stocks: any[], partId: number) {
//       // Find the party in the parties array
//       //console.log("parties data,", stocks);
//       const party = stocks.find((p: any) => Number(p.party_id) === Number(partId));
//       if (!party) return 1;

//       // Gather all string dates for the party in yyyy-mm-dd format
//       let dateList: Date[] = [];
//       if (Array.isArray(party.dates) && party.dates.length > 0) {
//         // .dates exists on the party, expected as array of date strings
//         dateList = party.dates
//           .filter(Boolean)
//           .map((d: string | Date) => typeof d === "string" ? new Date(d) : d);
//       } else if (party.date) {
//         // Fallback to single date property
//         dateList = [typeof party.date === "string" ? new Date(party.date) : party.date];
//       }

//       if (dateList.length === 0) return 1;

//       // Take the earliest date (by value)
//       const earliest = dateList.reduce((min, d) => (d.getTime() < min.getTime() ? d : min), dateList[0]);
//       const end = to ? (typeof to === "string" ? new Date(to) : to) : new Date();

//       // If the month and year are the same, return 1
//       if (earliest.getFullYear() === end.getFullYear() && earliest.getMonth() === end.getMonth()) {
//         return 1;
//       }

//       // Calculate month difference
//       let months = (end.getFullYear() - earliest.getFullYear()) * 12 + (end.getMonth() - earliest.getMonth());
//       if (end.getDate() >= earliest.getDate()) {
//         months += 1;
//       }
//       return months < 1 ? 1 : months;
//     }
//     let months = 1;
//     const end = dateTo ? new Date(dateTo) : new Date();
//     // months = getMonthDiff(party.date, end, parties, party.id);
//     months = getMonthDiff(party.date, end, stocks, party.id);
//     //console.log("months, ", months, "party date, ", party.date)
//     interestExpenses =  (Number(party.total_amount || 0))/2 * (Number(interestPercentage) / 100) * Number(months);
//     const partyStocksRaw = stocks.filter(stk => String(stk.party_id) === String(party.id));
//     for (const stk of partyStocksRaw) {
//       const purchaseDate = stk.date_of_purchase || stk.date || "";
//       if (isInDateRange(purchaseDate)) {
//         const cats = parseCategoriesForDb(stk.categories);
//         for (const catObj of cats) {
//           purchases += Number(catObj.total_amount || 0);
//           if(catObj.investment_type === "structure") {
//             sharesPurchased += Number(catObj.total_amount || 0);
//             sharesPurchased+=Number(catObj.indirect_charges);
//           }
//           if(catObj.investment_type === "direct") {
//             directExpenses += Number(catObj.total_amount || 0);
//           }

//         }
//       }
//     }
//     if (!calculationFormulasConfig?.purchaseShare && calculationFormulasConfig?.purchaseShare != undefined) {
//       sharesPurchased = 0;
//     }
//     if (!calculationFormulasConfig?.purchaseDirect && false || calculationFormulasConfig?.purchaseDirect !== undefined) {
//       directExpenses = 0;
//     }

//     // Compute sales from sellStocks API for this party and date range
//     let sales = 0;
//     if (sellStocks.length > 0) {
//       let filteredSales = sellStocks.filter(s =>
//         String(s.party_id) === String(party.id) &&
//         (!dateFrom || new Date(s.date) >= new Date(dateFrom)) &&
//         (!dateTo   || new Date(s.date) <= new Date(dateTo))
//       );
//       sales = filteredSales.reduce((sum, s) => sum + (parseFloat(s.sell_amount) || 0), 0);
//     }

//     let closingStock = 0;
//     for (const stk of partyStocksRaw) {
//       const cats = parseCategoriesForDb(stk.categories);
//       for (const catObj of cats) {
//         const catId = catObj.id;
//         const latest = getLatestCurrentAmountFor(stk.id, catId, updates, dateFrom, dateTo);
//         const val = latest ? Number(latest.current_price) : (isInDateRange(stk.date_of_purchase || stk.date || "") ? Number(catObj.total_amount) : 0);
//         closingStock += val;
//       }
//     }



//     sales  = getDatafromLocalStorageForSale(party.id);




//     let indirectExpenses = 0;
//   let totalPurchases = 0;
// let totalSales = 0;
// let totalHoldingCost = 0; // This is your "Amount not in sale"
// let totalsoldstockpurchasingamount = 0;
// let totalsoldstockpurchasingamountindirectcharges = 0;

// let totalsoldstocksellingpriceindirectcharges = 0;

// for (const stk of partyStocksRaw) {
//   const purchaseDate = stk.date_of_purchase || stk.date || "";
//   if (isInDateRange(purchaseDate)) {
//     const cats = parseCategoriesForDb(stk.categories);

//     for (const catObj of cats) {
//       // 1. Original Cost Values (from the purchase record)
//       const originalTotalAmt = Number(catObj.total_amount || 0);
//       const pUnits = parseFloat(catObj.unit);
//       const originalIndirect = Number(catObj.indirect_charges || 0);
      
//       // Original Cost Per Unit (including or excluding indirect based on your preference)
//       // Standard accounting: (Total Amount / Total Units)
//       const originalPricePerUnit = pUnits > 0 ? originalTotalAmt / pUnits : 0;
//       const originalIndirectPerUnit = pUnits > 0 ? originalIndirect / pUnits : 0;

//       // 2. Current Valuation (from updates table)
//       let currentPAmt = originalTotalAmt;
//       // let currentPricePerUnit = Number(catObj.perUnitCharge || 0);
//       let currentPricePerUnit = (originalTotalAmt+originalIndirect)/pUnits;

//       const latestUpdate = getLatestCurrentAmountFor(stk.id, catObj.id, updates, dateFrom, dateTo);

//       if (latestUpdate && latestUpdate.current_price) {
//         currentPAmt = Number(latestUpdate.current_price);
//         currentPricePerUnit = pUnits > 0 ? (currentPAmt+originalIndirect) / pUnits : 0;
//       }

//       // 3. Accumulate Global Total Purchases (At Original Cost)
//       totalPurchases += (originalTotalAmt + originalIndirect);

//       // 4. Sales Logic
//       const specificSales = sellStocks.filter(s =>
//         String(s.party_id) === String(party.id) &&
//         s.stock_name === catObj.stock_name
//       );

//       const soldUnits = specificSales.reduce((sum, s) => sum + (parseFloat(s.sell_units) || 0), 0);
//       const soldAmount = specificSales.reduce((sum, s) => sum + (parseFloat(s.sell_amount) || 0), 0);
//       const soldCharges = specificSales.reduce((sum, s) => sum + (parseFloat(s.indirect_charges) || 0), 0);

//       totalSales += soldAmount;
//       totalsoldstocksellingpriceindirectcharges+=soldCharges;

//       // --- NEW CALCULATION FOR SOLD STOCK COST ---
//       if (soldUnits > 0) {
//         // This calculates the Original Purchase Value of the units that were sold
//         totalsoldstockpurchasingamount += (soldUnits * originalPricePerUnit);
        
//         // This calculates the proportional Indirect Charges for the units that were sold
//         totalsoldstockpurchasingamountindirectcharges += originalIndirect;
        
//         //console.log(`Sold ${catObj.stock_name}: Cost was ${soldUnits * originalPricePerUnit}, Sold for ${soldAmount}`);
//       }

//       // 5. Holding Calculation (Remaining units at CURRENT valuation)
//       const remainingUnits = pUnits - soldUnits;
//       if (remainingUnits > 0) {
//         totalHoldingCost += (remainingUnits * currentPricePerUnit);
//       }
//     }
//   }
// }
//     //console.log("purchase  = ", purchases , " sales ", sales);
//     //console.log("totalsoldstockpurchasingamount  = ", totalsoldstockpurchasingamount );
//     //console.log("totalsoldstockpurchasingamountindirectcharges  = ", totalsoldstockpurchasingamountindirectcharges );
//     //console.log("totalSales  = ", totalSales);
//     //console.log("totalsoldstocksellingpriceindirectcharges  = ", totalsoldstocksellingpriceindirectcharges);

//     purchases +=sales;
//     console.log("holding amt," , totalHoldingCost);
//     //console.log("purchases," , purchases);
//     // Use sales in grossProfit
    
//     let dynamic_total_sold_stock_purchasing_amount = totalsoldstockpurchasingamount;
//     let dynamic_totalSales = totalSales;
//     if(calculationFormulasConfig?.grossSaleCharges){
//       dynamic_totalSales-=totalsoldstocksellingpriceindirectcharges;
//     }
//     if(calculationFormulasConfig?.grossSaleCharges){
//       dynamic_total_sold_stock_purchasing_amount+=totalsoldstockpurchasingamountindirectcharges;
//     }
//     let grossProfit = ((dynamic_totalSales)-(dynamic_total_sold_stock_purchasing_amount ));
//     if(calculationFormulasConfig?.grossInterestCharges){
//       grossProfit-=interestExpenses;
//     }

//     // console.log("(closingStock) - (purchases+indirectExpenses); ", "(",closingStock,")"," -", "(",purchases,"+",indirectExpenses,")")
//     let indirectIncome = 0;
   
//     const partyIdStr = String(party.id);
//     if (partySundryCreditorsMap[partyIdStr] !== undefined) {
//       indirectIncome = partySundryCreditorsMap[partyIdStr];
//     }
    
//     let dynamic_total_indirect_expenses = 0;
//     if(calculationFormulasConfig?.indInterestCharges){
//       dynamic_total_indirect_expenses+=interestExpenses;
//     }
//     if(calculationFormulasConfig?.indPurchaseIndirect){
//       dynamic_total_indirect_expenses+=totalsoldstockpurchasingamountindirectcharges;
//     }
//     if(calculationFormulasConfig?.indPurchasedStockSale){
//       dynamic_total_indirect_expenses+=totalsoldstocksellingpriceindirectcharges;
//     }
//     //console.log("purchase amt", purchases);
//     // const netLoss = grossProfit < 0 ? (interestExpenses - (grossProfit )) : (interestExpenses - (grossProfit ));
//    // const netLoss =  (((totalSales-totalsoldstocksellingpriceindirectcharges  )-(totalsoldstockpurchasingamount+totalsoldstockpurchasingamountindirectcharges ))-interestExpenses)+indirectIncome;

//      let dynamic_net_indirectIncome = 0;
//      if(calculationFormulasConfig?.netIndirectExpenses){
//       dynamic_net_indirectIncome+=indirectIncome;
//     }

//     const profitcs = Number(partyClosingAmounts[String(party.id)] ?? 0) - Number(totalHoldingCost ?? 0);

//     let netLoss = ( (((grossProfit)))) +profitcs;
//     console.log("grossProfit ," , grossProfit);
//     console.log("dynamic_total_indirect_expenses ," , dynamic_total_indirect_expenses);
//     console.log("dynamic_net_indirectIncome ," , dynamic_net_indirectIncome);
//     console.log("profitcs ," , profitcs);
//     console.log("netLoss ," , netLoss);
//     const format = (n: number) => n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     let withdrawlamuntofparty = partyStockRow && typeof partyStockRow.total_withdrawal_amount === "number"
//       ? partyStockRow.total_withdrawal_amount
//       : 0;
//     remainingAmount = (Number(party.total_amount)-(sharesPurchased)-interestExpenses)+indirectIncome+(sales-totalsoldstocksellingpriceindirectcharges)- withdrawlamuntofparty;
//     closingStock +=(remainingAmount);

//     // Custom loss/profit logic: Check per-party value
//     // --- BEGIN NEW LOGIC FOR PER-PARTY SAVED PROFIT/LOSS/COMMISSION DATA ---

//     // Helper function to filter transactions within selected date range (inclusive)
//     function filterByDateRange(arr: {amount: string, date: string}[] = []) {
//       if (!Array.isArray(arr) || arr.length === 0) return [];
//       const from = dateFrom ? new Date(dateFrom) : null;
//       const to = dateTo ? new Date(dateTo) : null;
//       return arr.filter(item => {
//         const d = new Date(item.date);
//         if (from && d < from) return false;
//         if (to && d > to) return false;
//         return true;
//       });
//     }

//     // Read saved loss/profit/commission arrays from localStorage for this party
//     let savedPartyLossArr: any[] = [];
//     let savedPartyProfitArr: any[] = [];
//     let savedPartyCommissionArr: any[] = [];

//     try {
//       // All keys in localStorage as per convention described (e.g., saved_party_Loss_data)
//       const keyLoss = `saved_party_Loss_data`;
//       const keyProfit = `saved_party_Profit_data`;
//       const keyCommission = `saved_party_Commission_data`;

//       // Try to get JSON and index by partyIdStr
//       let parsedLoss = JSON.parse(localStorage.getItem(keyLoss) || "{}");
//       let parsedProfit = JSON.parse(localStorage.getItem(keyProfit) || "{}");
//       let parsedCommission = JSON.parse(localStorage.getItem(keyCommission) || "{}");

//       if (Array.isArray(parsedLoss)) {
//         // Some stored as arrays with keys as numbers
//         savedPartyLossArr = filterByDateRange(parsedLoss.filter((x: any) => x && String(x.partyId) === partyIdStr));
//       } else {
//         // Otherwise object of partyId => array
//         savedPartyLossArr = filterByDateRange(parsedLoss[partyIdStr] || []);
//       }
//       if (Array.isArray(parsedProfit)) {
//         savedPartyProfitArr = filterByDateRange(parsedProfit.filter((x: any) => x && String(x.partyId) === partyIdStr));
//       } else {
//         savedPartyProfitArr = filterByDateRange(parsedProfit[partyIdStr] || []);
//       }
//       if (Array.isArray(parsedCommission)) {
//         savedPartyCommissionArr = filterByDateRange(parsedCommission.filter((x: any) => x && String(x.partyId) === partyIdStr));
//       } else {
//         savedPartyCommissionArr = filterByDateRange(parsedCommission[partyIdStr] || []);
//       }
//     } catch (e) {
//       // fallback: empty arrays, ignore parse errors.
//       savedPartyLossArr = [];
//       savedPartyProfitArr = [];
//       savedPartyCommissionArr = [];
//     }

//     // Now, sum the amounts for the current date range for loss/profit/commission
//     const sumAmounts = (arr: any[]) => {
//       return arr.reduce((sum, item) => {
//         // Accept both string or number types
//         let amt = typeof item.amount === "number" ? item.amount : Number(item.amount);
//         return sum + (isNaN(amt) ? 0 : amt);
//       }, 0);
//     };

//     const lossAmt = sumAmounts(savedPartyLossArr);
//     const profitAmt = sumAmounts(savedPartyProfitArr);
//     const Commission = sumAmounts(savedPartyCommissionArr);

//     // The expression to set data for netLoss (and its .toLocale... string)
//     let netLossOverrideVal: number;
//     if (typeof lossAmt === "number" && lossAmt > 0 && (!profitAmt || profitAmt === 0)) {
//       netLossOverrideVal = -1 * lossAmt;
//     } else if (typeof profitAmt === "number" && profitAmt > 0 && (!lossAmt || lossAmt === 0)) {
//       netLossOverrideVal = profitAmt;
//     } else if (typeof profitAmt === "number" && profitAmt > 0 && typeof lossAmt === "number" && lossAmt > 0) {
//       netLossOverrideVal = profitAmt - lossAmt;
//     } else {
//       netLossOverrideVal = netLoss;
//     }
//     let netGrossFitOverrideVal: number;
//     if (typeof lossAmt === "number" && lossAmt > 0 && (!profitAmt || profitAmt === 0)) {
//       netGrossFitOverrideVal = -1 * lossAmt;
//     } else if (typeof profitAmt === "number" && profitAmt > 0 && (!lossAmt || lossAmt === 0)) {
//       netGrossFitOverrideVal = profitAmt;
//     } else if (typeof profitAmt === "number" && profitAmt > 0 && typeof lossAmt === "number" && lossAmt > 0) {
//       netGrossFitOverrideVal = profitAmt - lossAmt;
//     } else {
//       netGrossFitOverrideVal = grossProfit;
//     }
//     let globalInterest =  0;
//     if(netLoss>0){
//       netLoss-=Commission;
//     }
//     let pnltotalcharges = dynamic_total_indirect_expenses;

//     // const interestResult = calculateDailyInterest(
//     //   party, 
//     //   dateFrom, 
//     //   dateTo, 
//     //   partyStocksRaw, 
//     //   sellStocks,
//     //   interestPercentage // Pass the rate here
//     // );

//     const reducingBalanceData = calculateReducingInterest(
//       party, 
//       withdrawals, 
//       (interestPercentage*12), 
//       interestDateTo || new Date().toISOString()
//   );

//     console.log("reducingBalanceData from function, ",reducingBalanceData);
//     let purchaseAccount = sharesPurchased + directExpenses;
//     let localstorageexpense = getDatafromLocalStorageForExpenses(party.id);

//     return {
//       openingStock: format(openingStock),
//       CapitalAccount:format((openingStock-reducingBalanceData.totalWithdrawal)+reducingBalanceData.accumulatedInterest),
//       remainingAmount:format(remainingAmount),
//       holdingamt:format(totalHoldingCost),
//       totalWithdrawalAmount:format(totalWithdrawalAmount),
//       purchases: format(purchases),
//       sales: format(sales),
//       closingStock: format(sales+netGrossFitOverrideVal),
//       grossProfit: format(netGrossFitOverrideVal),
//       indirectExpenses: format(globalInterest),
//       interestExpenses: format(reducingBalanceData.accumulatedInterest + localstorageexpense),
//       indirectIncome: format(indirectIncome),
//       netLoss: format(netLossOverrideVal),
//       salesindirectcharges:format(totalsoldstocksellingpriceindirectcharges),
//       purchasetosellindirectcharges:format(totalsoldstockpurchasingamountindirectcharges),
//       leftTotalTrading: format(purchases + Math.max(grossProfit, 0)),
//       rightTotalTrading: format(sales + closingStock),
//       leftTotalPL: format((openingStock)+netLossOverrideVal),
//       rightTotalPL: format((openingStock)+netLossOverrideVal),
//       directExpenses: format(directExpenses),
//       sharesPurchased: format(sharesPurchased),
//       pnltotalcharges:format(pnltotalcharges),
//       purchaseAccount:format(purchaseAccount),
//       raw: {
//         openingStock, purchases, sales, closingStock, grossProfit:netGrossFitOverrideVal, indirectExpenses, indirectIncome, netLoss: netLossOverrideVal
//       }
//     };
//   }

//   function buildBalanceSheetDetailsForParty(party: Party) {
//     const pnl = buildFinalSheetDataForParty(party);

//     const openingStock = Number(pnl.raw.openingStock || 0);
//     const investedCapital = Number(pnl.raw.purchases || 0);

//     let totalInterest = 0;
//     const partyStocksRaw = stocks.filter(stk => String(stk.party_id) === String(party.id));

//     // Get the party's investment date (using the earliest stock date for safety)
//     let earliestDate = undefined;
//     for (const stk of partyStocksRaw) {
//       const purchaseDate = stk.date_of_purchase || stk.date || "";
//       if (!purchaseDate) continue;
//       if (!earliestDate || new Date(purchaseDate) < new Date(earliestDate)) {
//         earliestDate = purchaseDate;
//       }
//     }
//     // Use filter or party?.date as a fallback
//     let investmentDate = earliestDate || party?.date;
//     let endDate = dateTo || new Date();

//     function getMonthDiff(partyDate: string | Date | undefined, to: string | Date | undefined) {
//       if (!partyDate) return 1;
//       const start = typeof partyDate === "string" ? new Date(partyDate) : partyDate;
//       const end = to ? (typeof to === "string" ? new Date(to) : to) : new Date();

//       if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) {
//         return 1;
//       }

//       let months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());

//       if (end.getDate() >= start.getDate()) {
//         months += 1;
//       }

//       return months < 1 ? 1 : months;
//     }

//     let months = 1;
//     if (investmentDate) {
//       const start = new Date(investmentDate);
//       const end = dateTo ? new Date(dateTo) : new Date();
//       months = getMonthDiff(party.date, end);
//     }

//     let openingBalance = 0;
//     for (const stk of partyStocksRaw) {
//       const purchaseDate = stk.date_of_purchase || stk.date || "";
//       if (!isInDateRange(purchaseDate)) continue;
//       const cats = parseCategoriesForDb(stk.categories);
//       for (const catObj of cats) {
//         openingBalance += Number(catObj.total_amount || 0);
//       }
//     }

//     totalInterest = Number(party.total_amount || 0) * (Number(interestPercentage) / 100) * Number(months);

//     const netLoss = Number(pnl.raw.netLoss) > 0 ? -1 * Number(pnl.raw.netLoss) : 0;

//     let sundryCreditors = 0;
//     let indirectcharges = 0;
//     const partyIdStr = String(party.id);
//     if (partySundryCreditorsMap[partyIdStr] !== undefined) {
//       sundryCreditors = partySundryCreditorsMap[partyIdStr];
//     } else {
//       for (const stk of partyStocksRaw) {
//         const purchaseDate = stk.date_of_purchase || stk.date || "";
//         if (!isInDateRange(purchaseDate)) continue;
//         const cats = parseCategoriesForDb(stk.categories);
//         for (const catObj of cats) { }
//       }
//     }
//     for (const stk of partyStocksRaw) {
//       const purchaseDate = stk.date_of_purchase || stk.date || "";
//       if (!isInDateRange(purchaseDate)) continue;
//       const cats = parseCategoriesForDb(stk.categories);
//       for (const catObj of cats) {
//         indirectcharges += Number(catObj.indirect_charges || 0);
//       }
//     }

//     const sharesInvestments = investedCapital;
//     const closingStock = Number(pnl.raw.closingStock || 0);
//     const totalCapital = investedCapital + totalInterest;
//     const totalLiabilities = totalCapital + netLoss + sundryCreditors+indirectcharges+(closingStock-sharesInvestments);
//     const TotalCloseStockAssests = totalCapital+(closingStock-sharesInvestments);
//     const totalAssets = parseFloat(Number(Number(pnl.raw.closingStock) + sundryCreditors).toFixed(2));

//     const fmt = (v: number) =>
//       v === 0 ? "0.00"
//         : v < 0
//         ? `(${Math.abs(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })})`
//         : v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//     return {
//       liabilities: [
//         { label: <b>Capital Account</b>, amount: "" },
//         { label: "Total Amount", amount: openingStock },
//         // { 
//         //   label: "Purchases", 
//         //   amount: isNaN(Number(pnl.raw.purchases)) && isNaN(Number(indirectcharges)) 
//         //     ? "0.00" 
//         //     : Number(Number(pnl.raw.purchases || 0) + Number(indirectcharges || 0)) 
//         // },
//         // // { label: "Remaining Amount", amount: String(pnl.remainingAmount || 0) },
//         // { label: `Interest on Investment (${interestPercentage}%)`, amount: totalInterest },
  
//         null,
//         // { label: <b>Profit &amp; Loss A/c</b>, amount: (pnl.raw.grossProfit) },
//         // { label: "Net Loss (Current Period)", amount: (pnl.raw.grossProfit)<0?(pnl.raw.grossProfit):0 },
//         // { label: "Net Profit (Current Period)", amount: (pnl.raw.grossProfit)>0?(pnl.raw.grossProfit):0 },
//         null,
//         { label: <b>Current Liabilities</b>, amount: "" },
//         { label: <span style={{ fontSize: '12px' }}>Indirect Charges</span>, amount: indirectcharges },
//         null,
//         { label: <b>TOTAL</b>, amount: (pnl.leftTotalPL) },
//       ],
//       assets: [
//         { label: <b>Current Assests</b>, amount: "" },
//         { label: "Sundry Debtors", amount: String(pnl.remainingAmount || 0) },
//         null,
//         { label: <b>Profit & Loss A/c</b>, amount: "" },
//         { label: "", amount:  pnl.raw.grossProfit },
//         null,
//         { label: <b>TOTAL</b>, amount:  pnl.leftTotalPL}
//       ]
//     }
//   }

//   useEffect(() => {
//     if (!partyAggregatedRows.length) return;
//     let vals: { [key: string]: string[] } = {};
//     vals['party_name'] = partyAggregatedRows.map(row => row.party.name);
//     setUniqueColumnValues(vals);
//   }, [partyAggregatedRows]);

//   // ------------ Filtering: Rewrite filteredData to use party id from url if exists -------------
//   const filteredData = React.useMemo(() => {
//     let arr = partyAggregatedRows;
//     // --- filter by party id if available ---
//     if(partyIdFromUrl){
//       arr = arr.filter(row => String(row.party.id) === String(partyIdFromUrl));
//     }
//     if (search) {
//       arr = arr.filter(row =>
//         row.party.name && row.party.name.toLowerCase().includes(search.toLowerCase())
//       );
//     }
//     Object.entries(filters).forEach(([key, value]) => {
//       if (!value) return;
//       if (key === 'party_name') {
//         arr = arr.filter(row =>
//           row.party.name && row.party.name.toLowerCase() === String(value).toLowerCase()
//         );
//       }
//     });
//     return arr;
//   }, [partyAggregatedRows, search, filters, partyIdFromUrl]); // add partyIdFromUrl as dep

//   // ...rest is unchanged...
//   const totalPage = Math.ceil(filteredData.length / perPage) || 1;
//   const pageData = filteredData.slice((page - 1) * perPage, page * perPage);

//   function handleExportCSV() {
//     const exportHeadings = [
//       "Party Name", "Contact Person", "Contact Number", "Total Purchased", "Total Used", "Total Earning"
//     ];
//     let csv = [exportHeadings.join(",")];
//     pageData.forEach(row => {
//       csv.push([
//         row.party.name,
//         row.party.contact_person_name,
//         row.party.contact_person_number,
//         row.total_purchased,
//         row.total_used,
//         row.total_earning
//       ].map(val => `"${val !== undefined && val !== null ? String(val).replace(/"/g, '""') : ''}"`).join(","))
//     });
//     downloadCSV(csv.join("\r\n"), "party_balance_sheet.csv");
//   }

//   function handleImportClick() {
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//       fileInputRef.current.click();
//     }
//   }
//   async function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
//     const file = e.target.files && e.target.files[0];
//     if (!file) return;
//     const reader = new FileReader();
//     reader.onload = async (event) => {
//       const text = event.target?.result as string;
//       alert("Import functionality: Received file, implement parsing here.");
//     };
//     reader.readAsText(file);
//   }

//   const handleColumnFilterChange = (colKey: string, val: string | null) => {
//     setFilters(filters => ({
//       ...filters,
//       [colKey]: val
//     }));
//     setPage(1);
//     setOpenFilterDropdown(null);
//   };

//   const renderGlobalFilterPanel = () => (
//     showFilterPanel && (
//       <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/30 z-30 flex items-center justify-center">
//         <div className="bg-white rounded-lg shadow-lg p-6 w-[95vw] max-w-2xl max-h-[90vh] overflow-y-auto relative">
//           <button
//             className="absolute top-3 right-4 text-xl text-gray-500 hover:text-gray-700"
//             onClick={() => setShowFilterPanel(false)}
//             title="Close"
//           >&times;</button>
//           <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
//             <FaFilter className="text-[#6742c7]" /> Filters
//           </h3>
//           <div className="space-y-3">
//             {columnFilters.map(f => (
//               <div key={f.key}>
//                 <div className="text-xs font-semibold text-gray-600 mb-1">{f.label}</div>
//                 {uniqueColumnValues[f.key] && uniqueColumnValues[f.key].length > 0 ? (
//                   <div className="flex gap-2 flex-wrap">
//                     <button
//                       key="filter-all"
//                       className={`px-3 py-1 rounded border text-xs ${!filters[f.key] ? "bg-[#6742c7] text-white" : "bg-gray-100 text-gray-700"}`}
//                       onClick={() => handleColumnFilterChange(f.key, null)}
//                     >
//                       All
//                     </button>
//                     {uniqueColumnValues[f.key]
//                       .sort()
//                       .map(option => (
//                         <button
//                           key={option + f.key}
//                           className={`px-3 py-1 rounded border text-xs ${filters[f.key] === option
//                             ? "bg-[#6742c7] text-white"
//                             : "bg-gray-100 text-gray-700"
//                           }`}
//                           onClick={() => handleColumnFilterChange(f.key, option)}
//                         >
//                           {option}
//                         </button>
//                       ))
//                     }
//                   </div>
//                 ) : (
//                   <span className="block px-2 text-xs text-gray-400">No values</span>
//                 )}
//                 {filters[f.key] && (
//                   <button
//                     className="mt-1 px-2 py-0 text-xs text-gray-500 hover:text-[#6742c7]"
//                     onClick={() => handleColumnFilterChange(f.key, null)}
//                   >
//                     Clear
//                   </button>
//                 )}
//               </div>
//             ))}
//             {/* Date Range Picker */}
//             <div>
//               <label className="text-xs font-semibold text-gray-600 block mb-1">Date Range</label>
//               <div className="flex gap-2 items-center">
//                 <input
//                   type="date"
//                   className="border px-2 py-1 rounded text-xs"
//                   value={dateFrom}
//                   onChange={e => { setDateFrom(e.target.value); setPage(1); }}
//                   max={dateTo || undefined}
//                   style={{width:"130px"}}
//                 />
//                 <span className="text-gray-500">to</span>
//                 <input
//                   type="date"
//                   className="border px-2 py-1 rounded text-xs"
//                   value={dateTo}
//                   onChange={e => { setDateTo(e.target.value); setPage(1); }}
//                   min={dateFrom || undefined}
//                   style={{width:"130px"}}
//                 />
//               </div>
//               {(dateFrom || dateTo) && (
//                 <button
//                   className="mt-1 px-2 py-0 text-xs text-gray-500 hover:text-[#6742c7]"
//                   onClick={() => { setDateFrom(''); setDateTo(''); setPage(1); }}
//                 >
//                   Clear Date
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     )
//   );

//   function renderDatePeriodBanner() {
//     const period = formatPeriod(dateFrom, dateTo);
//     return (
//       <div className="mb-2 text-sm text-[#6742c7] font-medium flex items-center gap-2">
//         <span>Showing data for:</span>
//         <span className="bg-[#ffff] px-2 rounded text-[#222]">
//           {period}
//         </span>
//       </div>
//     );
//   }

//   function renderPnLModalContent(party: Party) {
//     const data = buildFinalSheetDataForParty(party);
//     //console.log(" data ", data);
//     const periodLabel = (dateFrom || dateTo)
//       ? `${dateFrom ? new Date(dateFrom).toLocaleDateString("en-GB") : ""}${
//           dateFrom && dateTo ? " to " : dateTo ? "to " : ""
//         }${dateTo ? new Date(dateTo).toLocaleDateString("en-GB") : !dateTo ? " to 31-Dec-2025" : ""}`
//       : "Select date range";

//     // Helper for formatting currency with commas and two decimals
//     const fmt = (n: any) =>
//       typeof n === "number"
//         ? `₹${n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
//         : n || "";

//     // Prepare Indirect Expenses total (add Indirect + Interest)
//     const indirectExpensesVal = Number((data.indirectExpenses ?? "0").toString().replace(/,/g, ""));
//     const interestExpensesVal = Number((data.interestExpenses ?? "0").toString().replace(/,/g, ""));
//     const totalIndirectExpenses = indirectExpensesVal + interestExpensesVal;

//     // Table cell helper
//     const renderCell = (
//       children: React.ReactNode,
//       { bold, align = "left", fontSize = 15, style = {}, colSpan, italic }: any = {}
//     ) => (
//       <td
//         style={{
//           border: "0px solid #333",
//           padding: "7px 8px",
//           fontWeight: bold ? 700 : undefined,
//           fontStyle: italic ? "italic" : undefined,
//           textAlign: align,
//           fontSize,
//           ...style,
//           background: style && style.background ? style.background : undefined,
//         }}
//         colSpan={colSpan}
//       >
//         {children}
//       </td>
//     );

//     function addvalue(arg0: string, indirectExpenses: string): number {
//       const a = Number(arg0?.toString().replace(/,/g, "") || "0");
//       const b = Number(indirectExpenses?.toString().replace(/,/g, "") || "0");
//       return a + b;
//     }

//     return (
//       <div style={{ background: "#fff", maxWidth: 900, margin: "0 auto", padding: 12 }} id='renderpnl'>
//         <h2 style={{ fontWeight: 700, color: "#000", textAlign: "center", fontSize: 19, marginBottom: 0, letterSpacing: 1 }}>
//          {farmForm.name}
//         </h2>
//         <div style={{ textAlign: "center", fontSize: 15, marginBottom: 6 }}>{farmForm.address}</div>
//         <div style={{ textAlign: "center", fontWeight: 700, fontSize: 18, margin: "0 0 2px 0" }}>
//           Profit &amp; Loss A/c
//         </div>
//         <div style={{ textAlign: "center", fontSize: 13, marginBottom: 6 }}>
//           {periodLabel}
//         </div>

//         <div style={{ overflowX: "auto", marginTop: 11 }}>
//           <table style={{ borderCollapse: "collapse", width: "100%", minWidth: 700 }}>
//             <thead>
//               <tr style={{ border: "1px solid #0000006e", borderLeft: "none", borderRight: "none" }}>
//                 {renderCell("Particulars", { bold: true, align: "center", style: { background: "#ffff" } })}
//                 {renderCell(periodLabel, { bold: true, align: "center", style: { background: "#ffff" } })}
//                 {renderCell("Particulars", { bold: true, align: "center", style: { background: "#ffff" } })}
//                 {renderCell(periodLabel, { bold: true, align: "center", style: { background: "#ffff" } })}
//               </tr>
//             </thead>
//             <tbody>
//               {/* Helper to render a row with borderRight on the 2nd cell */}
//               {[
//                 // [cell1, cell2, cell3, cell4, optional trProps]
//                 ["", "", "Sales Accounts", fmt(data.sales)],
//                 ["Remaining Amount", fmt(data.remainingAmount), "", "", { className: "hidden" }],
//                 ["Purchase Accounts", fmt(data.sharesPurchased), "Closing Stock", fmt(partyClosingAmounts[String(party.id)] )],

//                 calculationFormulasConfig?.purchaseShare
//                 ?
//                 [
//                   <span style={{ marginLeft: 12 }}>Shares Purchased</span>,
//                   fmt(data.sharesPurchased),
//                   <span style={{ marginLeft: 12 }}></span>,
//                   "",
//                 ]:[],
//                 calculationFormulasConfig?.purchaseDirect
//                 ?
//                 [
//                   <span style={{ marginLeft: 12 }}>Direct Purchased</span>,
//                   fmt(data.directExpenses),
//                   <span style={{ marginLeft: 12 }}></span>,
//                   "",
//                 ]:[],
//                 [
//                   <span style={{ fontWeight: 600 }}>
//                     Gross Profit b/f
//                     <p className="text-[8px] ">This include indirect expenses</p>
//                   </span>,
//                   fmt(data.netLoss),
//                   <span style={{ fontWeight: 600 }}>Gross Profit c/o</span>,
//                   <span style={{ fontWeight: 600 }}>
//                     {fmt(data.netLoss)}
//                     <br />
//                     {fmt(addvalue(data.sharesPurchased,data.directExpenses))}
//                   </span>,
//                 ],
              
//                 [
//                   <span style={{ fontWeight: 600 }}>Indirect Expenses</span>,
//                   fmt(
//                     data.interestExpenses
//                   ),
//                   <span style={{ fontWeight: 600 }}>Indirect Incomes</span>,
//                   fmt(data.indirectIncome),
//                 ],
//                 // calculationFormulasConfig?.indPurchaseIndirect
//                 // ?
//                 // [
//                 //   <span style={{ paddingLeft: 22, fontSize: "12px" }}>Indirect Charges</span>,
//                 //   <span style={{ paddingLeft: 22, fontSize: "12px" }}>  {fmt(data.purchasetosellindirectcharges)}</span>,
                
//                 //   <span style={{ paddingLeft: 22 }}></span>,
//                 //   <span style={{ paddingLeft: 22 }}></span>,
//                 //   { className: "" }
//                 // ]:[],
//                 // [
//                 //   <span style={{ paddingLeft: 22, fontSize: "12px" }}></span>,
//                 //   <span style={{ paddingLeft: 22, fontSize: "12px" }}></span>,
                
//                 //   <span style={{ paddingLeft: 22 }}>Dividend</span>,
//                 //   <span style={{ paddingLeft: 22 }}>{fmt(data.indirectIncome)}</span>,
//                 //   { className: "" }
//                 // ],
//                 // calculationFormulasConfig?.indPurchasedStockSale
//                 //   ? [
//                 //       <span style={{ paddingLeft: 22, fontSize: "12px" }}>Sales stock indirect charges</span>,
//                 //       <span style={{ paddingLeft: 0, fontSize: "12px" }}>{fmt(data.salesindirectcharges)}</span>,
//                 //       "",
//                 //       "",
//                 //       { className: "" }
//                 //     ]
//                 //   : [],
//                   calculationFormulasConfig?.indInterestCharges 
//                   ?
//                 [
//                   <span style={{ paddingLeft: 22, fontSize: "12px" }}>Interest Expenses</span>,
//                   <span style={{ paddingLeft: 22, fontSize: "12px" }}>{fmt(data.interestExpenses)}</span>,
//                   (() => {
//                     // Check for per-party profit/loss override in localStorage
//                     // Use party.id from data.party if available (otherwise skip localStorage check)
//                     let hasCustomPL = false;
//                     let partyId = party.id;
//                     if (partyId) {
//                       try {
//                         const lossDataRaw = localStorage.getItem("saved_party_Loss_data");
//                         const profitDataRaw = localStorage.getItem("saved_party_Profit_data");
//                         const lossData = lossDataRaw ? JSON.parse(lossDataRaw) : {};
//                         const profitData = profitDataRaw ? JSON.parse(profitDataRaw) : {};
//                         if (
//                           (lossData && Array.isArray(lossData[String(partyId)]) && lossData[String(partyId)].length > 0) ||
//                           (profitData && Array.isArray(profitData[String(partyId)]) && profitData[String(partyId)].length > 0)
//                         ) {
//                           hasCustomPL = true;
//                         }
//                       } catch (e) {
//                         // Ignore parse errors
//                       }
//                     }
//                     const netLossVal = parseFloat(String(data.netLoss).replace(/,/g, "")) || 0;
//                     let interestExpVal = 0;
//                     if (!hasCustomPL) {
//                       interestExpVal = parseFloat(String(data.interestExpenses).replace(/,/g, "")) || 0;
//                     }
//                     const result = netLossVal - interestExpVal;
//                     return (
//                       <span style={{ fontWeight: 600 }}>
//                         {result < 0 ? "Net Loss: " : "Net Profit: "}
//                       </span>
//                     );
//                   })(),
//                   (() => {
//                     // Check for per-party profit/loss override in localStorage
//                     let hasCustomPL = false;
//                     let partyId = party.id;
//                     if (partyId) {
//                       try {
//                         const lossDataRaw = localStorage.getItem("saved_party_Loss_data");
//                         const profitDataRaw = localStorage.getItem("saved_party_Profit_data");
//                         const lossData = lossDataRaw ? JSON.parse(lossDataRaw) : {};
//                         const profitData = profitDataRaw ? JSON.parse(profitDataRaw) : {};
//                         if (
//                           (lossData && Array.isArray(lossData[String(partyId)]) && lossData[String(partyId)].length > 0) ||
//                           (profitData && Array.isArray(profitData[String(partyId)]) && profitData[String(partyId)].length > 0)
//                         ) {
//                           hasCustomPL = true;
//                         }
//                       } catch (e) {
//                         // Ignore parse errors
//                       }
//                     }
//                     const netLossVal = parseFloat(String(data.netLoss).replace(/,/g, "")) || 0;
//                     let interestExpVal = 0;
//                     if (!hasCustomPL) {
//                       interestExpVal = parseFloat(String(data.interestExpenses).replace(/,/g, "")) || 0;
//                     }
//                     const result = netLossVal - interestExpVal;
//                     return (
//                       <span style={{ fontWeight: 600 }}>
//                         {fmt(result)}
//                       </span>
//                     );
//                   })(),
//                   { className: "" }
//                 ]:[],
//                 // [
//                 //   "",
//                 //   "",
//                 //   (() => {
//                 //     const netLossVal = parseFloat(String(data.netLoss).replace(/,/g, "")) || 0;
//                 //     const interestExpVal = parseFloat(String(data.interestExpenses).replace(/,/g, "")) || 0;
//                 //     const result = netLossVal - interestExpVal;
//                 //     return (
//                 //       <span style={{ fontWeight: 600 }}>
//                 //         {result < 0 ? "Net Loss: " : "Net Profit: "}
                        
//                 //       </span>
//                 //     );
//                 //   })(),
//                 //   (() => {
//                 //     const netLossVal = parseFloat(String(data.netLoss).replace(/,/g, "")) || 0;
//                 //     const interestExpVal = parseFloat(String(data.interestExpenses).replace(/,/g, "")) || 0;
//                 //     const result = netLossVal - interestExpVal;
//                 //     return (
//                 //       <span style={{ fontWeight: 600 }}>
                        
//                 //         {fmt(result)}
//                 //       </span>
//                 //     );
//                 //   })(),
//                 //   { className: "" }
//                 // ],
        
//               ].map((row, i) => {
//                 // row = [td1, td2, td3, td4, {className, style, hideBorders}?]
//                 const trProps = row[4] && typeof row[4] === "object" ? row[4] : {};
//                 const hideBorders = trProps.hideBorders;

//                 // For hidden rows, use className='hidden'
//                 let trClass = "";
//                 if (trProps.className) trClass = trProps.className;

//                 // For separation 'empty' rows (height), use no border and custom style
//                 const isEmptySeparation =
//                   hideBorders ||
//                   (typeof row[0] === "string" && row[0] === "" && typeof row[1] === "string" && row[1] === "");

//                 const tdStyleBase = isEmptySeparation
//                   ? { border: "none", height: 4 }
//                   : {};

//                 return (
//                   <tr key={i} className={trClass}>
//                     {/* 1st cell */}
//                     {renderCell(row[0], { style: { ...tdStyleBase } })}
//                     {/* 2nd cell - with borderRight */}
//                     {renderCell(row[1], {
//                       align: ["hidden"].includes(trClass) ? undefined : "right",
//                       style: {
//                         ...tdStyleBase,
//                         borderRight: isEmptySeparation ? undefined : "1px solid black"
//                       }
//                     })}
//                     {/* 3rd cell */}
//                     {renderCell(row[2], { style: { ...tdStyleBase } })}
//                     {/* 4th cell */}
//                     {renderCell(row[3], { align: ["hidden"].includes(trClass) ? undefined : "right", style: { ...tdStyleBase } })}
//                   </tr>
//                 );
//               })}

//               {/* Totals row with direct JS, as there are if/elses for partyClosingAmounts */}
//               <tr style={{ border: "1px solid #0000006e", borderLeft: "none", borderRight: "none" }}>
//                 {/* Instead of OutSourceClosingAmount, use partyClosingAmounts with party.id */}
//                 {renderCell(
//                   <span style={{ fontWeight: 700 }}>
//                     {partyClosingAmounts && partyClosingAmounts[String(party.id)] !== undefined
//                       ? <>
//                           Direct Closing Amount
//                           <span className="ml-2 text-xs text-[#1CAC70] font-bold hidden">
//                             {Number(partyClosingAmounts[String(party.id)]).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
//                           </span>
//                         </>
//                       : "Total"}
//                   </span>,
//                   { align: "center", style: { background: "#ffff" } }
//                 )}
//                 {/* 2nd cell, add borderRight */}
//                 {renderCell(
//                   partyClosingAmounts && partyClosingAmounts[String(party.id)] !== undefined
//                     ? fmt(
//                         (parseFloat(String(data.netLoss).replace(/,/g, "")) || 0) -
//                         (parseFloat(String(data.interestExpenses).replace(/,/g, "")) || 0)
//                       )
//                     : fmt(data.leftTotalPL),
//                   { bold: true, align: "right", style: { background: "#ffff", borderRight: "1px solid black" } }
//                 )}
//                 {renderCell(
//                   <span style={{ fontWeight: 700 }}>
//                     {partyClosingAmounts && partyClosingAmounts[String(party.id)] !== undefined
//                       ? <>
//                           Direct Closing Amount
//                           <span className="ml-2 text-xs text-[#1CAC70] font-bold hidden">
//                             {fmt(
//                               (Number(partyClosingAmounts[String(party.id)]) +"-"+ ((data.holdingamt))) +"+"+
//                               ((data.netLoss))
//                             )}
//                           </span>
//                         </>
//                       : "Total"}
//                   </span>,
//                   { align: "center", style: { background: "#ffff" } }
//                 )}
//                 {renderCell(
//                   partyClosingAmounts && partyClosingAmounts[String(party.id)] !== undefined
//                     ? fmt(
//                       (parseFloat(String(data.netLoss).replace(/,/g, "")) || 0) -
//                       (parseFloat(String(data.interestExpenses).replace(/,/g, "")) || 0)
//                     ) : fmt(data.rightTotalPL),
//                   { bold: true, align: "right", style: { background: "#ffff" } }
//                 )}
//               </tr>
//             </tbody>
//           </table>
//         </div>
        
//       </div>
//     );
//   }
//   function renderQTLYPerformanceModalContent(party: Party) {
//     const data = buildFinalSheetDataForParty(party);

//     // 1. DYNAMIC PERIODS: Generate from indexPriceHistory instead of hardcoding
//     // We sort by date ascending so the table reads left-to-right chronologically
//     const periods = [...indexPriceHistory]
//       .sort((a, b) => (a.date > b.date ? 1 : -1))
//       .map(record => {
//         // Format YYYY-MM-DD to DD.MM.YY for the label
//         const dateObj = new Date(record.date);
//         const day = String(dateObj.getDate()).padStart(2, '0');
//         const month = String(dateObj.getMonth() + 1).padStart(2, '0');
//         const year = String(dateObj.getFullYear()).slice(-2);

//         return {
//           label: `${day}.${month}.${year}`,
//           key: record.date,
//           sensex: record.sensexPrice || "---"
//         };
//       });

//     const fmt = (n: any, isPercent = false) =>
//       n == null || n === ""
//         ? "0.00"
//         : isPercent
//         ? (typeof n === "number" ? n.toFixed(2) : n) + "%"
//         : typeof n === "number"
//         ? n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
//         : n;

//     // We can only use what we have in data.raw: openingStock, purchases, sales, closingStock, grossProfit
//     // Use: GROSS PROFIT PERCENT = (grossProfit / purchases) * 100 (if purchases > 0)

//     const purchases = Number(data?.raw?.purchases ?? 0);
//     const grossProfit = Number(data?.raw?.grossProfit ?? 0);
//     const grossProfitPercent = purchases > 0 ? (grossProfit / purchases) * 100 : 0;

//     // 2. Data Rows: Mapping across the dynamic periods (use same value for all periods for this version)
//     const tables = [
//       {
//         header: `${farmForm.name}`,
//         main: `${party.name.toUpperCase()} START FROM ${new Date(party.date).toLocaleDateString('en-GB')} (Total Capital ${fmt(Number(party.total_amount))})`,
//         rows: [
//           { label: "GROSS PROFIT (%)", values: periods.map(() => grossProfitPercent), isPercent: true },
//           { label: "Less: interest charged by us", values: periods.map(() => -(interestPercentage ?? 0)), isPercent: true },
//           { 
//             label: `Our net profit After ${interestPercentage}% interest`, 
//             values: periods.map(() => grossProfitPercent - (interestPercentage ?? 0)), 
//             isPercent: true 
//           }
//         ]
//       }
//     ];

//     return (
//       <div style={{ background: "#fff", maxWidth: 1200, margin: "0 auto", padding: 24 }} id='qtlydata'>
//         <div style={{ fontWeight: 700, fontSize: 16, textAlign: "center", marginBottom: 15, letterSpacing: 2, textTransform: "uppercase" }}>
//           {/* Dynamic header showing the last available period date */}
//           AS ON {periods.length > 0 ? periods[periods.length - 1].label : "---"} (QTY/ PRINCIPAL/%)
//         </div>

//         {tables.map((block, ti) => (
//           <div key={ti} style={{ border: "1px solid #222", marginBottom: 24, borderRadius: 6, background: "#f9f9ff", overflow: "hidden" }}>
//             <div style={{ fontWeight: 700, fontSize: 18, padding: "10px 12px", background: "#efeefe", borderBottom: "1.5px solid #d1cdf4", color: "#6742c7" }}>
//               {block.header}
//             </div>
//             <div style={{ overflowX: "auto" }}>
//               <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                 <thead>
//                   <tr>
//                     <th style={{ minWidth: 350, background: "#f2f2f2", border: "1px solid #aaa", textAlign: "left", padding: "12px", fontSize: 14 }}>
//                       {block.main}
//                     </th>
//                     {periods.map((p) => (
//                       <th key={p.key} style={{ minWidth: 160, background: "#e9e6fd", border: "1px solid #aaa", textAlign: "center", padding: "8px 5px" }}>
//                         <div style={{ fontSize: "13px", fontWeight: 700 }}>{p.label}</div>
//                         <div style={{ fontSize: "11px", fontWeight: 400, color: "#555", marginTop: "2px" }}>
//                           (Sensex {p.sensex})
//                         </div>
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {block.rows.map((row, ri) => (
//                     <tr key={ri}>
//                       <td style={{ padding: "10px 12px", background: "#fff", border: "1px solid #aaa", fontWeight: 600, fontSize: 14, color: "#444" }}>
//                         {row.label}
//                       </td>
//                       {row.values.map((value, vi) => (
//                         <td key={vi} style={{ textAlign: "right", padding: "8px 10px", fontWeight: 500, fontSize: 13, background: vi % 2 === 1 ? "#f6f6fb" : "#fff", border: "1px solid #ccc" }}>
//                           {fmt(value, row.isPercent)}
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         ))}
//       </div>
//     );
//   }
//   function renderGLobalQTLYPerformanceModalContent(parties: any[]) {
//     // 1. DYNAMIC PERIODS: Generate from indexPriceHistory instead of hardcoding
//     // We sort by date ascending so the table reads left-to-right chronologically
//     const periods = [...indexPriceHistory]
//       .sort((a, b) => (a.date > b.date ? 1 : -1))
//       .map(record => {
//         // Format YYYY-MM-DD to DD.MM.YY for the label
//         const dateObj = new Date(record.date);
//         const day = String(dateObj.getDate()).padStart(2, '0');
//         const month = String(dateObj.getMonth() + 1).padStart(2, '0');
//         const year = String(dateObj.getFullYear()).slice(-2);
        
//         return {
//           label: `${day}.${month}.${year}`,
//           key: record.date,
//           sensex: record.sensexPrice || "---"
//         };
//       });

//     const fmt = (n: any, isPercent = false) =>
//       n == null || n === ""
//         ? "0.00"
//         : isPercent
//         ? (typeof n === "number" ? n.toFixed(2) : n) + "%"
//         : typeof n === "number"
//         ? n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
//         : n;

//     // For each party, generate the table block
//     const tables = parties.map((party: any) => {
//       const data = buildFinalSheetDataForParty(party);
//       const purchases = Number(data?.raw?.purchases ?? 0);
//       const grossProfit = Number(data?.raw?.grossProfit ?? 0);
//       const partyInterestPercentage = typeof party.interestPercentage !== "undefined" ? party.interestPercentage : interestPercentage;
//       const grossProfitPercent = purchases > 0 ? (grossProfit / purchases) * 100 : 0;

//       return {
//         header: `${farmForm.name}`,
//         main: `${party.name?.toUpperCase?.() || ""} START FROM ${party.date ? new Date(party.date).toLocaleDateString('en-GB') : "-"} (Total Capital ${fmt(Number(party.total_amount))})`,
//         rows: [
//           { label: "GROSS PROFIT (%)", values: periods.map(() => grossProfitPercent), isPercent: true },
//           { label: "Less: interest charged by us", values: periods.map(() => -(partyInterestPercentage ?? 0)), isPercent: true },
//           { 
//             label: `Our net profit After ${partyInterestPercentage}% interest`, 
//             values: periods.map(() => grossProfitPercent - (partyInterestPercentage ?? 0)), 
//             isPercent: true 
//           }
//         ]
//       };
//     });

//     return (
//       <div style={{ background: "#fff", maxWidth: 1200, margin: "0 auto", padding: 24 }}>
//         <div style={{ fontWeight: 700, fontSize: 16, textAlign: "center", marginBottom: 15, letterSpacing: 2, textTransform: "uppercase" }}>
//           {/* Dynamic header showing the last available period date */}
//           AS ON {periods.length > 0 ? periods[periods.length - 1].label : "---"} (QTY/ PRINCIPAL/%)
//         </div>

//         {tables.map((block, ti) => (
//           <div key={ti} style={{ border: "1px solid #222", marginBottom: 24, borderRadius: 6, background: "#f9f9ff", overflow: "hidden" }}>
//             <div style={{ fontWeight: 700, fontSize: 18, padding: "10px 12px", background: "#efeefe", borderBottom: "1.5px solid #d1cdf4", color: "#6742c7" }}>
//               {block.header}
//             </div>
//             <div style={{ overflowX: "auto" }}>
//               <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                 <thead>
//                   <tr>
//                     <th style={{ minWidth: 350, background: "#f2f2f2", border: "1px solid #aaa", textAlign: "left", padding: "12px", fontSize: 14 }}>
//                       {block.main}
//                     </th>
//                     {periods.map((p) => (
//                       <th key={p.key} style={{ minWidth: 160, background: "#e9e6fd", border: "1px solid #aaa", textAlign: "center", padding: "8px 5px" }}>
//                         <div style={{ fontSize: "13px", fontWeight: 700 }}>{p.label}</div>
//                         <div style={{ fontSize: "11px", fontWeight: 400, color: "#555", marginTop: "2px" }}>
//                           (Sensex {p.sensex})
//                         </div>
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {block.rows.map((row, ri) => (
//                     <tr key={ri}>
//                       <td style={{ padding: "10px 12px", background: "#fff", border: "1px solid #aaa", fontWeight: 600, fontSize: 14, color: "#444" }}>
//                         {row.label}
//                       </td>
//                       {row.values.map((value, vi) => (
//                         <td key={vi} style={{ textAlign: "right", padding: "8px 10px", fontWeight: 500, fontSize: 13, background: vi % 2 === 1 ? "#f6f6fb" : "#fff", border: "1px solid #ccc" }}>
//                           {fmt(value, row.isPercent)}
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         ))}
//       </div>
//     );
//   }

//   function renderBalanceSheetModalContent(party: Party) {
//     const balance = buildBalanceSheetDetailsForParty(party);
//     const headerLabel = dateTo
//       ? `(As at ${new Date(dateTo).toLocaleDateString()})`
//       : "select date range";
//     return (
//       <div style={{ background: "#fff" }} id='balancesheet'>
//         <h2 style={{ fontWeight: 700, color: "#6742c7", textAlign: "center", fontSize: 22 }} >
//          {farmForm.name}
//         </h2>
//         <div style={{ textAlign: "center", marginBottom: 8 }}>{farmForm.address}</div>
//         <h3 style={{
//           textAlign: 'center',
//           fontWeight: 700,
//           fontSize: 20,
//           margin: "18px 0 0 0"
//         }}>BALANCE SHEET</h3>
//         <div style={{ textAlign: 'center', color: "#666", marginBottom: 6 }}>
//           {headerLabel}
//         </div>
//         <div style={{ textAlign: 'center', color: "#6742c7", marginBottom: 5, fontWeight:"bold" }}>
//           Showing data for: {formatPeriod(dateFrom, dateTo)}
//         </div>

//         <div style={{ display: "flex", gap: 20, justifyContent: "center", alignItems: "flex-start" }}>
//           <div style={{ flex: 1, minWidth: 320 }}>
//             <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 9, color: "#6742c7" }}>LIABILITIES</div>
//             <table style={{ borderCollapse: 'collapse', width: "100%", fontSize: 14 }}>
//               <thead>
//                 <tr>
//                   <th className='border-y border-[#d0d5dd] ' style={{background: '#ffff' }}>Particulars</th>
//                   <th className='border-y border-[#d0d5dd] ' style={{background: '#ffff' }}>Amount (₹)</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {balance.liabilities.map((item, idx) =>
//                   item === null ? (
//                     <tr key={idx}><td colSpan={2} style={{ border: "none", height: "6px" }}></td></tr>
//                   ) : (
//                     <tr key={idx}>
//                       <td style={{fontWeight: String(item.label).includes("b>") ? 600 : 400 }}>
//                         {item.label}
//                       </td>
//                       <td style={{
//                         textAlign: 'right',
//                         fontWeight: String(item.label).includes("b>") ? 600 : 400,
//                         color: Number(item.amount) < 0 ? "#B91C1C" : undefined
//                       }}>
//                         {item.amount !== "" && item.amount !== undefined
//                           ? typeof item.amount === "string" ? item.amount : Number(item.amount).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
//                           : ""}
//                       </td>
//                     </tr>
//                   )
//                 )}
//               </tbody>
//             </table>
//           </div>
//           <div style={{ flex: 1, minWidth: 320 }}>
//             <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 9, color: "#6742c7" }}>ASSETS</div>
//             <table style={{ borderCollapse: 'collapse', width: "100%", fontSize: 14 }}>
//               <thead>
//                 <tr>
//                   <th className='border-y border-[#d0d5dd] ' style={{background: '#ffff' }}>Particulars</th>
//                   <th className='border-y border-[#d0d5dd] ' style={{background: '#ffff' }}>Amount (₹)</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {balance.assets.map((item, idx) =>
//                   item === null ? (
//                     <tr key={idx}><td colSpan={2} style={{ border: "none", height: "6px" }}></td></tr>
//                   ) : (
//                     <tr key={idx}>
//                       <td style={{fontWeight: String(item.label).includes("b>") ? 600 : 400 }}>
//                         {item.label}
//                       </td>
//                       <td style={{
                
//                         textAlign: 'right',
//                         fontWeight: String(item.label).includes("b>") ? 600 : 400
//                       }}>
//                         {item.amount !== "" && item.amount !== undefined
//                           ? typeof item.amount === "string" ? item.amount : Number(item.amount).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
//                           : ""}
//                       </td>
//                     </tr>
//                   )
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
        
//       </div>
//     );
//   }


//   // Source - https://stackoverflow.com/a/79163267
// // Posted by Flavio Wuensche
// // Retrieved 2026-03-16, License - CC BY-SA 4.0

// const onPrint = (boxid: string) => {
//   const box = document.getElementById(boxid);
//   if (!box) {
//     alert("Element to print not found.");
//     return;
//   }
//   const specific_element = box.innerHTML;
//   const original_elements = document.body.innerHTML;

//   document.body.innerHTML = specific_element;
//   window.print();


// };

//   const handlePrintDownloadFinal = () => {
//     if (!selectedParty) return;
//     const htmlString = `
//       <html>
//         <head>
//           <title>P&L Statement - ${selectedParty.name}</title>
//           <style>
//             body { font-family: Arial, sans-serif; background: #fff; color: #222; margin:40px 20px;}
//             h2 { color: #6742c7;}
//             th, td { border: 1px solid #d0d5dd; padding: 8px; font-size: 14px; }
//             th { background: #ffff; color: #6742c7;}
//             table { border-collapse: collapse; width: 100%; margin:14px 0;}
//             .akktitle {font-weight:700;color: #6742c7;text-align:center;font-size:22px;}
//           </style>
//         </head>
//         <body>
//           <div class="akktitle">${farmForm.name} NEW SHARES</div>
//           <div style="text-align:center;margin-bottom:8px">Jaipur</div>
//           <h3 style="text-align:center;font-weight:700;font-size:20px;margin:18px 0 4px 0;">PROFIT &amp; LOSS ACCOUNT</h3>
//           <div style="text-align:center;color:#666;margin-bottom:5px">${
//             (dateFrom || dateTo)
//               ? `(For the period${dateFrom ? " from " + new Date(dateFrom).toLocaleDateString() : ""}${dateTo ? " to " + new Date(dateTo).toLocaleDateString() : ""})`
//               : "(For the period from 1st April 2025 to 31st December 2025)"
//           }</div>
//           <div style="text-align:center;color:#6742c7;margin-bottom:5px;">Showing data for: ${formatPeriod(dateFrom, dateTo)}</div>
//           <!-- Trading Account Table -->
//           <div style="margin-top:25px;margin-bottom:4px;font-weight:600;font-size:17px">TRADING ACCOUNT</div>
//           ${renderPnLModalContent(selectedParty).props.children[5].props.children}
//           <!-- P&L Account Table -->
//           <div style="margin:32px 0 6px 0;font-weight:600;font-size:16px">PROFIT &amp; LOSS ACCOUNT</div>
//           ${renderPnLModalContent(selectedParty).props.children[7].props.children}
          
//         </body>
//       </html>
//     `;
//     const win = window.open("", "", "width=900,height=700");
//     if (!win) return;
//     win.document.write(htmlString);
//     win.document.close();
//   };

//   // Function to calculate the value of stocks NOT sold
// const calculateUnsoldStockValue = (partyId:any, allStocks:any, sellStocks:any) => {
//   let totalHoldingAmount = 0;

//   // 1. Get all purchases for this party
//   const partyPurchases = allStocks.filter((s:any) => String(s.party_id) === String(partyId));

//   partyPurchases.forEach((purchaseRow :any) => {
//     // Parse the categories array from the stock row
//     const categories = typeof purchaseRow.categories === 'string' 
//       ? JSON.parse(purchaseRow.categories) 
//       : purchaseRow.categories;

//     categories.forEach((stock:any) => {
//       // 2. Find how many units of THIS specific stock were sold
//       const salesForThisStock = sellStocks.filter((sale:any) => 
//         String(sale.party_id) === String(partyId) && 
//         sale.stock_name === stock.stock_name
//       );

//       const totalUnitsSold = salesForThisStock.reduce((sum:any, s:any) => sum + parseFloat(s.sell_units || 0), 0);
//       const totalUnitsPurchased = parseFloat(stock.unit || 0);

//       // 3. Calculate remaining units
//       const unitsNotSold = totalUnitsPurchased - totalUnitsSold;

//       if (unitsNotSold > 0) {
//         // Calculate the value based on purchase price
//         // (Alternatively, use current market price if you want "Market Value")
//         const purchasePricePerUnit = parseFloat(stock.perUnitCharge || 0);
//         totalHoldingAmount += (unitsNotSold * purchasePricePerUnit);
//       }
//     });
//   });

//   return totalHoldingAmount;
// };

//   const handlePrintDownloadBalance = () => {
//     if (!selectedParty) return;
//     const balanceHtml = renderBalanceSheetModalContent(selectedParty);
//     const htmlString = `
//       <html>
//         <head>
//           <title>BALANCE SHEET - ${selectedParty.name}</title>
//           <style>
//             body { font-family: Arial, sans-serif; background: #fff; color: #222; margin:40px 20px;}
//             h2 { color: #6742c7;}
//             th, td { border: 1px solid #d0d5dd; padding: 8px; font-size: 14px; }
//             th { background: #ffff; color: #6742c7;}
//             table { border-collapse: collapse; width: 100%; margin:14px 0;}
//             .akktitle {font-weight:700;color: #6742c7;text-align:center;font-size:22px;}
//           </style>
//         </head>
//         <body>
//           ${balanceHtml.props.children}
          
//         </body>
//       </html>
//     `;
//     const win = window.open("", "", "width=1000,height=800");
//     if (!win) return;
//     win.document.write(htmlString);
//     win.document.close();
//   };

//   useEffect(() => {
//     if (!showPartyModal) return;
//     const handler = (e: KeyboardEvent) => {
//       if (e.key === "Escape") setShowPartyModal(false);
//     };
//     window.addEventListener('keydown', handler);
//     return () => window.removeEventListener('keydown', handler);
//   }, [showPartyModal]);

//   const renderPartyModal = () => {
//     if (!selectedParty) return null;
//     const row = partyAggregatedRows.find(r => r.party.id === selectedParty.id);
//     if (!row) return null;
//     return (
//       <div className="fixed top-0 left-0 right-0 bottom-0 z-40 bg-black/40 flex items-center justify-center">
//         <div className="bg-white rounded-xl shadow-lg p-6 min-w-[350px] w-[96vw] max-w-5xl relative max-h-[90vh] overflow-auto print-page">
//           <button
//             className="absolute top-3 right-4 text-2xl text-gray-400 hover:text-gray-600"
//             onClick={() => setShowPartyModal(false)}
//             title="Close"
//           >&times;</button>
//           <h2 className="text-2xl font-bold mb-2 text-[#6742c7]">{row.party.name}</h2>
//           {renderDatePeriodBanner()}
//           <div className="mb-2 flex gap-2">
//             <button
//               className={`px-3 py-1 rounded font-semibold border text-sm ${
//                 partyModalSheet === "overall"
//                   ? "bg-[#6742c7] text-white border-[#6742c7]"
//                   : "bg-white text-[#6742c7] border-[#6742c7] hover:bg-[#F3F0FD]"
//               }`}
//               onClick={() => setPartyModalSheet("overall")}
//             >
//               Overall
//             </button>
//             <button
//               className={`px-3 py-1 rounded font-semibold border text-sm ${
//                 partyModalSheet === "final"
//                   ? "bg-[#6742c7] text-white border-[#6742c7]"
//                   : "bg-white text-[#6742c7] border-[#6742c7] hover:bg-[#F3F0FD]"
//               }`}
//               onClick={() => setPartyModalSheet("final")}
//             >
//               Final (P&amp;L)
//             </button>
//             <button
//               className={`px-3 py-1 rounded font-semibold border text-sm ${
//                 partyModalSheet === "balance"
//                   ? "bg-[#6742c7] text-white border-[#6742c7]"
//                   : "bg-white text-[#6742c7] border-[#6742c7] hover:bg-[#F3F0FD]"
//               }`}
//               onClick={() => setPartyModalSheet("balance")}
//             >
//               Balance Sheet
//             </button>
//             <button
//               className={`px-3 py-1 rounded font-semibold border text-sm ${
//                 partyModalSheet === "QTLY Performance"
//                   ? "bg-[#6742c7] text-white border-[#6742c7]"
//                   : "bg-white text-[#6742c7] border-[#6742c7] hover:bg-[#F3F0FD]"
//               }`}
//               onClick={() => setPartyModalSheet("QTLY Performance")}
//             >
//               QTLY Performance
//             </button>
//           </div>
//           {partyModalSheet === "overall" ? (
//             < >
//               {/* Party Summary Section - visually distinct cards for clarity */}
//               <div className="mb-8 grid gap-6 md:grid-cols-3" >
//                 {/* Contact Card */}
//                 <div className="bg-white rounded-2xl shadow border-l-4 border-[#7964e7] px-6 py-5 flex flex-col gap-2 hover:shadow-lg transition">
//                   <div className="font-medium text-[#7964e7] uppercase text-xs mb-2 tracking-widest">Contact</div>
//                   <div className="text-[16px] mb-1">
//                     <span className="block text-gray-700 font-semibold">{row.party.contact_person_name || <span className="italic text-gray-400">-</span>}</span>
//                     <span className="block text-gray-500">{row.party.contact_person_number || <span className="italic text-gray-400">-</span>}</span>
//                   </div>
//                 </div>
//                 {/* Opening/Remaining Card */}
//                 <div className="bg-white rounded-2xl shadow border-l-4 border-[#41c6c4] px-6 py-5 flex flex-col gap-2 hover:shadow-lg transition">
//                   <div className="font-medium text-[#41c6c4] uppercase text-xs mb-2 tracking-widest">Balance</div>
//                   <div className="text-gray-600">Opening</div>
//                   <div className="text-xl font-extrabold text-black mb-1">
//                     {row.party.total_amount !== undefined && row.party.total_amount !== null
//                       ? `₹${Number(row.party.total_amount).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
//                       : <span className="italic text-gray-400">-</span>}
//                   </div>
                  
//                 </div>
//                 {/* Totals Card */}
//                 <div className="bg-white rounded-2xl shadow border-l-4 border-[#ffa629] px-6 py-5 flex flex-col gap-2 hover:shadow-lg transition">
//                   <div className="font-medium text-[#ffa629] uppercase text-xs mb-2 tracking-widest">Summary</div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Purchased</span>
//                     <span className="font-bold text-black">
//                       {typeof row.total_purchased === "number"
//                         ? `₹${row.total_purchased.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
//                         : typeof row.total_purchased === "string" && !isNaN(Number(row.total_purchased))
//                           ? `₹${Number(row.total_purchased).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
//                           : row.total_purchased}
//                     </span>
//                   </div>
//                   <div className="flex justify-between hidden">
//                     <span className="text-gray-600">Profit&nbsp;/&nbsp;Loss</span>
//                     <span className="font-bold text-black">
//                       {(row.total_used - (row.total_indirect_charges + row.total_interest)) > 0
//                         ? `+${row.total_used - (row.total_indirect_charges + row.total_interest)}`
//                         : `${row.total_used - (row.total_indirect_charges + row.total_interest)}`}
                    
//                         {/* Show the sum of total_profit_and_loss for all stock records */}
//                         {row.stocks
//                           .flatMap(stock => stock.records)
//                           .reduce((sum, rec) => sum + (rec.total_profit_and_loss  || 0), 0)
//                         }
//                       {}
//                     </span>
//                   </div>
//                   {/* --- ADD Sell sales summary --- */}
//                   <div className="flex justify-between pt-2 border-t mt-2">
//                     <span className="text-gray-600">Total Sold Amount</span>
//                     <span className="font-bold text-black">
//                       {row.total_sales_amount !== undefined && row.total_sales_amount !== null && !isNaN(Number(row.total_sales_amount))
//                         ? `₹${Number(row.total_sales_amount).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
//                         : <span className="italic text-gray-400">-</span>
//                       }
//                     </span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Total Units Sold</span>
//                     <span className="font-bold text-black">{row.total_sales_units !== undefined ? row.total_sales_units : "-"}</span>
//                   </div>
//                 </div>
//               </div>

//               {/* ---- Withdrawal section for overall tab ---- */}
//               <div className="mb-12">
//                 {/* Withdrawals Header */}
//                 <div className="flex items-center gap-3 mb-2">
//                   <div className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-gradient-to-br from-[#ffe0b6] to-[#ffd5c0] shadow">
//                     <svg width="24" height="24" fill="none">
//                       <circle cx="12" cy="12" r="12" fill="#FFA873"/>
//                       <path d="M12 7v6m0 4v.01" stroke="#FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//                     </svg>
//                   </div>
//                   <h3 className="font-extrabold text-lg tracking-wide text-[#e65a23] drop-shadow" style={{ letterSpacing: ".4px"}}>
//                     Withdrawals
//                   </h3>
//                   <div className="flex-1 border-b border-dashed border-orange-200 ml-2" />
//                 </div>

//                 {row.withdrawals_details && row.withdrawals_details.length > 0 ? (
//                   <div className="overflow-x-auto bg-gradient-to-b from-[#FFFAF5]/[.55] to-[#fff]/80 border border-orange-100 rounded-3xl shadow-lg p-3 transition">
//                     <table className="min-w-[500px] w-full border-separate border-spacing-y-2 text-[15px]">
//                       <thead>
//                         <tr>
//                           <th className="px-3 py-2 text-left font-bold text-[#e76a28] uppercase bg-[#FFF1E4] rounded-tl-2xl">
//                             Date
//                           </th>
//                           <th className="px-3 py-2 text-right font-bold text-[#e76a28] uppercase bg-[#FFF1E4]">
//                             Amount
//                           </th>
//                           <th className="px-3 py-2 text-left font-bold text-[#e76a28] uppercase bg-[#FFF1E4] rounded-tr-2xl">
//                             Categories
//                           </th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {row.withdrawals_details.map((withdrawal) => {
//                           // Safely parse categories
//                           let categories: any[] = [];
//                           if (withdrawal.catrgories) {
//                             try {
//                               // catrgories: '["[{"category":"Equity","stockName":"IFCI LTD","stockId":2,"amount":"120000"}]"]'
//                               const arr = JSON.parse(withdrawal.catrgories);
//                               if (Array.isArray(arr) && arr.length > 0 && typeof arr[0] === "string") {
//                                 categories = JSON.parse(arr[0]);
//                                 if (!Array.isArray(categories)) categories = [categories];
//                               }
//                             } catch {}
//                           }

//                           return (
//                             <tr
//                               key={withdrawal.id}
//                               className={`shadow-[0_1px_4px_rgba(255,172,109,0.07)] bg-white rounded-xl transition-all`}
//                             >
//                               {/* Date */}
//                               <td className="px-3 py-2 font-medium text-orange-700 whitespace-nowrap rounded-l-xl align-top">
//                                 <span className="inline-block px-2 py-0.5 rounded-md bg-[#FFEDE2] text-xs font-semibold">
//                                   {withdrawal.date
//                                     ? new Date(withdrawal.date).toLocaleDateString("en-IN", {
//                                         year: "numeric",
//                                         month: "short",
//                                         day: "numeric",
//                                       })
//                                     : "-"}
//                                 </span>
//                               </td>
//                               {/* Amount */}
//                               <td className="px-3 py-2 font-bold text-[#dd661a] text-right align-top">
//                                 {withdrawal.amount !== undefined && withdrawal.amount !== null && !isNaN(Number(withdrawal.amount))
//                                   ? `₹${Number(withdrawal.amount).toLocaleString("en-IN", {
//                                       minimumFractionDigits: 2,
//                                       maximumFractionDigits: 2,
//                                     })}`
//                                   : <span className="italic text-gray-400">-</span>}
//                               </td>
//                               {/* Categories */}
//                               <td className="px-2 py-1 align-top rounded-r-xl bg-white">
//                                 <div className="rounded-xl border border-orange-100 overflow-hidden">
//                                   <table className="w-full text-[13px]">
//                                     <thead className="bg-orange-50 text-orange-600">
//                                       <tr>
//                                         <th className="px-3 py-1 text-left">Category</th>
//                                         <th className="px-3 py-1 text-left">Stock</th>
//                                         <th className="px-3 py-1 text-left">ID</th>
//                                         <th className="px-3 py-1 text-right">Amount</th>
//                                       </tr>
//                                     </thead>
//                                     <tbody>
//                                       {categories.length === 0 ? (
//                                         <tr>
//                                           <td colSpan={4} className="px-3 py-1 text-gray-500 italic text-center">
//                                             No categories
//                                           </td>
//                                         </tr>
//                                       ) : (
//                                         categories.map((cat, i) => (
//                                           <tr className="border-t" key={i}>
//                                             {/* Category */}
//                                             <td className="px-3 py-1">
//                                               <span className="px-2 py-0.5 text-xs rounded bg-orange-100 text-orange-600 font-semibold">
//                                                 {cat.category || '-'}
//                                               </span>
//                                             </td>
//                                             {/* Stock */}
//                                             <td className="px-3 py-1 font-medium text-gray-800">
//                                               {cat.stockName ?? '-'}
//                                             </td>
//                                             {/* ID */}
//                                             <td className="px-3 py-1 text-gray-400">
//                                               {cat.stockId ?? '-'}
//                                             </td>
//                                             {/* Amount */}
//                                             <td className="px-3 py-1 text-right font-bold text-green-600">
//                                               {cat.amount !== undefined && cat.amount !== null && !isNaN(Number(cat.amount))
//                                                 ? `₹${Number(cat.amount).toLocaleString("en-IN", {
//                                                     minimumFractionDigits: 2,
//                                                     maximumFractionDigits: 2,
//                                                   })}`
//                                                 : <span className="italic text-gray-400">-</span>}
//                                             </td>
//                                           </tr>
//                                         ))
//                                       )}
//                                     </tbody>
//                                   </table>
//                                 </div>
//                               </td>
//                             </tr>
//                           );
//                         })}
//                         {/* Total Row */}
//                         <tr className="bg-gradient-to-r from-[#fff2e4] to-[#ffe6cc] font-extrabold">
//                           <td className="px-3 py-2 text-right" colSpan={1}>
//                             Total Withdrawn:
//                           </td>
//                           <td className="px-3 py-2 text-[#e65a23] text-right">
//                             {
//                               "₹" + (
//                                 row.withdrawals_details
//                                   .reduce((sum, wd) => sum + (parseFloat(String(wd.amount)) || 0), 0
//                                   )
//                                 ).toLocaleString("en-IN", {
//                                   minimumFractionDigits: 2,
//                                   maximumFractionDigits: 2,
//                                 })
//                             }
//                           </td>
//                           <td></td>
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 ) : (
//                   <div className="p-7 text-center text-gray-400 italic bg-gradient-to-br from-[#f9ede2] via-[#fffaee] to-[#ffede4] rounded-2xl shadow-inner border border-dashed border-[#FFD9B2]/60">
//                     <div className="flex items-center justify-center mb-2">
//                       <svg width="36" height="36" fill="none"><circle cx="18" cy="18" r="18" fill="#FFE5C2"/><path d="M18 10v8m0 4v.01" stroke="#FFC785" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
//                     </div>
//                     No withdrawal records found for this party.
//                   </div>
//                 )}
//               </div>

//               <h3 className="font-bold text-[#6742c7] text-xl mb-5 mt-8 flex items-center gap-3">
//                 <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#F3F0FD]">
//                   <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 stroke-current text-[#6941C6]" fill="none" viewBox="0 0 24 24"><path d="M3 7V5a2 2 0 012-2h14a2 2 0 012 2v2m-18 0v10a2 2 0 002 2h2m-4-12h18m0 0v10a2 2 0 01-2 2h-2m-12 0h12" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/></svg>
//                 </span>
//                 Stocks (Details per Category)
//               </h3>
//               {/* ... Stocks Table Section unchanged ... */}
//               <div className="overflow-x-auto pb-3" style={{ maxHeight: "370px" }}>
//                 {row.stocks.length === 0 && (
//                   <div className="p-10 text-center text-gray-400 italic bg-white rounded-lg shadow-inner border">No stocks found for this party.</div>
//                 )}
//                 {row.stocks.map((s, i) => (
//                   <div
//                     key={s.stock_name + '-' + i}
//                     className="mb-8 last:mb-0 bg-gradient-to-tr from-[#ffff] to-[#FFF] rounded-2xl shadow overflow-hidden border border-[#f1ecff]"
//                   >
//                     <div className="flex justify-between items-center px-7 py-4 bg-[#6742c7] bg-opacity-80">
//                       <span className="font-bold text-white tracking-wide text-lg">{s.stock_name}</span>
//                     </div>
//                     <div className="overflow-x-auto">
//                       <table className="w-full text-[14px] mt-0 border-separate border-spacing-y-1">
//                         <thead className="bg-[#ece6fa] sticky top-0 z-10">
//                           <tr>
//                             <th className="p-3 font-semibold text-[#6742c7] border-b border-[#eee] text-center">Category</th>
//                             <th className="p-3 font-semibold text-[#6742c7] border-b border-[#eee] text-center">Unit</th>
//                             <th className="p-3 font-semibold text-[#6742c7] border-b border-[#eee] text-center">Purchase Date</th>
//                             <th className="p-3 font-semibold text-[#6742c7] border-b border-[#eee] text-center">Purchase Amt</th>
//                             <th className="p-3 font-semibold text-[#6742c7] border-b border-[#eee] text-center">Indirect Charges</th>
//                             <th className="p-3 font-semibold text-[#6742c7] border-b border-[#eee] text-center">History</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {s.records.map((rec, ridx) => {
//                             // History Less/More expanded state using closure per record
//                             const HistoryComponent = (() => {
//                               const [page, setPage] = React.useState(0);
//                               const MAX_ROWS = 1;
//                               const shown = rec.update_history.slice(0, (page + 1) * MAX_ROWS);
//                               const canShowMore = rec.update_history.length > shown.length;
//                               const canShowLess = page > 0;

//                               return (
//                                 <div>
//                                   <table className="min-w-[270px] w-full border bg-white rounded shadow-inner mb-1">
//                                     <thead className="bg-[#ffff]">
//                                       <tr>
//                                         <th className="px-2 py-1 text-xs text-[#6941C6] font-semibold border-b border-[#eee]">Date</th>
//                                         <th className="px-2 py-1 text-xs text-[#6941C6] font-semibold border-b border-[#eee]">Amount</th>
//                                         <th className="px-2 py-1 text-xs text-[#6941C6] font-semibold border-b border-[#eee]">Indirect Income</th>
//                                         <th className="px-2 py-1 text-xs text-[#6941C6] font-semibold border-b border-[#eee]">P/L</th>
//                                       </tr>
//                                     </thead>
//                                     <tbody>
//                                       {shown.map((up, idx) => (
//                                         <tr key={idx} className="odd:bg-[#f6f1ff] text-center">
//                                           <td className="px-2 py-1">{up.date ? new Date(up.date).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' }) : "-"}</td>
//                                           <td className="px-2 py-1">
//                                             {typeof up.current_amount === "number" || !isNaN(Number(up.current_amount))
//                                               ? `₹${Number(up.current_amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
//                                               : up.current_amount}
//                                           </td>
//                                           <td className="px-2 py-1">
//                                             {typeof up.dividend === "number" || !isNaN(Number(up.dividend))
//                                               ? `₹${Number(up.dividend).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
//                                               : up.dividend}
//                                           </td>
//                                           <td className={`px-2 py-1 font-semibold ${up.profitAndLoss >= 0 ? "text-green-600" : "text-red-500"}`}>
//                                             {typeof up.profitAndLoss === "number" || !isNaN(Number(up.profitAndLoss))
//                                               ? `₹${Number(up.profitAndLoss).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
//                                               : up.profitAndLoss}
//                                           </td>
//                                         </tr>
//                                       ))}
//                                     </tbody>
//                                   </table>
//                                   <div className="flex gap-2 mb-1.5">
//                                     {canShowLess && (
//                                       <button
//                                         className="text-xs px-2 py-1 bg-[#e9e3ff] rounded-lg font-medium text-[#6742c7] outline-none hover:bg-[#d6caff] transition"
//                                         onClick={() => setPage(page - 1)}
//                                       >
//                                         Less
//                                       </button>
//                                     )}
//                                     {canShowMore && (
//                                       <button
//                                         className="text-xs px-2 py-1 bg-[#e9e3ff] rounded-lg font-medium text-[#6742c7] outline-none hover:bg-[#d6caff] transition"
//                                         onClick={() => setPage(page + 1)}
//                                       >
//                                         More
//                                       </button>
//                                     )}
//                                   </div>
//                                 </div>
//                               );
//                             });

//                             return (
//                               <tr
//                                 key={ridx}
//                                 className="bg-white hover:bg-[#f8f6ff] rounded-[12px] text-center shadow transition"
//                               >
//                                 <td className="p-3">{rec.category}</td>
//                                 <td className="p-3">{rec.unit}</td>
//                                 <td className="p-3">{rec.date_of_purchase ? new Date(rec.date_of_purchase).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' }) : "-"}</td>
//                                 <td className="p-3">
//                                   {typeof rec.opening_balance === "number" || !isNaN(Number(rec.opening_balance))
//                                     ? `₹${Number(rec.opening_balance).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
//                                     : rec.opening_balance}
//                                 </td>
//                                 <td className="p-3">
//                                   {typeof rec.indirect_charges === "number" || !isNaN(Number(rec.indirect_charges))
//                                     ? `₹${Number(rec.indirect_charges).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
//                                     : rec.indirect_charges}
//                                 </td>
//                                 <td className="p-3">
//                                   {rec.update_history.length === 0
//                                     ? <span className="text-gray-400 italic">No updates</span>
//                                     : <HistoryComponent />}
//                                 </td>
//                               </tr>
//                             );
//                           })}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 ))}
//               </div>


//             </>
//           ) : partyModalSheet === "final" ? (
//             <>
//               {renderPnLModalContent(row.party)}
//               <div className="flex justify-end gap-3 mt-6">
//                 <button
//                   className=" px-4 py-2 text-sm bg-[#6742c7] text-white font-bold rounded hover:bg-[#442293]"
//                   onClick={() => onPrint('renderpnl')}
//                 >
//                   Print/Download
//                 </button>
//               </div>
//             </>
//           ) :partyModalSheet === "QTLY Performance" ? (
//             <>
//               {renderQTLYPerformanceModalContent(row.party)}
              
//               <div className="flex justify-end gap-3 mt-6">
//                 <button
//                   className="px-4 py-2 text-sm bg-[#6742c7] text-white font-bold rounded hover:bg-[#442293]"
//                   onClick={() => onPrint('qtlydata')}
//                 >
//                   Print/Download
//                 </button>
//               </div>
//             </>
//           ) :(
//             <>
//               {renderBalanceSheetModalContent(row.party)}
//               <div className="flex justify-end gap-3 mt-6">
//                 <button
//                   className="px-4 py-2 text-sm bg-[#6742c7] text-white font-bold rounded hover:bg-[#442293]"
//                   onClick={() => onPrint('balancesheet')}
//                 >
//                   Print/Download
//                 </button>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     );
//   };
//   // ...rest of render function (balance sheet table, list table, etc, unchanged) ...

//   return (
//     <div
//       className="p-6 min-h-screen"
//       style={{
//         background: "linear-gradient(120deg, #f8fefb 0%, #e5f9f2 100%, #b0e4cc22 140%)",
//       }}
//     >
//       {renderGlobalFilterPanel()}
//       {showPartyModal && renderPartyModal()}

//       {/* Closing amount modal for per-party entry (after View button) */}
//       {showClosingAmountModal.open && (
//         <div className="fixed inset-0 z-50 bg-[#09141311] flex items-center justify-center">
//           <div className="relative rounded-xl shadow-lg p-6 w-[95vw] max-w-sm border-2 border-[#408A71] bg-gradient-to-br from-[#f7fff7] via-[#b0e4cc70] to-[#fff]">
//             <button
//               className="absolute top-2 right-3 text-2xl text-[#285A48] hover:text-[#408A71]"
//               title="Close"
//               onClick={() => setShowClosingAmountModal({ open: false })}
//             >
//               &times;
//             </button>
//             <h3 className="text-xl font-bold mb-3 text-[#285A48]">Set Closing Amount</h3>
//             <input
//               type="number"
//               className="border-2 border-[#B0E4CC] focus:border-[#408A71] px-3 py-2 rounded-lg w-full mb-4 text-[#091413] bg-[#ffffff]"
//               placeholder="Enter amount"
//               value={closingAmountInput}
//               onChange={e => {
//                 setClosingAmountInput(e.target.value);
//               }}
//             />
//             <div className="flex gap-2 justify-end">
//               <button
//                 className="px-3 py-1.5 rounded-lg bg-[#fff] hover:bg-[#e5f9f2] text-[#285a48] border border-[#b0e4cc] font-semibold"
//                 onClick={() => setShowClosingAmountModal({ open: false })}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="px-3 py-1.5 rounded-lg bg-[#408A71] hover:bg-[#285A48] text-white font-semibold shadow transition"
//                 onClick={() => {
//                   if (showClosingAmountModal.partyId) {
//                     if (closingAmountInput === "") {
//                     } else {
//                       setPartyClosingAmounts(prev => ({
//                         ...prev,
//                         [showClosingAmountModal.partyId!]: Number(closingAmountInput)
//                       }));
//                     }
//                   }
//                   setShowClosingAmountModal({ open: false });
//                 }}
//               >
//                 Save
//               </button>
//               <button
//                 className="px-3 py-1.5 rounded-lg bg-[#CB1C38] hover:bg-[#A6242B] text-white font-semibold"
//                 onClick={() => {
//                   if (showClosingAmountModal.partyId) {
//                     setPartyClosingAmounts(prev => {
//                       const copy = { ...prev };
//                       delete copy[showClosingAmountModal.partyId!];
//                       return copy;
//                     });
//                   }
//                   setShowClosingAmountModal({ open: false });
//                 }}
//               >
//                 Remove
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {showLossAmountModal.open && (
//         <div className="fixed inset-0 z-50 bg-[#09141311] flex items-center justify-center">
//           <div className="relative rounded-xl shadow-lg p-6 w-[95vw] max-w-sm border-2 border-[#408A71] bg-gradient-to-br from-[#fcf8ff] via-[#e5f9f2] to-[#ffffff]">
//             <button
//               className="absolute top-2 right-3 text-2xl text-[#285A48] hover:text-[#408A71]"
//               title="Close"
//               onClick={() => setShowLossAmountModal({ open: false })}
//             >
//               &times;
//             </button>
//             <h3 className="text-xl font-bold mb-3 text-[#285A48]">Set Loss Amount</h3>
//             <input
//               type="number"
//               className="border-2 border-[#B0E4CC] focus:border-[#408A71] px-3 py-2 rounded-lg w-full mb-4 text-[#091413] bg-[#fff]"
//               placeholder="Enter amount"
//               value={lossAmountInput}
//               onChange={e => {
//                 setLossAmountInput(e.target.value);
//               }}
//             />
//             <div className="flex gap-2 justify-end">
//               <button
//                 className="px-3 py-1.5 rounded-lg bg-[#fff] hover:bg-[#e5f9f2] text-[#285a48] border border-[#b0e4cc] font-semibold"
//                 onClick={() => setShowLossAmountModal({ open: false })}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="px-3 py-1.5 rounded-lg bg-[#408A71] hover:bg-[#285A48] text-white font-semibold shadow transition"
//                 onClick={() => {
//                   if (showLossAmountModal.partyId) {
//                     if (lossAmountInput === "") {
//                     } else {
//                       setPartyLossAmounts(prev => ({
//                         ...prev,
//                         [showLossAmountModal.partyId!]: Number(lossAmountInput)
//                       }));
//                     }
//                   }
//                   setShowLossAmountModal({ open: false });
//                 }}
//               >
//                 Save
//               </button>
//               <button
//                 className="px-3 py-1.5 rounded-lg bg-[#CB1C38] hover:bg-[#A6242B] text-white font-semibold"
//                 onClick={() => {
//                   if (showLossAmountModal.partyId) {
//                     setPartyLossAmounts(prev => {
//                       const copy = { ...prev };
//                       delete copy[showLossAmountModal.partyId!];
//                       return copy;
//                     });
//                   }
//                   setShowLossAmountModal({ open: false });
//                 }}
//               >
//                 Remove
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {showProfitAmountModal.open && (
//         <div className="fixed inset-0 z-50 bg-[#09141311] flex items-center justify-center">
//           <div className="relative rounded-xl shadow-lg p-6 w-[95vw] max-w-sm border-2 border-[#408A71] bg-gradient-to-br from-[#fff] via-[#e5f9f2] to-[#b0e4cc70]">
//             <button
//               className="absolute top-2 right-3 text-2xl text-[#285A48] hover:text-[#408A71]"
//               title="Close"
//               onClick={() => setShowProfitAmountModal({ open: false })}
//             >
//               &times;
//             </button>
//             <h3 className="text-xl font-bold mb-3 text-[#285A48]">Set Profit Amount</h3>
//             <input
//               type="number"
//               className="border-2 border-[#B0E4CC] focus:border-[#408A71] px-3 py-2 rounded-lg w-full mb-4 text-[#091413] bg-[#fff]"
//               placeholder="Enter amount"
//               value={profitAmountInput}
//               onChange={e => {
//                 setProfitAmountInput(e.target.value);
//               }}
//             />
//             <div className="flex gap-2 justify-end">
//               <button
//                 className="px-3 py-1.5 rounded-lg bg-[#fff] hover:bg-[#e5f9f2] text-[#285a48] border border-[#b0e4cc] font-semibold"
//                 onClick={() => setShowProfitAmountModal({ open: false })}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="px-3 py-1.5 rounded-lg bg-[#408A71] hover:bg-[#285A48] text-white font-semibold shadow transition"
//                 onClick={() => {
//                   if (showProfitAmountModal.partyId) {
//                     if (profitAmountInput === "") {
//                     } else {
//                       setPartyProfitAmounts(prev => ({
//                         ...prev,
//                         [showProfitAmountModal.partyId!]: Number(profitAmountInput)
//                       }));
//                     }
//                   }
//                   setShowProfitAmountModal({ open: false });
//                 }}
//               >
//                 Save
//               </button>
//               <button
//                 className="px-3 py-1.5 rounded-lg bg-[#CB1C38] hover:bg-[#A6242B] text-white font-semibold"
//                 onClick={() => {
//                   if (showProfitAmountModal.partyId) {
//                     setPartyProfitAmounts(prev => {
//                       const copy = { ...prev };
//                       delete copy[showProfitAmountModal.partyId!];
//                       return copy;
//                     });
//                   }
//                   setShowProfitAmountModal({ open: false });
//                 }}
//               >
//                 Remove
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {showCommisionAndExpensesAmountModal.open && (
//         <div className="fixed inset-0 z-50 bg-[#09141311] flex items-center justify-center">
//           <div className="relative rounded-xl shadow-lg p-6 w-[95vw] max-w-sm border-2 border-[#408A71] bg-gradient-to-br from-[#fff] via-[#e5f9f2] to-[#b0e4cc22]">
//             <button
//               className="absolute top-2 right-3 text-2xl text-[#285A48] hover:text-[#408A71]"
//               title="Close"
//               onClick={() => setShowCommisionAndExpensesAmountModal({ open: false })}
//             >
//               &times;
//             </button>
//             <h3 className="text-xl font-bold mb-3 text-[#285A48]">Set Commission Amount</h3>
//             <input
//               type="number"
//               className="border-2 border-[#B0E4CC] focus:border-[#408A71] px-3 py-2 rounded-lg w-full mb-4 text-[#091413] bg-[#fff]"
//               placeholder="Enter amount"
//               value={commisionAmountInput}
//               onChange={e => {
//                 setCommisionAmountInput(e.target.value);
//               }}
//             />
//             <div className="flex gap-2 justify-end">
//               <button
//                 className="px-3 py-1.5 rounded-lg bg-[#fff] hover:bg-[#e5f9f2] text-[#285a48] border border-[#b0e4cc] font-semibold"
//                 onClick={() => setShowCommisionAndExpensesAmountModal({ open: false })}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="px-3 py-1.5 rounded-lg bg-[#408A71] hover:bg-[#285A48] text-white font-semibold shadow transition"
//                 onClick={() => {
//                   if (showCommisionAndExpensesAmountModal.partyId) {
//                     if (commisionAmountInput === "") {
//                     } else {
//                       setPartyCommisionAmounts(prev => ({
//                         ...prev,
//                         [showCommisionAndExpensesAmountModal.partyId!]: Number(commisionAmountInput)
//                       }));
//                     }
//                   }
//                   setShowCommisionAndExpensesAmountModal({ open: false });
//                 }}
//               >
//                 Save
//               </button>
//               <button
//                 className="px-3 py-1.5 rounded-lg bg-[#CB1C38] hover:bg-[#A6242B] text-white font-semibold"
//                 onClick={() => {
//                   if (showCommisionAndExpensesAmountModal.partyId) {
//                     setPartyCommisionAmounts(prev => {
//                       const copy = { ...prev };
//                       delete copy[showCommisionAndExpensesAmountModal.partyId!];
//                       return copy;
//                     });
//                   }
//                   setShowCommisionAndExpensesAmountModal({ open: false });
//                 }}
//               >
//                 Remove
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Header */}
//       <div className="w-full mb-6">
//         <div className="flex flex-wrap justify-between items-center w-full">
//           <div className="flex items-center gap-4">
//             <h1 className="text-[30px] font-extrabold text-[#091413] drop-shadow-sm">
//               <span style={{ color: "#285A48" }}>Custom Party</span>{' '}
//               <span style={{ color: "#408A71" }}>Balance Sheet</span>
//             </h1>
//             <div className="bg-[#b0e4cc] px-4 py-1 rounded-[24px] border border-[#285A48] shadow">
//               <span className="text-[#091413] text-[13px] font-bold">
//                 {parties.length} vendors
//               </span>
//             </div>
//           </div>
//           <div className="flex flex-wrap gap-2 items-center mt-2">
//             <button
//               className={`px-3 py-1.5 rounded-xl font-semibold border text-sm shadow ${
//                 partyModalSheet === "QTLY Performance"
//                   ? "bg-[#285A48] text-white border-[#285A48]"
//                   : "bg-[#b0e4cc] text-[#091413] hover:bg-[#408A71] hover:text-white border-[#285A48]"
//               }`}
//               onClick={() => setGlobalQtly(true)}
//             >
//               QTLY Performance
//             </button>
//             {globalQTLY && (
//               <div className="fixed inset-0 z-50 bg-[#09141311] flex items-center justify-center">
//                 <div className="relative bg-white rounded-xl shadow-lg p-6 min-w-[350px] w-[96vw] max-w-5xl max-h-[90vh] overflow-auto border-2 border-[#408A71]">
//                   <button
//                     className="absolute top-3 right-4 text-2xl text-[#285A48] hover:text-[#408A71]"
//                     onClick={() => setGlobalQtly(false)}
//                     title="Close"
//                   >
//                     &times;
//                   </button>
//                   {renderGLobalQTLYPerformanceModalContent(parties)}
//                 </div>
//               </div>
//             )}
//             <button
//               className="flex items-center gap-1 border border-[#408A71] bg-[#B0E4CC] py-2 px-5 rounded-lg text-[#285A48] font-semibold shadow hover:bg-[#285a48] hover:text-white hover:border-[#285a48] transition"
//               onClick={() => setShowFilterPanel(true)}
//             >
//               <FaFilter /> Filter
//             </button>
//             <button
//               className="flex items-center gap-1 border border-[#B0E4CC] bg-[#B0E4CC] py-2 px-5 rounded-lg text-[#091413] font-semibold shadow hover:bg-[#408A71] hover:text-white hover:border-[#408A71] transition"
//               onClick={handleImportClick}
//             >
//               <BiImport /> Import
//             </button>
//             <input
//               ref={fileInputRef}
//               type="file"
//               accept=".csv"
//               style={{ display: "none" }}
//               onChange={handleFileChange}
//             />
//             <button
//               className="flex items-center gap-1 border-[1.5px] border-[#408A71] bg-[#fff] py-2 px-5 rounded-lg text-[#408A71] font-bold shadow hover:bg-[#B0E4CC] hover:border-[#285A48] hover:text-[#285A48] transition"
//               onClick={handleExportCSV}
//             >
//               Export CSV
//             </button>
//           </div>
//         </div>
//         <span className="block mt-3 text-[#285A48] text-[15px] font-medium bg-[#b0e4cc1a] px-3 py-2 rounded shadow-inner">
//           Check purchase, usage (return), and earning summary per party.{" "}
//           <span className="font-bold text-[#091413]">Use</span> the eye icon to see all stock history and a downloadable/printable statement across all purchases and updates.
//         </span>
//       </div>
//       {renderDatePeriodBanner()}

//       {/* Search/Banner */}
//       <div className="flex justify-between w-full mt-5">
//         <div className="w-[40%] bg-[#e5f9f2] h-[42px] flex items-center rounded-lg px-3 border-2 border-[#B0E4CC] gap-2 shadow">
//           <CiSearch className="text-[#091413] text-[22px]" />
//           <input
//             type="text"
//             placeholder="Search party name..."
//             className="w-full bg-transparent h-[34px] focus:outline-none text-[#091413] placeholder:text-[#285A48] font-medium"
//             value={search}
//             onChange={e => { setSearch(e.target.value); setPage(1); }}
//           />
//         </div>
//         <div className="bg-[#f0f4ff] p-2 rounded-md border border-[#d0d9f5] flex flex-row flex-wrap gap-2 items-center mb-3 w-auto shadow-sm">
//           <div className="flex flex-col gap-0 min-w-[90px]">
//             <label className="text-[10px] font-semibold text-[#4c66a4] uppercase tracking-wider mb-0">
//               Interest From
//             </label>
//             <span className="text-[10px] text-[#4c66a4] opacity-80 leading-tight">
//               (from party add)
//             </span>
//           </div>
//           <div className="flex flex-col gap-0 min-w-[90px]">
//             <label className="text-[10px] font-semibold text-[#4c66a4] uppercase tracking-wider mb-0">
//               Interest To
//             </label>
//             <input
//               type="date"
//               className="border rounded px-2 py-[4px] text-xs focus:ring-1 focus:ring-[#4c66a4] transition outline-none bg-white min-w-[110px]"
//               value={interestDateTo}
//               onChange={e => setInterestDateTo(e.target.value)}
//               placeholder="End date"
//             />
//           </div>
//           <button
//             className="px-2 py-[4px] bg-[#ffffff] text-[#4c66a4] border border-[#b5c5e3] rounded-md text-[10px] font-bold hover:bg-[#e3ecfb] transition leading-tight"
//             style={{height:'27px'}}
//             onClick={() => {setInterestDateTo(''); }}
//             title="Clear date"
//           >
//             Reset
//           </button>
          
//         </div>
     
//       <div className="flex gap-3 hidden">
//   <button 
//     onClick={() => setEntryModal({ isOpen: true, type: 'Closing', partyId: partyIdFromUrl || '' })}
//     className="flex items-center gap-1 border border-[#8d8df3] bg-[#ebebfc] py-2 px-5 rounded-lg text-[#24246a] font-semibold shadow hover:bg-[#8d8df3] hover:text-white"
//   >
//     Closing Amount
//   </button>
//   {/* Repeat for Loss, Profit, Sale, Commission/exp */}
//   <button
//   onClick={() => setEntryModal({ isOpen: true, type: 'Loss', partyId: partyIdFromUrl || '' })}
//           className="flex items-center gap-1 border border-[#FFB4A5] bg-[#FFEFEC] py-2 px-5 rounded-lg text-[#BF3636] font-semibold shadow hover:bg-[#FFB4A5] hover:text-white hover:border-[#BF3636] transition"
//           type="button"
//         >
//           Loss Amount
//         </button>
//         <button
//         onClick={() => setEntryModal({ isOpen: true, type: 'Profit', partyId: partyIdFromUrl || '' })}
//           className="flex items-center gap-1 border border-[#A5DB8C] bg-[#F3FCEA] py-2 px-5 rounded-lg text-[#37762A] font-semibold shadow hover:bg-[#A5DB8C] hover:text-white hover:border-[#37762A] transition"
//           type="button"
//         >
//           Profit Amount
//         </button>
//         <button
//         onClick={() => setEntryModal({ isOpen: true, type: 'Sale', partyId: partyIdFromUrl || '' })}
//           className="flex items-center gap-1 border border-[#B0E4CC] bg-[#fff7ee] py-2 px-5 rounded-lg text-[#ae793c] font-semibold shadow hover:bg-[#B0E4CC] hover:text-white hover:border-[#ae793c] transition"
//           type="button"
//         >
//           Sale Amount
//         </button>
//         <button
//          onClick={() => setEntryModal({ isOpen: true, type: 'Commission', partyId: partyIdFromUrl || '' })}
//           className="flex items-center gap-1 border border-[#c6b8ff] bg-[#f3eefb] py-2 px-5 rounded-lg text-[#6842c7] font-semibold shadow hover:bg-[#c6b8ff] hover:text-white hover:border-[#6842c7] transition"
//           type="button"
//         >
//           Commision
//         </button>
//         <button
//          onClick={() => setEntryModal({ isOpen: true, type: 'Expenses', partyId: partyIdFromUrl || '' })}
//           className="flex items-center gap-1 border border-[#c6b8ff] bg-[#f3eefb] py-2 px-5 rounded-lg text-[#6842c7] font-semibold shadow hover:bg-[#c6b8ff] hover:text-white hover:border-[#6842c7] transition"
//           type="button"
//         >
//           Expenses
//         </button>
// </div>

// {/* Conditional Rendering of Popups */}
// {entryModal.isOpen && entryModal.type !== 'Sale' && (
//   <MultiEntryForm 
//     type={entryModal.type}
//     partyId={entryModal.partyId}
//     records={
//       entryModal.type === 'Closing' ? partyClosingRecords :
//       entryModal.type === 'Loss' ? partyLossRecords :
//       entryModal.type === 'Profit' ? partyProfitRecords :
//       entryModal.type === 'Expenses'? partyExpnsesRecords : partyCommisionRecords
//     }
//     parties={parties}
//     onClose={() => setEntryModal({ ...entryModal, isOpen: false })}
//     onSave={(pid: string, data: any) => {
//         // Update the specific state based on entryModal.type
//         // Then close modal
//         setEntryModal({ ...entryModal, isOpen: false });
//     }}
//   />
// )}

// {entryModal.isOpen && entryModal.type === 'Sale' && (
//     <SaleEntryForm 
//     partyId={entryModal.partyId}
//     stocks={stocks} // Pass all stocks so it can filter
//     records={partySaleRecords} // Pass the "old data"
//     parties={parties}
//     onClose={() => setEntryModal({ ...entryModal, isOpen: false })}
//     onSave={(type: string, pid: string, data: any) => {
//       setPartySaleRecords(prev => ({ ...prev, [pid]: data }));
//       localStorage.setItem('saved_party_Sale_data', JSON.stringify({ ...partySaleRecords, [pid]: data }));
//       setEntryModal({ ...entryModal, isOpen: false });
//     }}
//   />
// )}
//       </div>
//       {/* Table */}
//       <div className="max-w-full overflow-x-auto border-2 border-[#B0E4CC] bg-[#ffffffcc] mt-6 rounded-2xl shadow-xl">
//         <table className="w-full max-w-full border-collapse table-auto rounded-2xl overflow-hidden">
//           <thead
//             className="bg-gradient-to-r from-[#f7fffb] via-[#b0e4cc55] to-[#e5f9f2]"
//           >
//             <tr>
//               <th className="px-3 py-3 text-left text-[15px] font-bold text-[#091413] border-b border-[#b0e4cc] whitespace-nowrap relative shadow">
//                 <div className="flex items-center gap-1">
//                   Party Name
//                   <div className="inline-block relative">
//                     <button
//                       type="button"
//                       onClick={e => {
//                         e.stopPropagation();
//                         setOpenFilterDropdown(openFilterDropdown === 'party_name' ? null : 'party_name');
//                       }}
//                       className={`ml-1 text-[#285A48] hover:text-[#408A71] p-0.5 rounded-full bg-white border border-[#b0e4cc] ${openFilterDropdown === 'party_name' ? 'ring-2 ring-[#408A71]/30' : ''}`}
//                       aria-label="Filter Party Name"
//                     >
//                       <FaFilter
//                         size={14}
//                         className={filters["party_name"] ? "text-[#408A71]" : "text-[#285A48]"}
//                       />
//                     </button>
//                     {openFilterDropdown === "party_name" && (
//                       <div className="dropdown-filter-pop absolute left-0 top-7 min-w-[160px] bg-white border border-[#b0e4cc] shadow-lg z-[9] p-3 rounded-lg">
//                         <div className="mb-2 text-xs text-[#285A48] font-bold pb-1 border-b border-[#b0e4cc]">
//                           Party Name
//                         </div>
//                         {uniqueColumnValues["party_name"] && uniqueColumnValues["party_name"].length > 0 ? (
//                           <ul className="max-h-[220px] overflow-y-auto">
//                             <li>
//                               <button
//                                 className={`w-full text-left px-2 py-1 rounded hover:bg-[#b0e4cc33] text-xs ${!filters["party_name"] ? "font-bold text-[#408A71]" : "text-[#285A48]"}`}
//                                 onClick={e => { e.preventDefault(); handleColumnFilterChange("party_name", null); }}
//                               >
//                                 All
//                               </button>
//                             </li>
//                             {uniqueColumnValues["party_name"]
//                               .sort()
//                               .map((option, oidx) => (
//                                 <li key={option + oidx}>
//                                   <button
//                                     className={`w-full text-left px-2 py-1 rounded hover:bg-[#b0e4cc33] text-xs ${
//                                       filters["party_name"] === option
//                                         ? "font-bold text-[#408A71]" : "text-[#285A48]"
//                                     }`}
//                                     onClick={e => {
//                                       e.preventDefault();
//                                       handleColumnFilterChange("party_name", option);
//                                     }}
//                                   >
//                                     {option}
//                                   </button>
//                                 </li>
//                               ))}
//                           </ul>
//                         ) : (
//                           <span className="block px-2 text-xs text-[#408A71]">No values</span>
//                         )}
//                         <button
//                           className="mt-2 px-2 py-1 text-xs text-[#408A71] hover:text-[#091413] underline"
//                           onClick={e => { e.preventDefault(); handleColumnFilterChange("party_name", null); }}
//                         >
//                           Clear filter
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </th>
//               <th className="px-3 py-3 text-left text-[15px] font-bold text-[#285A48] border-b border-[#b0e4cc] whitespace-nowrap">Contact Person</th>
//               <th className="px-3 py-3 text-left text-[15px] font-bold text-[#285A48] border-b border-[#b0e4cc] whitespace-nowrap">Contact Number</th>
//               <th className="px-3 py-3 text-left text-[15px] font-bold text-[#091413] border-b border-[#b0e4cc] whitespace-nowrap">Total Amount</th>
//               <th className="px-3 py-3 text-right text-[15px] font-bold text-[#408A71] border-b border-[#b0e4cc] whitespace-nowrap">Total Purchased</th>
//               <th className="px-3 py-3 text-center text-[15px] font-bold text-[#285A48] border-b border-[#b0e4cc] whitespace-nowrap">View</th>
//             </tr>
//           </thead>
//           <tbody>
//             {pageData.length === 0 ? (
//               <tr>
//                 <td colSpan={7} className="text-center py-8 text-[#B0B0B0] font-bold text-lg">
//                   No data found.
//                 </td>
//               </tr>
//             ) : (
//               pageData.map((row, idx) => (
//                 <tr key={row.party.id} className="hover:bg-[#b0e4cc22] transition">
//                   <td className="px-3 py-3 text-base text-[#091413] border-b border-[#b0e4cc] whitespace-nowrap font-semibold">{row.party.name}</td>
//                   <td className="px-3 py-3 text-base text-[#285A48] border-b border-[#b0e4cc] whitespace-nowrap">{row.party.contact_person_name}</td>
//                   <td className="px-3 py-3 text-base text-[#285A48] border-b border-[#b0e4cc] whitespace-nowrap">{row.party.contact_person_number}</td>
//                   <td className="px-3 py-3 text-base text-[#408A71] border-b border-[#b0e4cc] whitespace-nowrap font-semibold">
//                     {typeof row.party.total_amount === "number"
//                       ? `₹${row.party.total_amount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
//                       : typeof row.party.total_amount === "string" && !isNaN(Number(row.party.total_amount))
//                         ? `₹${Number(row.party.total_amount).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
//                         : row.party.total_amount}
//                   </td>
//                   <td className="px-3 py-3 text-base text-[#285A48] border-b border-[#b0e4cc] whitespace-nowrap text-right font-bold">
//                     {typeof row.total_purchased === "number"
//                       ? `₹${row.total_purchased.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
//                       : typeof row.total_purchased === "string" && !isNaN(Number(row.total_purchased))
//                         ? `₹${Number(row.total_purchased).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
//                         : row.total_purchased}
//                   </td>
//                   <td className="px-3 py-3 border-b border-[#b0e4cc] whitespace-nowrap text-center">
//                     {/* UI Button Group: All actions for each party */}
//                     <div className="flex flex-wrap gap-2 justify-center items-center">
//                       {/* View/Print Details */}
//                       <button
//                         onClick={() => { setSelectedParty(row.party); setShowPartyModal(true); setPartyModalSheet("overall"); }}
//                         className="flex items-center gap-1 text-[#fff] text-[14px] px-3 py-2 rounded-lg border border-[#285A48] hover:bg-[#285A48] bg-[#408A71] font-bold shadow transition"
//                         title="View/Print details"
//                       >
//                         <FaEye /> View
//                       </button>
//                       {/* Set Closing Amount */}
//                       <div className="flex gap-3">
//   <button 
//     onClick={() => setEntryModal({ isOpen: true, type: 'Closing', partyId: String(row.party.id) || '' })}
//     className="flex items-center gap-1 border border-[#8d8df3] bg-[#ebebfc] py-2 px-5 rounded-lg text-[#24246a] font-semibold shadow hover:bg-[#8d8df3] hover:text-white"
//   >
//     Closing Amount
//   </button>
//   {/* Repeat for Loss, Profit, Sale, Commission/exp */}
//   <button
//   onClick={() => setEntryModal({ isOpen: true, type: 'Loss', partyId: String(row.party.id) || '' })}
//           className="flex items-center gap-1 border border-[#FFB4A5] bg-[#FFEFEC] py-2 px-5 rounded-lg text-[#BF3636] font-semibold shadow hover:bg-[#FFB4A5] hover:text-white hover:border-[#BF3636] transition"
//           type="button"
//         >
//           Loss Amount
//         </button>
//         <button
//         onClick={() => setEntryModal({ isOpen: true, type: 'Profit', partyId:String(row.party.id) || '' })}
//           className="flex items-center gap-1 border border-[#A5DB8C] bg-[#F3FCEA] py-2 px-5 rounded-lg text-[#37762A] font-semibold shadow hover:bg-[#A5DB8C] hover:text-white hover:border-[#37762A] transition"
//           type="button"
//         >
//           Profit Amount
//         </button>
//         <button
//         onClick={() => setEntryModal({ isOpen: true, type: 'Sale', partyId: String(row.party.id) || '' })}
//           className="flex items-center gap-1 border border-[#B0E4CC] bg-[#fff7ee] py-2 px-5 rounded-lg text-[#ae793c] font-semibold shadow hover:bg-[#B0E4CC] hover:text-white hover:border-[#ae793c] transition"
//           type="button"
//         >
//           Sale Amount
//         </button>
//         <button
//          onClick={() => setEntryModal({ isOpen: true, type: 'Commission', partyId: partyIdFromUrl?partyIdFromUrl:String(row.party.id) || '' })}
//           className="flex items-center gap-1 border border-[#c6b8ff] bg-[#f3eefb] py-2 px-5 rounded-lg text-[#6842c7] font-semibold shadow hover:bg-[#c6b8ff] hover:text-white hover:border-[#6842c7] transition"
//           type="button"
//         >
//           Commision
//         </button>
//         <button
//          onClick={() => setEntryModal({ isOpen: true, type: 'Expenses', partyId: partyIdFromUrl?partyIdFromUrl:String(row.party.id) || '' })}
//           className="flex items-center gap-1 border border-[#c6b8ff] bg-[#f3eefb] py-2 px-5 rounded-lg text-[#6842c7] font-semibold shadow hover:bg-[#c6b8ff] hover:text-white hover:border-[#6842c7] transition"
//           type="button"
//         >
//           Expenses
//         </button>
// </div>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>
//       {/* Pagination */}
//       <div className="flex items-center justify-between mt-6 bg-[#b0e4cc1a] px-5 py-3 rounded-xl shadow-inner">
//         <span className="text-[#091413] text-[15px] font-bold">
//           Page {page} of {totalPage}
//         </span>
//         <div className="flex gap-4">
//           <button
//             disabled={page === 1}
//             onClick={() => setPage(p => p - 1)}
//             className={`px-4 py-2 rounded-xl border-2 border-[#285A48] font-bold transition bg-white text-[#285A48] shadow ${page === 1 ? "opacity-40 cursor-not-allowed" : "hover:bg-[#408A71] hover:text-white hover:border-[#408A71]"}`}
//           >
//             Previous
//           </button>
//           <button
//             disabled={page === totalPage || filteredData.length === 0}
//             onClick={() => setPage(p => p + 1)}
//             className={`px-4 py-2 rounded-xl border-2 border-[#285A48] font-bold transition bg-white text-[#285A48] shadow ${(page === totalPage || filteredData.length === 0) ? "opacity-40 cursor-not-allowed" : "hover:bg-[#408A71] hover:text-white hover:border-[#408A71]"}`}
//           >
//             Next
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // --- INJECT our partyClosingAmounts into modal/statements logic ---
// // pass the value for the selected party into final P&L etc
// // e.g., in renderPnLModalContent or buildFinalSheetDataForParty: 
// // check if partyClosingAmounts[selectedParty?.id] exists, if so use; else use default P&L logic

// // Example: When rendering the Party Modal/PnL, inside renderPartyModal...
// // 1. Find the right closing amount
// // 2. Pass into renderPnLModalContent or similar

// // Below is an example if you have, in your "renderPnLModalContent", to override OutSourceClosingAmount dynamically based on party:
//     // const closingAmtOverride = selectedParty ? partyClosingAmounts[String(selectedParty.id)] : undefined;
//     // ...within modal...
//     // where you formerly wrote: 
//     //   typeof OutSourceClosingAmount !== "undefined"
//     // ...use...
//     //   typeof closingAmtOverride !== "undefined"
// // If not using prop, may need to thread partyClosingAmounts usage into P&L builder/renderer as shown above.

// export default CustomBalance;


import React, { useState, useEffect, useCallback, useRef } from 'react';
import { BiImport } from "react-icons/bi";
import { CiSearch } from "react-icons/ci";
import { FaFilter } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import partiesData from '../data/party';
import stocksData from '../data/stock';
import updatestocksApi from '../data/stockhistory';
import settingapi from '../data/setting';
import axios from 'axios';
import { useLocation } from "react-router-dom";

// ─── Types ────────────────────────────────────────────────────────────────────

type StockCategoryObj = {
  id: number;
  stock_name: string;
  category: string;
  unit: string;
  total_amount: string;
  indirect_charges: string;
  perUnitCharge: string;
  investment_type: string;
};

type WithdrawalRecord = {
  id: number;
  party_id: number;
  amount: number;
  date: string;
  catrgories: string;
};

type SellStockRecord = {
  id: number;
  party_id: number;
  category: string;
  stock_id: string;
  stock_name: string;
  sell_units: string;
  sell_amount: string;
  indirect_charges: string;
  date: string;
  catrgories: string;
};

interface Party {
  id: number;
  date: string;
  name: string;
  display_name:string;
  number: string;
  contact_person_name: string;
  contact_person_number: string;
  categories: string[];
  total_amount?: number | string;
}

type PartyStockDBType = {
  id: number | string;
  party_id: number | string;
  categories: string | StockCategoryObj[];
  date?: string;
  date_of_purchase?: string;
};

type StockCurrentAmountRecord = {
  id: number;
  stock_id: number;
  cat_id: number;
  current_price: number | string;
  current_price_date: string;
  sundry_creditors?: number;
};

interface IndexPriceRecord {
  id: number;
  niftyPrice?: string;
  sensexPrice?: string;
  date: string;
}

// Financial record stored in DB
type FinancialEntry = {
  id?: number;          // DB id (returned after save)
  party_id: string;
  record_type: 'Closing' | 'Loss' | 'Profit' | 'Commission' | 'Expenses' | 'Sale';
  amount: string;
  date: string;
  stock_name?: string;
  category?: string;
  units?: string;
};

type ModalSheetView = "overall" | "final" | "balance" | "QTLY Performance";

type CalculationFormulaConfig = {
  purchaseShare: boolean;
  purchaseDirect: boolean;
  purchaseOperator: string;
  grossSaleStock: boolean;
  grossSaleStockOp: string;
  grossSaleCharges: boolean;
  grossSaleChargesOp: string;
  grossPurchasedStockSale: boolean;
  grossPurchasedStockSaleOp: string;
  grossPurchaseIndirect: boolean;
  grossInterestCharges: boolean;
  gpcGrossProfit: boolean;
  gpcOperator: string;
  gpcSaleAccount: boolean;
  indirectCharges: boolean;
  indirectChargesOp: string;
  indInterestCharges: boolean;
  indPurchaseIndirect: boolean;
  indPurchasedStockSale: boolean;
  indPurchasedStockSaleOp: string;
  netGrossProfit: boolean;
  netIndirectExpenses: boolean;
  netPLOperator: string;
  [key: string]: any;
};

// ─── Helpers ──────────────────────────────────────────────────────────────────

function parseCategoriesForDb(categories: string | StockCategoryObj[]): StockCategoryObj[] {
  if (Array.isArray(categories)) return categories as StockCategoryObj[];
  if (typeof categories === 'string') {
    try {
      const value = categories.trim();
      if (value.startsWith('[')) {
        const arr = JSON.parse(value);
        if (Array.isArray(arr)) return arr;
        return [arr];
      }
    } catch { }
  }
  return [];
}

function getAllCurrentAmountsFor(
  stockId: number | string,
  catId: number | string,
  records: StockCurrentAmountRecord[],
  dateFrom?: string,
  dateTo?: string
) {
  if (!stockId || !catId) return [];
  return records
    .filter(record =>
      String(record.stock_id) === String(stockId) &&
      String(record.cat_id) === String(catId) &&
      (!dateFrom || new Date(record.current_price_date) >= new Date(dateFrom)) &&
      (!dateTo   || new Date(record.current_price_date) <= new Date(dateTo))
    )
    .sort((a, b) => (a.current_price_date < b.current_price_date ? 1 : -1));
}

function getLatestCurrentAmountFor(
  stockId: number | string,
  catId: number | string,
  records: StockCurrentAmountRecord[],
  dateFrom?: string,
  dateTo?: string
) {
  const all = getAllCurrentAmountsFor(stockId, catId, records, dateFrom, dateTo);
  if (all.length === 0) return null;
  return all[0];
}

function downloadCSV(csv: string, filename: string) {
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
}

function getUniqueValues(array: any[], field: string): string[] {
  const set = new Set<string>();
  array.forEach(item => {
    let value = item[field];
    if (value === undefined || value === null) return;
    set.add(String(value));
  });
  return Array.from(set).filter(v => v !== '');
}

function formatPeriod(dateFrom?: string, dateTo?: string) {
  if (!dateFrom && !dateTo) return "All dates";
  if (dateFrom && dateTo)
    return `${new Date(dateFrom).toLocaleDateString()} to ${new Date(dateTo).toLocaleDateString()}`;
  if (dateFrom) return `From ${new Date(dateFrom).toLocaleDateString()}`;
  if (dateTo) return `Up to ${new Date(dateTo).toLocaleDateString()}`;
  return '';
}

function getMonthDiff(partyDate: string | Date | undefined, to: string | Date | undefined) {
  if (!partyDate) return 1;
  const start = typeof partyDate === "string" ? new Date(partyDate) : partyDate;
  const end = to ? (typeof to === "string" ? new Date(to) : to) : new Date();
  if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) return 1;
  let months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
  if (end.getDate() >= start.getDate()) months += 1;
  return months < 1 ? 1 : months;
}

async function fetchSellStocks() {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/sellstocks`);
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch { return []; }
}

async function fetchWithdrawals(): Promise<WithdrawalRecord[]> {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/withdrawals`);
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch { return []; }
}

// ─── API helpers for financial records ────────────────────────────────────────

const FINANCIAL_RECORDS_API = `${process.env.REACT_APP_API_URL}/auth/financial-records`;

async function apiFetchFinancialRecords(partyId?: string): Promise<FinancialEntry[]> {
  try {
    const url = partyId ? `${FINANCIAL_RECORDS_API}?party_id=${partyId}` : FINANCIAL_RECORDS_API;
    const res = await fetch(url);
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch { return []; }
}

async function apiSaveFinancialRecord(entry: FinancialEntry): Promise<FinancialEntry | null> {
  try {
    const method = entry.id ? 'PUT' : 'POST';
    const url = entry.id ? `${FINANCIAL_RECORDS_API}/${entry.id}` : FINANCIAL_RECORDS_API;
    const res = await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(entry),
    });
    if (!res.ok) return null;
    return await res.json();
  } catch { return null; }
}

async function apiDeleteFinancialRecord(id: number): Promise<boolean> {
  try {
    const res = await fetch(`${FINANCIAL_RECORDS_API}/${id}`, { method: 'DELETE' });
    return res.ok;
  } catch { return false; }
}

// ─── Multi-Entry Form Component ───────────────────────────────────────────────

type EntryFormProps = {
  type: 'Closing' | 'Loss' | 'Profit' | 'Commission' | 'Expenses';
  partyId: string;
  partyName: string;
  existingRecords: FinancialEntry[];
  onClose: () => void;
  onSaved: () => void;
};

function MultiEntryForm({ type, partyId, partyName, existingRecords, onClose, onSaved }: EntryFormProps) {
  const [rows, setRows] = useState<FinancialEntry[]>(
    existingRecords.length > 0
      ? existingRecords
      : [{ party_id: partyId, record_type: type, amount: '', date: new Date().toISOString().split('T')[0] }]
  );
  const [saving, setSaving] = useState(false);

  const addRow = () =>
    setRows(prev => [...prev, { party_id: partyId, record_type: type, amount: '', date: new Date().toISOString().split('T')[0] }]);

  const updateRow = (idx: number, field: keyof FinancialEntry, value: string) => {
    setRows(prev => {
      const copy = [...prev];
      copy[idx] = { ...copy[idx], [field]: value };
      return copy;
    });
  };

  const removeRow = async (idx: number) => {
    const row = rows[idx];
    if (row.id) {
      setSaving(true);
      await apiDeleteFinancialRecord(row.id);
      setSaving(false);
    }
    setRows(prev => prev.filter((_, i) => i !== idx));
  };

  const handleSave = async () => {
    setSaving(true);
    for (const row of rows) {
      if (!row.amount || !row.date) continue;
      await apiSaveFinancialRecord({ ...row, party_id: partyId, record_type: type });
    }
    setSaving(false);
    onSaved();
    onClose();
  };

  const typeColors: Record<string, { bg: string; header: string; border: string }> = {
    Closing: { bg: '#ebebfc', header: '#6742c7', border: '#8d8df3' },
    Loss:    { bg: '#FFEFEC', header: '#BF3636', border: '#FFB4A5' },
    Profit:  { bg: '#F3FCEA', header: '#37762A', border: '#A5DB8C' },
    Commission: { bg: '#f3eefb', header: '#6842c7', border: '#c6b8ff' },
    Expenses:   { bg: '#fff7ee', header: '#ae793c', border: '#B0E4CC' },
  };
  const c = typeColors[type] || typeColors.Closing;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden border border-gray-200">
        <div className="p-4 text-white flex justify-between items-center" style={{ background: c.header }}>
          <h3 className="font-bold text-lg">{type} Entries — {partyName}</h3>
          <button onClick={onClose} className="text-2xl leading-none">&times;</button>
        </div>
        <div className="p-6 max-h-[60vh] overflow-y-auto space-y-4">
          {rows.map((entry, idx) => (
            <div key={idx} className="flex gap-3 items-end border-b pb-4 last:border-0">
              <div className="flex-1">
                <label className="text-[10px] font-bold text-gray-500 uppercase block mb-1">Date</label>
                <input
                  type="date"
                  value={entry.date}
                  onChange={e => updateRow(idx, 'date', e.target.value)}
                  className="w-full border rounded-lg p-2 text-sm"
                />
              </div>
              <div className="flex-1">
                <label className="text-[10px] font-bold text-gray-500 uppercase block mb-1">Amount (₹)</label>
                <input
                  type="number"
                  value={entry.amount}
                  placeholder="0.00"
                  onChange={e => updateRow(idx, 'amount', e.target.value)}
                  className="w-full border rounded-lg p-2 text-sm"
                />
              </div>
              <button onClick={() => removeRow(idx)} className="text-red-500 p-2 pb-3" title="Remove">🗑️</button>
            </div>
          ))}
          <button
            onClick={addRow}
            className="w-full py-2 border-2 border-dashed rounded-lg font-bold hover:opacity-80 transition"
            style={{ borderColor: c.border, color: c.header }}
          >
            + Add Another Entry
          </button>
        </div>
        <div className="p-4 bg-gray-50 flex gap-3 justify-end border-t">
          <button onClick={onClose} className="px-4 py-2 text-gray-600 font-semibold">Cancel</button>
          <button
            onClick={handleSave}
            disabled={saving}
            className="px-6 py-2 text-white rounded-lg font-bold shadow-lg disabled:opacity-60"
            style={{ background: c.header }}
          >
            {saving ? 'Saving…' : 'Save All'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Sale Entry Form ──────────────────────────────────────────────────────────

type SaleFormProps = {
  partyId: string;
  partyName: string;
  partyStocks: StockCategoryObj[];
  existingRecords: FinancialEntry[];
  onClose: () => void;
  onSaved: () => void;
};

function SaleEntryForm({ partyId, partyName, partyStocks, existingRecords, onClose, onSaved }: SaleFormProps) {
  const [rows, setRows] = useState<FinancialEntry[]>(
    existingRecords.length > 0
      ? existingRecords
      : [{ party_id: partyId, record_type: 'Sale', amount: '', date: new Date().toISOString().split('T')[0], stock_name: '', units: '' }]
  );
  const [saving, setSaving] = useState(false);

  const addRow = () =>
    setRows(prev => [...prev, { party_id: partyId, record_type: 'Sale', amount: '', date: new Date().toISOString().split('T')[0], stock_name: '', units: '' }]);

  const updateRow = (idx: number, field: keyof FinancialEntry, value: string) => {
    setRows(prev => {
      const copy = [...prev];
      if (field === 'stock_name') {
        const found = partyStocks.find(s => s.stock_name === value);
        copy[idx] = { ...copy[idx], stock_name: value, category: found?.category || '' };
      } else {
        copy[idx] = { ...copy[idx], [field]: value };
      }
      return copy;
    });
  };

  const removeRow = async (idx: number) => {
    const row = rows[idx];
    if (row.id) {
      setSaving(true);
      await apiDeleteFinancialRecord(row.id);
      setSaving(false);
    }
    setRows(prev => prev.filter((_, i) => i !== idx));
  };

  const handleSave = async () => {
    setSaving(true);
    for (const row of rows) {
      if (!row.amount || !row.date) continue;
      await apiSaveFinancialRecord({ ...row, party_id: partyId, record_type: 'Sale' });
    }
    setSaving(false);
    onSaved();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl overflow-hidden border border-gray-200">
        <div className="bg-[#ae793c] p-5 text-white flex justify-between items-center">
          <div>
            <h3 className="font-bold text-xl">Sale Stock Management</h3>
            <p className="text-orange-100 text-sm opacity-90">Recording sales for {partyName}</p>
          </div>
          <button onClick={onClose} className="text-2xl hover:text-gray-200">&times;</button>
        </div>
        <div className="p-6 max-h-[65vh] overflow-y-auto bg-orange-50/30 space-y-4">
          {rows.map((sale, idx) => (
            <div key={idx} className="grid grid-cols-12 gap-3 p-4 bg-white rounded-xl shadow-sm border border-orange-100 items-end">
              <div className="col-span-4">
                <label className="text-[10px] font-extrabold text-gray-400 uppercase mb-1 block">Select Stock</label>
                <select
                  value={sale.stock_name || ''}
                  onChange={e => updateRow(idx, 'stock_name', e.target.value)}
                  className="w-full border rounded-lg p-2 text-sm bg-gray-50 outline-none focus:ring-2 focus:ring-orange-400"
                >
                  <option value="">-- Choose Stock --</option>
                  {partyStocks.map((s, i) => (
                    <option key={i} value={s.stock_name}>{s.stock_name} ({s.category})</option>
                  ))}
                </select>
              </div>
              <div className="col-span-3">
                <label className="text-[10px] font-extrabold text-gray-400 uppercase mb-1 block">Date</label>
                <input type="date" value={sale.date} onChange={e => updateRow(idx, 'date', e.target.value)}
                  className="w-full border rounded-lg p-2 text-sm outline-none focus:ring-2 focus:ring-orange-400" />
              </div>
              <div className="col-span-2">
                <label className="text-[10px] font-extrabold text-gray-400 uppercase mb-1 block">Units</label>
                <input type="number" placeholder="Qty" value={sale.units || ''} onChange={e => updateRow(idx, 'units', e.target.value)}
                  className="w-full border rounded-lg p-2 text-sm outline-none focus:ring-2 focus:ring-orange-400" />
              </div>
              <div className="col-span-2">
                <label className="text-[10px] font-extrabold text-gray-400 uppercase mb-1 block">Total ₹</label>
                <input type="number" placeholder="Amount" value={sale.amount} onChange={e => updateRow(idx, 'amount', e.target.value)}
                  className="w-full border rounded-lg p-2 text-sm font-bold text-green-700 outline-none focus:ring-2 focus:ring-orange-400" />
              </div>
              <div className="col-span-1 text-right">
                <button onClick={() => removeRow(idx)} className="text-red-400 hover:text-red-600 p-2">🗑️</button>
              </div>
            </div>
          ))}
          <button onClick={addRow} className="w-full py-3 border-2 border-dashed border-orange-200 text-[#ae793c] rounded-xl font-bold hover:bg-orange-50 transition-all">
            + Add Another Sale Row
          </button>
        </div>
        <div className="p-4 bg-white border-t flex gap-3 justify-end">
          <button onClick={onClose} className="px-6 py-2 text-gray-500 font-bold">Cancel</button>
          <button onClick={handleSave} disabled={saving}
            className="px-8 py-2.5 bg-[#ae793c] text-white rounded-xl font-bold shadow-lg hover:bg-[#8e622f] transition-all disabled:opacity-60">
            {saving ? 'Saving…' : 'Save All Sales'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────────

function CustomBalance() {
  const [parties, setParties] = useState<Party[]>([]);
  const [stocks, setStocks] = useState<PartyStockDBType[]>([]);
  const [updates, setUpdates] = useState<StockCurrentAmountRecord[]>([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const perPage = 10;
  const [openFilterDropdown, setOpenFilterDropdown] = useState<string | null>(null);
  const [uniqueColumnValues, setUniqueColumnValues] = useState<{ [key: string]: string[] }>({});
  const [filters, setFilters] = useState<{ [key: string]: string | null }>({});
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [dateFrom, setDateFrom] = useState<string>('');
  const [dateTo, setDateTo] = useState<string>('');
  const [interestDateTo, setInterestDateTo] = useState<string>('');
  const [selectedParty, setSelectedParty] = useState<Party | null>(null);
  const [showPartyModal, setShowPartyModal] = useState(false);
  const [partyModalSheet, setPartyModalSheet] = useState<ModalSheetView>("overall");
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [interestPercentage, setInterestPercentage] = useState(3);
  const [indexPriceHistory, setIndexPriceHistory] = useState<IndexPriceRecord[]>([]);
  const [sellStocks, setSellStocks] = useState<SellStockRecord[]>([]);
  const [withdrawals, setWithdrawals] = useState<WithdrawalRecord[]>([]);
  const [globalQTLY, setGlobalQtly] = useState(false);
  const [farmForm, setFarmForm] = useState({ name: '', email: '', phone: '', address: '' });
  const [calculationFormulasConfig, setCalculationFormulasConfig] = useState<CalculationFormulaConfig | null>(null);
  const location = useLocation();
  const [partyIdFromUrl, setPartyIdFromUrl] = useState<string | null>(null);

  // Per-party closing amounts (from DB + local override for modal display)
  const [partyClosingAmounts, setPartyClosingAmounts] = useState<Record<string, number>>({});

  // ── Financial records from DB ──────────────────────────────────────────────
  const [financialRecords, setFinancialRecords] = useState<FinancialEntry[]>([]);
  const [financialLoading, setFinancialLoading] = useState(false);

  // Active entry modal
  const [entryModal, setEntryModal] = useState<{
    isOpen: boolean;
    type: 'Closing' | 'Loss' | 'Profit' | 'Commission' | 'Expenses' | 'Sale';
    partyId: string;
  }>({ isOpen: false, type: 'Closing', partyId: '' });

  // ── Fetch financial records from DB ───────────────────────────────────────
  const loadFinancialRecords = useCallback(async () => {
    setFinancialLoading(true);
    const data = await apiFetchFinancialRecords();
    setFinancialRecords(data);
    setFinancialLoading(false);
  }, []);

  useEffect(() => { loadFinancialRecords(); }, [loadFinancialRecords]);

  // Helper: get records for a party + type, filtered by date range
  const getFilteredRecords = useCallback(
    (partyId: string, type: FinancialEntry['record_type'], from?: string, to?: string): FinancialEntry[] => {
      return financialRecords.filter(r => {
        if (String(r.party_id) !== String(partyId)) return false;
        if (r.record_type !== type) return false;
        if (from && new Date(r.date) < new Date(from)) return false;
        if (to   && new Date(r.date) > new Date(to))   return false;
        return true;
      });
    },
    [financialRecords]
  );

  const sumRecords = (records: FinancialEntry[]) =>
    records.reduce((s, r) => s + (parseFloat(r.amount) || 0), 0);

  // ── Settings / Parties / Stocks / Withdrawals ──────────────────────────────
  useEffect(() => {
    try {
      const raw = localStorage.getItem('calculationsFormulasConfigV1');
      if (raw) setCalculationFormulasConfig(JSON.parse(raw));
    } catch { }
  }, []);

  useEffect(() => {
    const sp = new URLSearchParams(location.search);
    let pid = sp.get('party');
    if (!pid) {
      const m = location.pathname.match(/\/(\d+)$/);
      if (m) pid = m[1];
    }
    setPartyIdFromUrl(pid);
  }, [location]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/auth/setting`);
        const arr = Array.isArray(res.data) ? res.data : [];
        const farm = arr.find((i: any) => i.meta_key === 'farm');
        if (farm) {
          const v = typeof farm.meta_value === 'string' ? JSON.parse(farm.meta_value || '{}') : farm.meta_value || {};
          setFarmForm({ name: v.name || '', email: v.email || '', phone: v.phone || '', address: v.address || '' });
        }
        const histSetting = arr.find((i: any) => i.meta_key === 'index_prices_history');
        if (histSetting) {
          const h = typeof histSetting.meta_value === 'string' ? JSON.parse(histSetting.meta_value || '[]') : histSetting.meta_value || [];
          if (Array.isArray(h)) setIndexPriceHistory(h.sort((a: any, b: any) => (b.date > a.date ? 1 : -1)));
        }
      } catch { }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await settingapi();
        if (Array.isArray(res)) {
          const p = res.find((i: any) => i.meta_key === 'percentage');
          if (p && !isNaN(parseFloat(p.meta_value))) setInterestPercentage(parseFloat(p.meta_value));
        }
      } catch { }
    };
    load();
  }, []);

  useEffect(() => {
    async function fetchPartiesApi() {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/addparty`);
        if (!res.ok) return;
        const data = await res.json();
        if (Array.isArray(data)) {
          setParties(data.map((item: any) => ({
            ...item,
            categories: Array.isArray(item.categories) ? item.categories
              : typeof item.categories === 'string'
                ? (item.categories.trim().startsWith('[') ? JSON.parse(item.categories) : item.categories.split(',').map((c: string) => c.trim()))
                : []
          })));
        }
      } catch { }
    }
    fetchPartiesApi();
  }, []);

  const fetchStocks = useCallback(async () => {
    try { const res = await stocksData(); setStocks(Array.isArray(res) ? res : []); } catch { setStocks([]); }
  }, []);

  const fetchUpdates = useCallback(async () => {
    try { const data = await updatestocksApi(); setUpdates(Array.isArray(data) ? data : []); } catch { setUpdates([]); }
  }, []);

  useEffect(() => {
    async function loadSellStocks() { setSellStocks(await fetchSellStocks()); }
    loadSellStocks();
  }, []);

  useEffect(() => {
    async function loadWithdrawals() {
      const arr = await fetchWithdrawals();
      const normalized = (arr || []).map(wd => {
        let categories: any[] = [];
        if (wd.catrgories) {
          try {
            const a = JSON.parse(wd.catrgories);
            if (Array.isArray(a) && a.length > 0 && typeof a[0] === 'string') {
              categories = JSON.parse(a[0]);
              if (!Array.isArray(categories)) categories = [categories];
            }
          } catch { }
        }
        return { ...wd, categories };
      });
      setWithdrawals(normalized);
    }
    loadWithdrawals();
  }, []);

  useEffect(() => { fetchStocks(); fetchUpdates(); }, [fetchStocks, fetchUpdates]);

  // ── Date helpers ───────────────────────────────────────────────────────────
  const isInDateRange = (dateStr: string) => {
    if (!dateStr) return true;
    const date = new Date(dateStr);
    const from = dateFrom ? new Date(dateFrom) : null;
    const to = dateTo ? new Date(dateTo) : null;
    if (from && date < from) return false;
    if (to && date > to) return false;
    return true;
  };

  // ── Sundry creditors map ───────────────────────────────────────────────────
  const partySundryCreditorsMap = React.useMemo(() => {
    if (!updates.length || !stocks.length) return {};
    const stockIdToParty = new Map();
    for (const stk of stocks) stockIdToParty.set(String(stk.id), stk.party_id);
    const partyTotals: Record<string, number> = {};
    for (const update of updates) {
      const party_id = stockIdToParty.get(String(update.stock_id));
      if (!party_id) continue;
      const inDate = !update.current_price_date || (
        (!dateFrom || new Date(update.current_price_date) >= new Date(dateFrom)) &&
        (!dateTo   || new Date(update.current_price_date) <= new Date(dateTo))
      );
      if (!inDate) continue;
      if (typeof update.sundry_creditors !== 'undefined' && !isNaN(Number(update.sundry_creditors))) {
        if (!partyTotals[party_id]) partyTotals[party_id] = 0;
        partyTotals[party_id] += Number(update.sundry_creditors);
      }
    }
    return partyTotals;
  }, [updates, stocks, dateFrom, dateTo]);

  // ── Party aggregated rows ──────────────────────────────────────────────────
  const partyAggregatedRows = React.useMemo(() => {
    if (!parties.length || !stocks.length) return [];
    let result: any[] = [];
    for (const party of parties) {
      const partyStocks = stocks.filter(stk => String(stk.party_id) === String(party.id));
      let total_purchased = 0, total_used = 0, total_earning = 0, total_indirect_charges = 0;
      const end = dateTo ? new Date(dateTo) : new Date();
      const months = getMonthDiff(party.date, end);
      const total_interest = Number(party.total_amount || 0) * (Number(interestPercentage) / 100) * Number(months);

      let total_sales_amount = 0, total_sales_units = 0;
      if (sellStocks.length) {
        const filtered = sellStocks.filter(s =>
          String(s.party_id) === String(party.id) &&
          (!dateFrom || new Date(s.date) >= new Date(dateFrom)) &&
          (!dateTo   || new Date(s.date) <= new Date(dateTo))
        );
        total_sales_amount = filtered.reduce((sum, s) => sum + (parseFloat(s.sell_amount) || 0), 0);
        total_sales_units  = filtered.reduce((sum, s) => sum + (parseFloat(s.sell_units) || 0), 0);
      }

      let total_withdrawal_amount = 0;
      let withdrawals_details: WithdrawalRecord[] = [];
      if (withdrawals.length) {
        const filtered = withdrawals.filter(w =>
          String(w.party_id) === String(party.id) &&
          (!dateFrom || new Date(w.date) >= new Date(dateFrom)) &&
          (!dateTo   || new Date(w.date) <= new Date(dateTo))
        );
        total_withdrawal_amount = filtered.reduce((sum, w) => sum + (parseFloat(String(w.amount)) || 0), 0);
        withdrawals_details = filtered;
      }

      let stock_aggregate: any[] = [];
      for (const stk of partyStocks) {
        const cats = parseCategoriesForDb(stk.categories);
        for (const catObj of cats) {
          const catId = catObj.id ?? '';
          const stock_name = catObj.stock_name;
          const indirectCharges = Number(catObj.indirect_charges || 0);
          const allHistory = getAllCurrentAmountsFor(stk.id, catId, updates, dateFrom, dateTo);
          const chronHistory = [...allHistory].sort((a, b) => (a.current_price_date > b.current_price_date ? 1 : -1));
          const opening = Number(catObj.total_amount || 0);
          const purchaseDate = stk.date_of_purchase || stk.date || '';
          const inDate = isInDateRange(purchaseDate);
          let records: any[] = [];
          if (inDate) {
            records.push({
              category: catObj.category, unit: catObj.unit, date_of_purchase: purchaseDate,
              opening_balance: opening, update_history: [], total_purchased: opening,
              total_used: 0, total_earning: 0, indirect_charges: indirectCharges,
              per_unit_charge: Number(catObj.perUnitCharge || 0), total_profit_and_loss: 0
            });
          }
          let totalStockUsed = 0, totalStockEarning = 0, total_profit_and_loss = 0;
          let update_history: any[] = [];
          let prevAmount = opening;
          for (const rec of chronHistory) {
            const thisAmount = Number(rec.current_price || 0);
            const used = thisAmount - prevAmount;
            const earning = thisAmount - (prevAmount + indirectCharges);
            const profitAndLoss = thisAmount - (prevAmount + indirectCharges);
            total_profit_and_loss += profitAndLoss;
            const entry: any = { date: rec.current_price_date, current_amount: thisAmount, used, earning, profitAndLoss };
            if (rec.sundry_creditors !== undefined && rec.sundry_creditors !== null) {
              entry.dividend = Number(rec.sundry_creditors);
              entry.sundry_creditors = Number(rec.sundry_creditors);
            }
            update_history.push(entry);
            totalStockUsed += used;
            totalStockEarning += earning;
          }
          if (inDate && records.length > 0) {
            records[0].update_history = update_history;
            records[0].total_used = totalStockUsed;
            records[0].total_earning = totalStockEarning;
            records[0].total_profit_and_loss = total_profit_and_loss;
          }
          if (inDate) {
            total_purchased += opening + indirectCharges;
            total_indirect_charges += indirectCharges;
          }
          total_used += totalStockUsed;
          total_earning += totalStockEarning;
          let stockEntry = stock_aggregate.find(s => s.stock_name === stock_name);
          if (!stockEntry) stock_aggregate.push({ stock_name, records });
          else stockEntry.records.push(...records);
        }
      }
      if (stock_aggregate.length > 0) {
        result.push({
          party, stocks: stock_aggregate, total_purchased, total_used, total_earning,
          total_indirect_charges, total_interest, total_sales_amount, total_sales_units,
          total_withdrawal_amount, withdrawals_details,
        });
      }
    }
    return result;
  }, [parties, stocks, updates, dateFrom, dateTo, interestPercentage, sellStocks, withdrawals]);

  useEffect(() => {
    if (!partyAggregatedRows.length) return;
    setUniqueColumnValues({ party_name: partyAggregatedRows.map(r => r.party.name) });
  }, [partyAggregatedRows]);

  // ── Reducing balance interest ──────────────────────────────────────────────
  const calculateReducingInterest = (party: Party, withdrawalsList: WithdrawalRecord[], interestRate: number, endDate: string) => {
    const start = new Date(party.date);
    const end = new Date(endDate);
    let currentPrincipal = parseFloat(String(party.total_amount || 0));
    let totalInterest = 0;
    let lastDate = new Date(start);
    const partyWithdrawals = withdrawalsList
      .filter(w => String(w.party_id) === String(party.id))
      .map(w => ({ date: new Date(w.date), amount: parseFloat(String(w.amount || 0)) }))
      .filter(w => w.date > start && w.date <= end)
      .sort((a, b) => a.date.getTime() - b.date.getTime());
    const totalWithdrawal = partyWithdrawals.reduce((sum, w) => sum + w.amount, 0);
    for (const wd of partyWithdrawals) {
      const days = Math.floor((wd.date.getTime() - lastDate.getTime()) / (1000 * 60 * 60 * 24));
      if (days > 0) totalInterest += (currentPrincipal * interestRate / 36500) * days;
      currentPrincipal -= wd.amount;
      lastDate = new Date(wd.date);
    }
    const finalDays = Math.floor((end.getTime() - lastDate.getTime()) / (1000 * 60 * 60 * 24));
    if (finalDays > 0) totalInterest += (currentPrincipal * interestRate / 36500) * finalDays;
    return { accumulatedInterest: totalInterest, remainingPrincipal: currentPrincipal, totalWithdrawal };
  };

  // ── Build final sheet data ─────────────────────────────────────────────────
  function buildFinalSheetDataForParty(party: Party) {
    const fmt = (n: number) => n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const partyStocksRaw = stocks.filter(stk => String(stk.party_id) === String(party.id));
    const partyIdStr = String(party.id);

    // Use date-filtered financial records from DB
    const closingRecs   = getFilteredRecords(partyIdStr, 'Closing', dateFrom, dateTo);
    const lossRecs      = getFilteredRecords(partyIdStr, 'Loss', dateFrom, dateTo);
    const profitRecs    = getFilteredRecords(partyIdStr, 'Profit', dateFrom, dateTo);
    const commissionRecs= getFilteredRecords(partyIdStr, 'Commission', dateFrom, dateTo);
    const expensesRecs  = getFilteredRecords(partyIdStr, 'Expenses', dateFrom, dateTo);
    const saleRecs      = getFilteredRecords(partyIdStr, 'Sale', dateFrom, dateTo);

    const lossAmt       = sumRecords(lossRecs);
    const profitAmt     = sumRecords(profitRecs);
    const commissionAmt = sumRecords(commissionRecs);
    const dbSaleAmt     = sumRecords(saleRecs);
    const closingOverride = sumRecords(closingRecs); // sum of Closing entries for display
    const expensesAmt   = sumRecords(expensesRecs);

    const openingStock = parties.filter(p => p.id === party.id).reduce((s, p) => s + (Number(p.total_amount) || 0), 0);

    const end = dateTo ? new Date(dateTo) : new Date();
    const months = getMonthDiff(party.date, end, );
    const interestExpenses = (Number(party.total_amount || 0)) / 2 * (Number(interestPercentage) / 100) * Number(months);

    let sharesPurchased = 0, directExpenses = 0, purchases = 0;
    for (const stk of partyStocksRaw) {
      const purchaseDate = stk.date_of_purchase || stk.date || '';
      if (!isInDateRange(purchaseDate)) continue;
      const cats = parseCategoriesForDb(stk.categories);
      for (const catObj of cats) {
        purchases += Number(catObj.total_amount || 0);
        if (catObj.investment_type === 'structure') {
          sharesPurchased += Number(catObj.total_amount || 0) + Number(catObj.indirect_charges || 0);
        }
        if (catObj.investment_type === 'direct') directExpenses += Number(catObj.total_amount || 0);
      }
    }

    // Sales: prefer DB sale records, fallback to sellStocks API
    let totalSales = 0, totalsoldstockpurchasingamount = 0, totalsoldstockpurchasingamountindirectcharges = 0, totalsoldstocksellingpriceindirectcharges = 0, totalHoldingCost = 0, totalPurchases = 0;
    for (const stk of partyStocksRaw) {
      const purchaseDate = stk.date_of_purchase || stk.date || '';
      if (!isInDateRange(purchaseDate)) continue;
      const cats = parseCategoriesForDb(stk.categories);
      for (const catObj of cats) {
        const pUnits = parseFloat(catObj.unit) || 0;
        const origAmt = Number(catObj.total_amount || 0);
        const origIndirect = Number(catObj.indirect_charges || 0);
        const origPPU = pUnits > 0 ? origAmt / pUnits : 0;
        const origIndPPU = pUnits > 0 ? origIndirect / pUnits : 0;
        let currentPAmt = origAmt;
        const latestUpdate = getLatestCurrentAmountFor(stk.id, catObj.id, updates, dateFrom, dateTo);
        if (latestUpdate) currentPAmt = Number(latestUpdate.current_price);
        const currentPPU = pUnits > 0 ? (currentPAmt + origIndirect) / pUnits : 0;
        totalPurchases += origAmt + origIndirect;
        const specificSales = sellStocks.filter(s => String(s.party_id) === String(party.id) && s.stock_name === catObj.stock_name);
        const soldUnits = specificSales.reduce((sum, s) => sum + (parseFloat(s.sell_units) || 0), 0);
        const soldAmount = specificSales.reduce((sum, s) => sum + (parseFloat(s.sell_amount) || 0), 0);
        const soldCharges = specificSales.reduce((sum, s) => sum + (parseFloat(s.indirect_charges) || 0), 0);
        totalSales += soldAmount;
        totalsoldstocksellingpriceindirectcharges += soldCharges;
        if (soldUnits > 0) {
          totalsoldstockpurchasingamount += soldUnits * origPPU;
          totalsoldstockpurchasingamountindirectcharges += origIndirect;
        }
        const remainingUnits = pUnits - soldUnits;
        if (remainingUnits > 0) totalHoldingCost += remainingUnits * currentPPU;
      }
    }

    // Use DB sale records if available, else API sell stocks
    const sales = dbSaleAmt > 0 ? dbSaleAmt : totalSales;

    let grossProfit = (totalSales - totalsoldstocksellingpriceindirectcharges) - (totalsoldstockpurchasingamount + (calculationFormulasConfig?.grossSaleCharges ? totalsoldstockpurchasingamountindirectcharges : 0));
    if (calculationFormulasConfig?.grossInterestCharges) grossProfit -= interestExpenses;

    const indirectIncome = partySundryCreditorsMap[partyIdStr] || 0;

    const profitcs = closingOverride > 0 ? (closingOverride - totalHoldingCost) : 0;
    let netLoss = grossProfit + profitcs;

    let netLossOverrideVal: number;
    if (lossAmt > 0 && !profitAmt) netLossOverrideVal = -lossAmt;
    else if (profitAmt > 0 && !lossAmt) netLossOverrideVal = profitAmt;
    else if (profitAmt > 0 && lossAmt > 0) netLossOverrideVal = profitAmt - lossAmt;
    else netLossOverrideVal = netLoss;

    let netGrossFitOverrideVal = netLossOverrideVal;
    if (netLoss > 0) netLoss -= commissionAmt;

    const reducingBalanceData = calculateReducingInterest(party, withdrawals, interestPercentage * 12, interestDateTo || new Date().toISOString());

    purchases += sales;
    const partyStockRow = partyAggregatedRows.find(r => r.party.id === party.id);
    const withdrawalAmt = partyStockRow?.total_withdrawal_amount || 0;
    const remainingAmount = (Number(party.total_amount) - sharesPurchased - interestExpenses) + indirectIncome + (sales - totalsoldstocksellingpriceindirectcharges) - withdrawalAmt;

    return {
      openingStock: fmt(openingStock),
      CapitalAccount: fmt((openingStock - reducingBalanceData.totalWithdrawal) + reducingBalanceData.accumulatedInterest),
      remainingAmount: fmt(remainingAmount),
      holdingamt: fmt(totalHoldingCost),
      totalWithdrawalAmount: fmt(withdrawalAmt),
      purchases: fmt(purchases),
      sales: fmt(sales),
      closingStock: fmt(sales + netGrossFitOverrideVal),
      grossProfit: fmt(netGrossFitOverrideVal),
      indirectExpenses: fmt(0),
      interestExpenses: fmt(reducingBalanceData.accumulatedInterest + expensesAmt),
      indirectIncome: fmt(indirectIncome),
      netLoss: fmt(netLossOverrideVal),
      salesindirectcharges: fmt(totalsoldstocksellingpriceindirectcharges),
      purchasetosellindirectcharges: fmt(totalsoldstockpurchasingamountindirectcharges),
      leftTotalTrading: fmt(purchases + Math.max(grossProfit, 0)),
      rightTotalTrading: fmt(sales + (closingOverride || totalHoldingCost)),
      leftTotalPL: fmt(openingStock + netLossOverrideVal),
      rightTotalPL: fmt(openingStock + netLossOverrideVal),
      directExpenses: fmt(directExpenses),
      sharesPurchased: fmt(sharesPurchased),
      pnltotalcharges: fmt(0),
      purchaseAccount: fmt(sharesPurchased + directExpenses),
      raw: { openingStock, purchases, sales, closingStock: sales + netGrossFitOverrideVal, grossProfit: netGrossFitOverrideVal, indirectExpenses: 0, indirectIncome, netLoss: netLossOverrideVal }
    };
  }

  function buildBalanceSheetDetailsForParty(party: Party) {

    const parseNumeric = (val: any) => {
      if (typeof val === "string") {
        return Number(val.replace(/,/g, '').replace(/[^0-9.-]+/g,"")) || 0;
      }
      return Number(val) || 0;
    };
    const pnl = buildFinalSheetDataForParty(party);
    const partyStocksRaw = stocks.filter(stk => String(stk.party_id) === String(party.id));
    const openingStock = Number(pnl.raw.openingStock || 0);
    const end = dateTo ? new Date(dateTo) : new Date();
    const months = getMonthDiff(party.date, end);
    const totalInterest = Number(party.total_amount || 0) * (Number(interestPercentage) / 100) * Number(months);
    let indirectcharges = 0;
    for (const stk of partyStocksRaw) {
      const purchaseDate = stk.date_of_purchase || stk.date || '';
      if (!isInDateRange(purchaseDate)) continue;
      const cats = parseCategoriesForDb(stk.categories);
      for (const catObj of cats) indirectcharges += Number(catObj.indirect_charges || 0);
    }
    const sundryCreditors = partySundryCreditorsMap[String(party.id)] || 0;
    const capitalamnt = pnl.CapitalAccount;
    const interestOnCap = pnl.interestExpenses;

    const nestLossNumeric = parseNumeric(pnl.netLoss);
    const interestExpNumeric = parseNumeric(pnl.interestExpenses);

    const  profitAndLoss = nestLossNumeric-interestExpNumeric;


    const numericCapitalAccount = parseNumeric(pnl.CapitalAccount);
    const numericInterestOnCap = parseNumeric(pnl.interestExpenses);

    const beforeInt = numericCapitalAccount - numericInterestOnCap;
    return {
      liabilities: [
        { label: <b>Capital Account</b>, amount: '' },
        {
          label: (
            <span style={{ paddingLeft: 12, paddingRight: 32, display: "inline-block", minWidth: 160 }}>
              Interest On Capital
              <br />
              {party.display_name}
            </span>
       
          ),
          amount: interestOnCap
        },
        {
          label: (
            <span style={{ paddingLeft: 8, paddingRight: 32, display: "inline-block", minWidth: 160 }}>
              {/* empty for alignment */}
            </span>
          ),
          amount: beforeInt
        },
        { label: 'Total Amount', amount: openingStock },
        null,
        { label: <b>Current Liabilities</b>, amount: '' },
        { label: <span style={{ fontSize: '12px' }}>Indirect Charges</span>, amount: indirectcharges },
        null,
        { label: <b>TOTAL</b>, amount: pnl.leftTotalPL },
      ],
      assets: [
        { label: <b>Current Assets</b>, amount: '' },
        { label: 'Sundry Debtors', amount: String(pnl.remainingAmount || 0) },
        null,
        { label: <b>Profit &amp; Loss A/c</b>, amount: '' },
        { label: '', amount: pnl.raw.grossProfit },
        null,
        { label: <b>TOTAL</b>, amount: pnl.leftTotalPL },
      ]
    };
  }

  // ── Filtered table data ────────────────────────────────────────────────────
  const filteredData = React.useMemo(() => {
    let arr = partyAggregatedRows;
    if (partyIdFromUrl) arr = arr.filter(r => String(r.party.id) === String(partyIdFromUrl));
    if (search) arr = arr.filter(r => r.party.name?.toLowerCase().includes(search.toLowerCase()));
    Object.entries(filters).forEach(([key, value]) => {
      if (!value) return;
      if (key === 'party_name') arr = arr.filter(r => r.party.name?.toLowerCase() === String(value).toLowerCase());
    });
    return arr;
  }, [partyAggregatedRows, search, filters, partyIdFromUrl]);

  const totalPage = Math.ceil(filteredData.length / perPage) || 1;
  const pageData = filteredData.slice((page - 1) * perPage, page * perPage);

  // ── CSV export ─────────────────────────────────────────────────────────────
  function handleExportCSV() {
    const hdrs = ['Party Name', 'Contact Person', 'Contact Number', 'Total Purchased', 'Total Used', 'Total Earning'];
    let csv = [hdrs.join(',')];
    pageData.forEach(row => {
      csv.push([row.party.name, row.party.contact_person_name, row.party.contact_person_number, row.total_purchased, row.total_used, row.total_earning]
        .map(v => `"${v !== undefined && v !== null ? String(v).replace(/"/g, '""') : ''}"`).join(','));
    });
    downloadCSV(csv.join('\r\n'), 'party_balance_sheet.csv');
  }

  function handleImportClick() { if (fileInputRef.current) { fileInputRef.current.value = ''; fileInputRef.current.click(); } }

  const handleColumnFilterChange = (colKey: string, val: string | null) => {
    setFilters(f => ({ ...f, [colKey]: val }));
    setPage(1);
    setOpenFilterDropdown(null);
  };

  // ── Print ──────────────────────────────────────────────────────────────────
  const onPrint = (boxid: string) => {
    const box = document.getElementById(boxid);
    if (!box) return;
    document.body.innerHTML = box.innerHTML;
    window.print();
  };

  // ── Modal renderers ────────────────────────────────────────────────────────
  function renderDatePeriodBanner() {
    return (
      <div className="mb-2 text-sm text-[#6742c7] font-medium flex items-center gap-2">
        <span>Showing data for:</span>
        <span className="bg-white px-2 rounded text-[#222]">{formatPeriod(dateFrom, dateTo)}</span>
      </div>
    );
  }

  function renderPnLModalContent(party: Party) {
    const data = buildFinalSheetDataForParty(party);
    const periodLabel = (dateFrom || dateTo)
      ? `${dateFrom ? new Date(dateFrom).toLocaleDateString('en-GB') : ''}${dateFrom && dateTo ? ' to ' : dateTo ? 'to ' : ''}${dateTo ? new Date(dateTo).toLocaleDateString('en-GB') : ''}`
      : 'Select date range';
    const fmt = (n: any) => typeof n === 'number' ? `₹${n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : n || '';
    const renderCell = (children: React.ReactNode, { bold, align = 'left', style = {}, colSpan }: any = {}) => (
      <td style={{ border: '0px solid #333', padding: '7px 8px', fontWeight: bold ? 700 : undefined, textAlign: align, fontSize: 15, ...style }} colSpan={colSpan}>{children}</td>
    );
    function addvalue(a: string, b: string) { return (Number(a?.toString().replace(/,/g, '') || '0')) + (Number(b?.toString().replace(/,/g, '') || '0')); }

    const rows: any[] = [
      ['', '', 'Sales Accounts', fmt(data.sales)],
      ['Purchase Accounts', fmt(data.sharesPurchased), 'Closing Stock', fmt(partyClosingAmounts[String(party.id)])],
      calculationFormulasConfig?.purchaseShare ? [<span style={{ marginLeft: 12 }}>Shares Purchased</span>, fmt(data.sharesPurchased), '', ''] : [],
      calculationFormulasConfig?.purchaseDirect ? [<span style={{ marginLeft: 12 }}>Direct Purchased</span>, fmt(data.directExpenses), '', ''] : [],
      [<span style={{ fontWeight: 600 }}>Gross Profit b/f<p className="text-[8px]">This include indirect expenses</p></span>, fmt(data.netLoss), <span style={{ fontWeight: 600 }}>Gross Profit c/o</span>, <span style={{ fontWeight: 600 }}>{fmt(data.netLoss)}<br />{fmt(addvalue(data.sharesPurchased, data.directExpenses))}</span>],
      [<span style={{ fontWeight: 600 }}>Indirect Expenses</span>, fmt(data.interestExpenses), <span style={{ fontWeight: 600 }}>Indirect Incomes</span>, fmt(data.indirectIncome)],
      calculationFormulasConfig?.indInterestCharges ? [
        <span style={{ paddingLeft: 22, fontSize: '12px' }}>Interest Expenses</span>,
        <span style={{ paddingLeft: 22, fontSize: '12px' }}>{fmt(data.interestExpenses)}</span>,
        (() => { const nv = parseFloat(String(data.netLoss).replace(/,/g, '')) || 0; const iv = parseFloat(String(data.interestExpenses).replace(/,/g, '')) || 0; const r = nv - iv; return <span style={{ fontWeight: 600 }}>{r < 0 ? 'Net Loss: ' : 'Net Profit: '}</span>; })(),
        (() => { const nv = parseFloat(String(data.netLoss).replace(/,/g, '')) || 0; const iv = parseFloat(String(data.interestExpenses).replace(/,/g, '')) || 0; const r = nv - iv; return <span style={{ fontWeight: 600 }}>{fmt(r)}</span>; })(),
        { className: '' }
      ] : [],
    ];

    return (
      <div style={{ background: '#fff', maxWidth: 900, margin: '0 auto', padding: 12 }} id="renderpnl">
        <h2 style={{ fontWeight: 700, color: '#000', textAlign: 'center', fontSize: 19, marginBottom: 0, letterSpacing: 1 }}>{farmForm.name}</h2>
        <div style={{ textAlign: 'center', fontSize: 15, marginBottom: 6 }}>{farmForm.address}</div>
        <div style={{ textAlign: 'center', fontWeight: 700, fontSize: 18, margin: '0 0 2px 0' }}>Profit &amp; Loss A/c</div>
        <div style={{ textAlign: 'center', fontSize: 13, marginBottom: 6 }}>{periodLabel}</div>
        <div style={{ overflowX: 'auto', marginTop: 11 }}>
          <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: 700 }}>
            <thead>
              <tr style={{ border: '1px solid #0000006e', borderLeft: 'none', borderRight: 'none' }}>
                {renderCell('Particulars', { bold: true, align: 'center', style: { background: '#ffff' } })}
                {renderCell(periodLabel, { bold: true, align: 'center', style: { background: '#ffff' } })}
                {renderCell('Particulars', { bold: true, align: 'center', style: { background: '#ffff' } })}
                {renderCell(periodLabel, { bold: true, align: 'center', style: { background: '#ffff' } })}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => {
                if (!row || row.length === 0) return null;
                const trProps = row[4] && typeof row[4] === 'object' ? row[4] : {};
                const trClass = trProps.className || '';
                return (
                  <tr key={i} className={trClass}>
                    {renderCell(row[0], { style: {} })}
                    {renderCell(row[1], { align: 'right', style: { borderRight: '1px solid black' } })}
                    {renderCell(row[2], { style: {} })}
                    {renderCell(row[3], { align: 'right', style: {} })}
                  </tr>
                );
              })}
              <tr style={{ border: '1px solid #0000006e', borderLeft: 'none', borderRight: 'none' }}>
                {renderCell(<span style={{ fontWeight: 700 }}>Total</span>, { align: 'center', style: { background: '#ffff' } })}
                {renderCell(fmt(parseFloat(String(data.netLoss).replace(/,/g, '')) - parseFloat(String(data.interestExpenses).replace(/,/g, ''))), { bold: true, align: 'right', style: { background: '#ffff', borderRight: '1px solid black' } })}
                {renderCell(<span style={{ fontWeight: 700 }}>Total</span>, { align: 'center', style: { background: '#ffff' } })}
                {renderCell(fmt(parseFloat(String(data.netLoss).replace(/,/g, '')) - parseFloat(String(data.interestExpenses).replace(/,/g, ''))), { bold: true, align: 'right', style: { background: '#ffff' } })}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  function renderBalanceSheetModalContent(party: Party) {
    const balance = buildBalanceSheetDetailsForParty(party);
    const headerLabel = dateTo ? `(As at ${new Date(dateTo).toLocaleDateString()})` : 'select date range';
    return (
      <div style={{ background: '#fff' }} id="balancesheet">
        <h2 style={{ fontWeight: 700, color: '#6742c7', textAlign: 'center', fontSize: 22 }}>{farmForm.name}</h2>
        <div style={{ textAlign: 'center', marginBottom: 8 }}>{farmForm.address}</div>
        <h3 style={{ textAlign: 'center', fontWeight: 700, fontSize: 20, margin: '18px 0 0 0' }}>BALANCE SHEET</h3>
        <div style={{ textAlign: 'center', color: '#666', marginBottom: 6 }}>{headerLabel}</div>
        <div style={{ textAlign: 'center', color: '#6742c7', marginBottom: 5, fontWeight: 'bold' }}>Showing data for: {formatPeriod(dateFrom, dateTo)}</div>
        <div style={{ display: 'flex', gap: 20, justifyContent: 'center', alignItems: 'flex-start' }}>
          {[{ title: 'LIABILITIES', items: balance.liabilities }, { title: 'ASSETS', items: balance.assets }].map(({ title, items }) => (
            <div key={title} style={{ flex: 1, minWidth: 320 }}>
              <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 9, color: '#6742c7' }}>{title}</div>
              <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: 14 }}>
                <thead><tr>
                  <th className="border-y border-[#d0d5dd]" style={{ background: '#ffff' }}>Particulars</th>
                  <th className="border-y border-[#d0d5dd]" style={{ background: '#ffff' }}>Amount (₹)</th>
                </tr></thead>
                <tbody>
                  {items.map((item: any, idx: number) =>
                    item === null ? <tr key={idx}><td colSpan={2} style={{ border: 'none', height: '6px' }}></td></tr> : (
                      <tr key={idx}>
                        <td>{item.label}</td>
                        <td style={{ textAlign: 'right', color: Number(item.amount) < 0 ? '#B91C1C' : undefined }}>
                          {item.amount !== '' && item.amount !== undefined
                            ? typeof item.amount === 'string' ? item.amount : Number(item.amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            : ''}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </div>
    );
  }

  function renderQTLYPerformanceModalContent(party: Party) {
    const data = buildFinalSheetDataForParty(party);
    const periods = [...indexPriceHistory].sort((a, b) => (a.date > b.date ? 1 : -1)).map(record => {
      const d = new Date(record.date);
      return { label: `${String(d.getDate()).padStart(2,'0')}.${String(d.getMonth()+1).padStart(2,'0')}.${String(d.getFullYear()).slice(-2)}`, key: record.date, sensex: record.sensexPrice || '---' };
    });
    const fmt = (n: any, isPercent = false) => n == null ? '0.00' : isPercent ? (typeof n === 'number' ? n.toFixed(2) : n) + '%' : typeof n === 'number' ? n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : n;
    const purchases = Number(data?.raw?.purchases ?? 0);
    const grossProfit = Number(data?.raw?.grossProfit ?? 0);
    const grossProfitPercent = purchases > 0 ? (grossProfit / purchases) * 100 : 0;
    const rows2 = [
      { label: 'GROSS PROFIT (%)', values: periods.map(() => grossProfitPercent), isPercent: true },
      { label: 'Less: interest charged by us', values: periods.map(() => -interestPercentage), isPercent: true },
      { label: `Our net profit After ${interestPercentage}% interest`, values: periods.map(() => grossProfitPercent - interestPercentage), isPercent: true },
    ];
    return (
      <div style={{ background: '#fff', maxWidth: 1200, margin: '0 auto', padding: 24 }} id="qtlydata">
        <div style={{ fontWeight: 700, fontSize: 16, textAlign: 'center', marginBottom: 15, letterSpacing: 2, textTransform: 'uppercase' }}>
          AS ON {periods.length > 0 ? periods[periods.length - 1].label : '---'} (QTY/ PRINCIPAL/%)
        </div>
        <div style={{ border: '1px solid #222', marginBottom: 24, borderRadius: 6, background: '#f9f9ff', overflow: 'hidden' }}>
          <div style={{ fontWeight: 700, fontSize: 18, padding: '10px 12px', background: '#efeefe', borderBottom: '1.5px solid #d1cdf4', color: '#6742c7' }}>{farmForm.name}</div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
              <thead>
                <tr>
                  <th style={{ minWidth: 350, background: '#f2f2f2', border: '1px solid #aaa', textAlign: 'left', padding: '12px', fontSize: 14 }}>
                    {`${party.name.toUpperCase()} START FROM ${new Date(party.date).toLocaleDateString('en-GB')} (Total Capital ${Number(party.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })})`}
                  </th>
                  {periods.map(p => (
                    <th key={p.key} style={{ minWidth: 160, background: '#e9e6fd', border: '1px solid #aaa', textAlign: 'center', padding: '8px 5px' }}>
                      <div style={{ fontSize: '13px', fontWeight: 700 }}>{p.label}</div>
                      <div style={{ fontSize: '11px', fontWeight: 400, color: '#555', marginTop: '2px' }}>(Sensex {p.sensex})</div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows2.map((row, ri) => (
                  <tr key={ri}>
                    <td style={{ padding: '10px 12px', background: '#fff', border: '1px solid #aaa', fontWeight: 600, fontSize: 14, color: '#444' }}>{row.label}</td>
                    {row.values.map((v, vi) => (
                      <td key={vi} style={{ textAlign: 'right', padding: '8px 10px', fontSize: 13, background: vi % 2 === 1 ? '#f6f6fb' : '#fff', border: '1px solid #ccc' }}>{fmt(v, row.isPercent)}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  function renderGlobalQTLYContent(partiesList: Party[]) {
    const periods = [...indexPriceHistory].sort((a, b) => (a.date > b.date ? 1 : -1)).map(record => {
      const d = new Date(record.date);
      return { label: `${String(d.getDate()).padStart(2,'0')}.${String(d.getMonth()+1).padStart(2,'0')}.${String(d.getFullYear()).slice(-2)}`, key: record.date, sensex: record.sensexPrice || '---' };
    });
    const fmt = (n: any, isPercent = false) => n == null ? '0.00' : isPercent ? (typeof n === 'number' ? n.toFixed(2) : n) + '%' : typeof n === 'number' ? n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : n;
    return (
      <div style={{ background: '#fff', maxWidth: 1200, margin: '0 auto', padding: 24 }}>
        <div style={{ fontWeight: 700, fontSize: 16, textAlign: 'center', marginBottom: 15, letterSpacing: 2, textTransform: 'uppercase' }}>
          AS ON {periods.length > 0 ? periods[periods.length - 1].label : '---'} (QTY/ PRINCIPAL/%)
        </div>
        {partiesList.map(party => {
          const data = buildFinalSheetDataForParty(party);
          const purchases = Number(data?.raw?.purchases ?? 0);
          const grossProfit = Number(data?.raw?.grossProfit ?? 0);
          const gpPercent = purchases > 0 ? (grossProfit / purchases) * 100 : 0;
          const rows2 = [
            { label: 'GROSS PROFIT (%)', values: periods.map(() => gpPercent), isPercent: true },
            { label: 'Less: interest charged by us', values: periods.map(() => -interestPercentage), isPercent: true },
            { label: `Our net profit After ${interestPercentage}% interest`, values: periods.map(() => gpPercent - interestPercentage), isPercent: true },
          ];
          return (
            <div key={party.id} style={{ border: '1px solid #222', marginBottom: 24, borderRadius: 6, background: '#f9f9ff', overflow: 'hidden' }}>
              <div style={{ fontWeight: 700, fontSize: 18, padding: '10px 12px', background: '#efeefe', borderBottom: '1.5px solid #d1cdf4', color: '#6742c7' }}>{farmForm.name}</div>
              <div style={{ overflowX: 'auto' }}>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                  <thead>
                    <tr>
                      <th style={{ minWidth: 350, background: '#f2f2f2', border: '1px solid #aaa', textAlign: 'left', padding: '12px', fontSize: 14 }}>
                        {`${party.name.toUpperCase()} FROM ${new Date(party.date).toLocaleDateString('en-GB')} (Capital ${fmt(Number(party.total_amount))})`}
                      </th>
                      {periods.map(p => (
                        <th key={p.key} style={{ minWidth: 160, background: '#e9e6fd', border: '1px solid #aaa', textAlign: 'center', padding: '8px 5px' }}>
                          <div style={{ fontSize: '13px', fontWeight: 700 }}>{p.label}</div>
                          <div style={{ fontSize: '11px', color: '#555' }}>(Sensex {p.sensex})</div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {rows2.map((row, ri) => (
                      <tr key={ri}>
                        <td style={{ padding: '10px 12px', background: '#fff', border: '1px solid #aaa', fontWeight: 600, fontSize: 14, color: '#444' }}>{row.label}</td>
                        {row.values.map((v, vi) => (
                          <td key={vi} style={{ textAlign: 'right', padding: '8px 10px', fontSize: 13, background: vi % 2 === 1 ? '#f6f6fb' : '#fff', border: '1px solid #ccc' }}>{fmt(v, row.isPercent)}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  // ── Party Modal ────────────────────────────────────────────────────────────
  useEffect(() => {
    if (!showPartyModal) return;
    const handler = (e: KeyboardEvent) => { if (e.key === 'Escape') setShowPartyModal(false); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [showPartyModal]);

  const renderPartyModal = () => {
    if (!selectedParty) return null;
    const row = partyAggregatedRows.find(r => r.party.id === selectedParty.id);
    if (!row) return null;
    return (
      <div className="fixed top-0 left-0 right-0 bottom-0 z-40 bg-black/40 flex items-center justify-center">
        <div className="bg-white rounded-xl shadow-lg p-6 min-w-[350px] w-[96vw] max-w-5xl relative max-h-[90vh] overflow-auto">
          <button className="absolute top-3 right-4 text-2xl text-gray-400 hover:text-gray-600" onClick={() => setShowPartyModal(false)} title="Close">&times;</button>
          <h2 className="text-2xl font-bold mb-2 text-[#6742c7]">{row.party.name}</h2>
          {renderDatePeriodBanner()}
          <div className="mb-4 flex flex-wrap gap-2">
            {(['overall', 'final', 'balance', 'QTLY Performance'] as ModalSheetView[]).map(tab => (
              <button key={tab}
                className={`px-3 py-1 rounded font-semibold border text-sm ${partyModalSheet === tab ? 'bg-[#6742c7] text-white border-[#6742c7]' : 'bg-white text-[#6742c7] border-[#6742c7] hover:bg-[#F3F0FD]'}`}
                onClick={() => setPartyModalSheet(tab)}
              >
                {tab === 'final' ? 'Final (P&L)' : tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>

          {partyModalSheet === 'overall' && (
            <>
              <div className="mb-6 grid gap-4 md:grid-cols-3">
                <div className="bg-white rounded-2xl shadow border-l-4 border-[#7964e7] px-5 py-4">
                  <div className="font-medium text-[#7964e7] uppercase text-xs mb-2 tracking-widest">Contact</div>
                  <span className="block text-gray-700 font-semibold">{row.party.contact_person_name || '-'}</span>
                  <span className="block text-gray-500">{row.party.contact_person_number || '-'}</span>
                </div>
                <div className="bg-white rounded-2xl shadow border-l-4 border-[#41c6c4] px-5 py-4">
                  <div className="font-medium text-[#41c6c4] uppercase text-xs mb-2 tracking-widest">Opening Balance</div>
                  <div className="text-xl font-extrabold">
                    {row.party.total_amount !== undefined ? `₹${Number(row.party.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : '-'}
                  </div>
                </div>
                <div className="bg-white rounded-2xl shadow border-l-4 border-[#ffa629] px-5 py-4">
                  <div className="font-medium text-[#ffa629] uppercase text-xs mb-2 tracking-widest">Summary</div>
                  <div className="flex justify-between"><span className="text-gray-600">Purchased</span><span className="font-bold">{typeof row.total_purchased === 'number' ? `₹${row.total_purchased.toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : row.total_purchased}</span></div>
                  <div className="flex justify-between pt-2 border-t mt-2"><span className="text-gray-600">Total Sold</span><span className="font-bold">{row.total_sales_amount !== undefined ? `₹${Number(row.total_sales_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : '-'}</span></div>
                  <div className="flex justify-between"><span className="text-gray-600">Units Sold</span><span className="font-bold">{row.total_sales_units ?? '-'}</span></div>
                </div>
              </div>

              {/* Withdrawals */}
              {row.withdrawals_details && row.withdrawals_details.length > 0 && (
                <div className="mb-6">
                  <h3 className="font-bold text-[#e65a23] text-lg mb-3">Withdrawals</h3>
                  <div className="overflow-x-auto border border-orange-100 rounded-2xl">
                    <table className="w-full text-sm">
                      <thead className="bg-orange-50"><tr>
                        <th className="px-3 py-2 text-left text-[#e76a28]">Date</th>
                        <th className="px-3 py-2 text-right text-[#e76a28]">Amount</th>
                        <th className="px-3 py-2 text-left text-[#e76a28]">Category</th>
                        <th className="px-3 py-2 text-left text-[#e76a28]">Stock</th>
                      </tr></thead>
                      <tbody>
                        {row.withdrawals_details.map((wd: any) => {
                          let cats: any[] = [];
                          if (wd.catrgories) { try { const a = JSON.parse(wd.catrgories); if (Array.isArray(a) && typeof a[0] === 'string') { cats = JSON.parse(a[0]); if (!Array.isArray(cats)) cats = [cats]; } } catch { } }
                          return (
                            <tr key={wd.id} className="border-t">
                              <td className="px-3 py-2">{wd.date ? new Date(wd.date).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' }) : '-'}</td>
                              <td className="px-3 py-2 text-right font-bold text-[#dd661a]">{wd.amount ? `₹${Number(wd.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : '-'}</td>
                              <td className="px-3 py-2">{cats.map((c: any) => c.category).join(', ') || '-'}</td>
                              <td className="px-3 py-2">{cats.map((c: any) => c.stockName).join(', ') || '-'}</td>
                            </tr>
                          );
                        })}
                        <tr className="bg-orange-50 font-bold">
                          <td className="px-3 py-2" colSpan={1}>Total</td>
                          <td className="px-3 py-2 text-right text-[#e65a23]">{`₹${row.withdrawals_details.reduce((s: number, w: any) => s + (parseFloat(String(w.amount)) || 0), 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}</td>
                          <td colSpan={2}></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Stocks */}
              <h3 className="font-bold text-[#6742c7] text-lg mb-3">Stocks</h3>
              <div className="overflow-x-auto max-h-[350px]">
                {row.stocks.map((s: any, i: number) => (
                  <div key={i} className="mb-6 border border-[#f1ecff] rounded-xl overflow-hidden">
                    <div className="bg-[#6742c7] px-5 py-3"><span className="font-bold text-white text-base">{s.stock_name}</span></div>
                    <table className="w-full text-[13px]">
                      <thead className="bg-[#ece6fa]"><tr>
                        {['Category', 'Unit', 'Purchase Date', 'Purchase Amt', 'Indirect Charges', 'History'].map(h => <th key={h} className="p-2 text-center text-[#6742c7] font-semibold">{h}</th>)}
                      </tr></thead>
                      <tbody>
                        {s.records.map((rec: any, ridx: number) => (
                          <tr key={ridx} className="border-t text-center">
                            <td className="p-2">{rec.category}</td>
                            <td className="p-2">{rec.unit}</td>
                            <td className="p-2">{rec.date_of_purchase ? new Date(rec.date_of_purchase).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' }) : '-'}</td>
                            <td className="p-2">{`₹${Number(rec.opening_balance).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}</td>
                            <td className="p-2">{`₹${Number(rec.indirect_charges).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}</td>
                            <td className="p-2">
                              {rec.update_history.length === 0 ? <span className="text-gray-400 italic">No updates</span> : (
                                <table className="w-full text-[11px] border">
                                  <thead className="bg-[#f8f6ff]"><tr>{['Date', 'Amount', 'Ind. Income', 'P/L'].map(h => <th key={h} className="px-1 py-1 border-b">{h}</th>)}</tr></thead>
                                  <tbody>
                                    {rec.update_history.slice(0, 3).map((up: any, ui: number) => (
                                      <tr key={ui} className="text-center">
                                        <td className="px-1 py-1">{up.date ? new Date(up.date).toLocaleDateString('en-IN', { month: 'short', day: 'numeric' }) : '-'}</td>
                                        <td className="px-1 py-1">{`₹${Number(up.current_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}</td>
                                        <td className="px-1 py-1">{up.dividend ? `₹${Number(up.dividend).toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : '-'}</td>
                                        <td className={`px-1 py-1 font-semibold ${up.profitAndLoss >= 0 ? 'text-green-600' : 'text-red-500'}`}>{`₹${Number(up.profitAndLoss).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>
            </>
          )}

          {partyModalSheet === 'final' && (
            <>
              {renderPnLModalContent(row.party)}
              <div className="flex justify-end mt-4">
                <button className="px-4 py-2 text-sm bg-[#6742c7] text-white font-bold rounded hover:bg-[#442293]" onClick={() => onPrint('renderpnl')}>Print/Download</button>
              </div>
            </>
          )}

          {partyModalSheet === 'QTLY Performance' && (
            <>
              {renderQTLYPerformanceModalContent(row.party)}
              <div className="flex justify-end mt-4">
                <button className="px-4 py-2 text-sm bg-[#6742c7] text-white font-bold rounded hover:bg-[#442293]" onClick={() => onPrint('qtlydata')}>Print/Download</button>
              </div>
            </>
          )}

          {partyModalSheet === 'balance' && (
            <>
              {renderBalanceSheetModalContent(row.party)}
              <div className="flex justify-end mt-4">
                <button className="px-4 py-2 text-sm bg-[#6742c7] text-white font-bold rounded hover:bg-[#442293]" onClick={() => onPrint('balancesheet')}>Print/Download</button>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  // ── Entry Modal handler ────────────────────────────────────────────────────
  const openEntryModal = (type: FinancialEntry['record_type'], partyId: string) => {
    setEntryModal({ isOpen: true, type: type as any, partyId });
  };

  const getPartyStocksFlat = (partyId: string): StockCategoryObj[] =>
    stocks.filter(s => String(s.party_id) === String(partyId)).flatMap(s => parseCategoriesForDb(s.categories));

  const getExistingRecords = (partyId: string, type: FinancialEntry['record_type']): FinancialEntry[] =>
    financialRecords.filter(r => String(r.party_id) === String(partyId) && r.record_type === type);

  // ── Filter panel ───────────────────────────────────────────────────────────
  const renderFilterPanel = () => showFilterPanel && (
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/30 z-30 flex items-center justify-center" onClick={() => setShowFilterPanel(false)}>
      <div className="bg-white rounded-lg shadow-lg p-6 w-[95vw] max-w-2xl max-h-[90vh] overflow-y-auto relative" onClick={e => e.stopPropagation()}>
        <button className="absolute top-3 right-4 text-xl text-gray-500" onClick={() => setShowFilterPanel(false)}>&times;</button>
        <h3 className="text-xl font-semibold mb-4 flex items-center gap-2"><FaFilter className="text-[#6742c7]" /> Filters</h3>
        <div className="space-y-4">
          <div>
            <div className="text-xs font-semibold text-gray-600 mb-1">Party Name</div>
            <div className="flex gap-2 flex-wrap">
              <button className={`px-3 py-1 rounded border text-xs ${!filters.party_name ? 'bg-[#6742c7] text-white' : 'bg-gray-100 text-gray-700'}`} onClick={() => handleColumnFilterChange('party_name', null)}>All</button>
              {(uniqueColumnValues.party_name || []).sort().map(opt => (
                <button key={opt} className={`px-3 py-1 rounded border text-xs ${filters.party_name === opt ? 'bg-[#6742c7] text-white' : 'bg-gray-100 text-gray-700'}`} onClick={() => handleColumnFilterChange('party_name', opt)}>{opt}</button>
              ))}
            </div>
          </div>
          <div>
            <label className="text-xs font-semibold text-gray-600 block mb-1">Date Range</label>
            <div className="flex gap-2 items-center">
              <input type="date" className="border px-2 py-1 rounded text-xs" value={dateFrom} onChange={e => { setDateFrom(e.target.value); setPage(1); }} style={{ width: 130 }} />
              <span className="text-gray-500">to</span>
              <input type="date" className="border px-2 py-1 rounded text-xs" value={dateTo} onChange={e => { setDateTo(e.target.value); setPage(1); }} style={{ width: 130 }} />
            </div>
            {(dateFrom || dateTo) && <button className="mt-1 px-2 py-0 text-xs text-gray-500 hover:text-[#6742c7]" onClick={() => { setDateFrom(''); setDateTo(''); setPage(1); }}>Clear Date</button>}
          </div>
        </div>
      </div>
    </div>
  );

  // ── Financial Records Table (per party, in the main list row) ─────────────
  const FinancialSummaryBadges = ({ partyId }: { partyId: string }) => {
    const types: Array<{ type: FinancialEntry['record_type'], label: string, color: string }> = [
      { type: 'Closing', label: 'Closing', color: '#6742c7' },
      { type: 'Loss', label: 'Loss', color: '#BF3636' },
      { type: 'Profit', label: 'Profit', color: '#37762A' },
      { type: 'Sale', label: 'Sale', color: '#ae793c' },
      { type: 'Commission', label: 'Commission', color: '#6842c7' },
      { type: 'Expenses', label: 'Expenses', color: '#ae793c' },
    ];
    return (
      <div className="flex flex-wrap gap-1 mt-2">
        {types.map(({ type, label, color }) => {
          const recs = getFilteredRecords(partyId, type, dateFrom, dateTo);
          const total = sumRecords(recs);
          return (
            <button
              key={type}
              onClick={() => openEntryModal(type, partyId)}
              className="flex items-center gap-1 px-2 py-1 rounded-lg text-[11px] font-semibold border transition hover:opacity-80"
              style={{ borderColor: color, color, background: `${color}11` }}
              title={`${label}: ₹${total.toLocaleString('en-IN', { minimumFractionDigits: 2 })} — click to edit`}
            >
              {label}
              {total > 0 && <span className="font-bold">₹{total.toLocaleString('en-IN', { minimumFractionDigits: 0 })}</span>}
              {recs.length === 0 && <span className="text-gray-400">+</span>}
            </button>
          );
        })}
      </div>
    );
  };

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <div className="p-6 min-h-screen" style={{ background: 'linear-gradient(120deg,rgb(255, 255, 255) 0%,rgb(248, 255, 253) 100%)' }}>
      {renderFilterPanel()}
      {showPartyModal && renderPartyModal()}

      {/* Entry modals */}
      {entryModal.isOpen && entryModal.type !== 'Sale' && (
        <MultiEntryForm
          type={entryModal.type as any}
          partyId={entryModal.partyId}
          partyName={parties.find(p => String(p.id) === entryModal.partyId)?.name || ''}
          existingRecords={getExistingRecords(entryModal.partyId, entryModal.type)}
          onClose={() => setEntryModal(e => ({ ...e, isOpen: false }))}
          onSaved={loadFinancialRecords}
        />
      )}
      {entryModal.isOpen && entryModal.type === 'Sale' && (
        <SaleEntryForm
          partyId={entryModal.partyId}
          partyName={parties.find(p => String(p.id) === entryModal.partyId)?.name || ''}
          partyStocks={getPartyStocksFlat(entryModal.partyId)}
          existingRecords={getExistingRecords(entryModal.partyId, 'Sale')}
          onClose={() => setEntryModal(e => ({ ...e, isOpen: false }))}
          onSaved={loadFinancialRecords}
        />
      )}

      {/* Global QTLY modal */}
      {globalQTLY && (
        <div className="fixed inset-0 z-50 bg-[#09141311] flex items-center justify-center">
          <div className="relative bg-white rounded-xl shadow-lg p-6 w-[96vw] max-w-5xl max-h-[90vh] overflow-auto border-2 border-[#408A71]">
            <button className="absolute top-3 right-4 text-2xl text-[#285A48]" onClick={() => setGlobalQtly(false)}>&times;</button>
            {renderGlobalQTLYContent(parties)}
          </div>
        </div>
      )}

      {/* Header */}
      <div className="w-full mb-5 flex flex-wrap justify-between items-center gap-3">
        <div className="flex items-center gap-3">
          <h1 className="text-[26px] font-extrabold text-[#091413]">
            <span style={{ color: '#285A48' }}>Party</span>{' '}<span style={{ color: '#408A71' }}>Balance Sheet</span>
          </h1>
          <div className="bg-[#b0e4cc] px-3 py-1 rounded-full border border-[#285A48] text-[#091413] text-[12px] font-bold">{parties.length} parties</div>
        </div>
        <div className="flex flex-wrap gap-2 items-center">
          <button
            className="px-3 py-1.5 rounded-xl font-semibold border text-sm shadow bg-[#b0e4cc] text-[#091413] hover:bg-[#408A71] hover:text-white border-[#285A48]"
            onClick={() => setGlobalQtly(true)}
          >QTLY Performance</button>
          <button className="flex items-center gap-1 border border-[#408A71] bg-[#B0E4CC] py-2 px-4 rounded-lg text-[#285A48] font-semibold shadow hover:bg-[#285a48] hover:text-white transition" onClick={() => setShowFilterPanel(true)}>
            <FaFilter /> Filter
          </button>
          <button className="flex items-center gap-1 border border-[#B0E4CC] bg-[#B0E4CC] py-2 px-4 rounded-lg text-[#091413] font-semibold shadow hover:bg-[#408A71] hover:text-white transition" onClick={handleImportClick}>
            <BiImport /> Import
          </button>
          <input ref={fileInputRef} type="file" accept=".csv" style={{ display: 'none' }} />
          <button className="flex items-center gap-1 border-[1.5px] border-[#408A71] bg-[#fff] py-2 px-4 rounded-lg text-[#408A71] font-bold shadow hover:bg-[#B0E4CC] transition" onClick={handleExportCSV}>
            Export CSV
          </button>
        </div>
      </div>

      {renderDatePeriodBanner()}

      {/* Search + Interest date */}
      <div className="flex flex-wrap justify-between items-center gap-3 mt-3 mb-4">
        <div className="bg-[#e5f9f2] h-[42px] flex items-center rounded-lg px-3 border-2 border-[#B0E4CC] gap-2 shadow min-w-[260px] flex-1 max-w-sm">
          <CiSearch className="text-[#091413] text-[22px]" />
          <input type="text" placeholder="Search party name..." className="w-full bg-transparent h-[34px] focus:outline-none text-[#091413] placeholder:text-[#285A48] font-medium"
            value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} />
        </div>
        <div className="flex items-center gap-2 bg-[#f0f4ff] p-2 rounded-md border border-[#d0d9f5] shadow-sm">
          <label className="text-[11px] font-semibold text-[#4c66a4] uppercase">Interest To:</label>
          <input type="date" className="border rounded px-2 py-[4px] text-xs focus:ring-1 focus:ring-[#4c66a4] outline-none bg-white"
            value={interestDateTo} onChange={e => setInterestDateTo(e.target.value)} />
          <button className="px-2 py-[4px] bg-white text-[#4c66a4] border border-[#b5c5e3] rounded text-[10px] font-bold hover:bg-[#e3ecfb] transition" onClick={() => setInterestDateTo('')}>Reset</button>
        </div>
      </div>

      {/* Table */}
      <div className="max-w-full overflow-x-auto border-2 border-[#B0E4CC] bg-[#ffffffcc] rounded-2xl shadow-xl">
        <table className="w-full border-collapse table-auto rounded-2xl overflow-hidden">
          <thead className="bg-gradient-to-r from-[#f7fffb] via-[#b0e4cc55] to-[#e5f9f2]">
            <tr>
              {[
                { key: 'party_name', label: 'Party Name' },
                { key: 'contact', label: 'Contact Person' },
                { key: 'number', label: 'Contact Number' },
                { key: 'total', label: 'Total Amount' },
                { key: 'purchased', label: 'Total Purchased', align: 'right' },
                { key: 'actions', label: 'Actions' },
              ].map(col => (
                <th key={col.key} className="px-3 py-3 text-left text-[14px] font-bold text-[#285A48] border-b border-[#b0e4cc] whitespace-nowrap">
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {pageData.length === 0 ? (
              <tr><td colSpan={6} className="text-center py-8 text-[#B0B0B0] font-bold">No data found.</td></tr>
            ) : (
              pageData.map(row => (
                <tr key={row.party.id} className="hover:bg-[#b0e4cc22] transition align-top">
                  <td className="px-3 py-3 text-sm font-semibold text-[#091413] border-b border-[#b0e4cc] whitespace-nowrap">{row.party.name}</td>
                  <td className="px-3 py-3 text-sm text-[#285A48] border-b border-[#b0e4cc] whitespace-nowrap">{row.party.contact_person_name}</td>
                  <td className="px-3 py-3 text-sm text-[#285A48] border-b border-[#b0e4cc] whitespace-nowrap">{row.party.contact_person_number}</td>
                  <td className="px-3 py-3 text-sm font-semibold text-[#408A71] border-b border-[#b0e4cc] whitespace-nowrap">
                    {row.party.total_amount !== undefined ? `₹${Number(row.party.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : '-'}
                  </td>
                  <td className="px-3 py-3 text-sm font-bold text-[#285A48] border-b border-[#b0e4cc] whitespace-nowrap text-right">
                    {typeof row.total_purchased === 'number' ? `₹${row.total_purchased.toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : row.total_purchased}
                  </td>
                  <td className="px-3 py-3 border-b border-[#b0e4cc] flex items-center gap-2">
                    <div className="flex items-center gap-2 ">
                      <button
                        onClick={() => { setSelectedParty(row.party); setShowPartyModal(true); setPartyModalSheet('overall'); }}
                        className="mt-2 flex items-center gap-1 text-white text-[13px] px-3 py-[3px] rounded-lg border border-[#285A48] bg-[#408A71] font-bold shadow hover:bg-[#285A48] transition"
                      >
                        <FaEye /> View
                      </button>
                    </div>
                    {/* Financial record badges — click to open edit modal */}
                    <FinancialSummaryBadges partyId={String(row.party.id)} />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex items-center justify-between mt-5 bg-[#b0e4cc1a] px-5 py-3 rounded-xl shadow-inner">
        <span className="text-[#091413] text-[14px] font-bold">Page {page} of {totalPage}</span>
        <div className="flex gap-3">
          <button disabled={page === 1} onClick={() => setPage(p => p - 1)}
            className={`px-4 py-2 rounded-xl border-2 border-[#285A48] font-bold bg-white text-[#285A48] shadow transition ${page === 1 ? 'opacity-40 cursor-not-allowed' : 'hover:bg-[#408A71] hover:text-white'}`}>Previous</button>
          <button disabled={page === totalPage || filteredData.length === 0} onClick={() => setPage(p => p + 1)}
            className={`px-4 py-2 rounded-xl border-2 border-[#285A48] font-bold bg-white text-[#285A48] shadow transition ${(page === totalPage || filteredData.length === 0) ? 'opacity-40 cursor-not-allowed' : 'hover:bg-[#408A71] hover:text-white'}`}>Next</button>
        </div>
      </div>
    </div>
  );
}

export default CustomBalance;